import type { ServiceAreaSlug } from "@/config/service-areas";

export type ServiceSlug =
  | "roof-replacement"
  | "roof-repair"
  | "asphalt-shingle-roofing"
  | "metal-roofing"
  | "flat-roofing"
  | "roof-inspection-maintenance"
  | "flashing-roof-penetration-repair"
  | "shingle-spot-repair"
  | "gutter-cleaning-downspout-flush"
  | "storm-tarping-emergency-dry-in"
  | "skylight-leak-flashing-repair"
  | "chimney-flashing-repair"
  | "gutter-replacement"
  | "gutter-guard-installation"
  | "roof-ventilation-upgrade"
  | "fascia-soffit-repair-replacement"
  | "cedar-shake-repair-restoration"
  | "flat-low-slope-roof-repair"
  | "metal-roof-repair-maintenance"
  | "cedar-shake-roof-replacement"
  | "moss-removal-roof-gutter"
  | "roof-health-check-maintenance";

export type ServiceContentTranslation = {
  title: string;
  shortTitle: string;
  eyebrow: string;
  description: string;
  definition: string;
  forWhom: string;
  warningSigns: string[];
  evaluates: string[];
  causes: string[];
  methodology: string[];
  materials: string[];
  bcClimate: string;
  whenAppropriate: string;
  whenOtherService: string;
  process: string[];
  solutionCategories: { title: string; body: string }[];
  repairVsReplace: { repair: string; replace: string };
  scopeFactors: string[];
  faqs: { question: string; answer: string }[];
  publicPriceHint: string;
};

export type ServiceAreaContentTranslation = {
  intro: string;
  localContext: string;
  assessmentFocus: readonly string[];
  propertyContexts: readonly string[];
  faqs: readonly { question: string; answer: string }[];
};

export const services = {
  "roof-replacement": {
    title: "ਆਰਕੀਟੈਕਚਰਲ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਬਦਲਣਾ",
    shortTitle: "ਅਸਫਾਲਟ ਬਦਲਣਾ",
    eyebrow: "ਢਲਾਣ ਵਾਲੀ ਰੀਰੂਫ",
    description:
      "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਦੇ ਢਲਾਣ ਵਾਲੇ ਘਰਾਂ ਲਈ ਪੂਰੀ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਟੀਅਰ-ਆਫ, ਅੰਡਰਲੇਮੈਂਟ, ਸ਼ਿੰਗਲ, ਫਲੈਸ਼ਿੰਗ ਏਕੀਕਰਣ ਅਤੇ ਨਿਪਟਾਰਾ।",
    definition:
      "ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਬਦਲਣਾ ਇੱਕ ਪੂਰੀ ਢਲਾਣ ਵਾਲੀ ਰੀਰੂਫ ਹੈ ਜੋ ਮੌਜੂਦਾ ਸ਼ਿੰਗਲ ਢੱਕਣ ਹਟਾਉਂਦੀ ਹੈ, ਸਬਸਟਰੇਟ ਅਤੇ ਅੰਡਰਲੇਮੈਂਟ ਦੀਆਂ ਲੋੜਾਂ ਨੂੰ ਸੰਬੋਧਿਤ ਕਰਦੀ ਹੈ, ਨਵੀਂ ਸ਼ਿੰਗਲ ਪ੍ਰਣਾਲੀ ਸਥਾਪਿਤ ਕਰਦੀ ਹੈ ਅਤੇ ਫਲੈਸ਼ਿੰਗਾਂ ਅਤੇ ਪ੍ਰਵੇਸ਼ਾਂ ਨੂੰ ਦੁਬਾਰਾ ਏਕੀਕ੍ਰਿਤ ਕਰਦੀ ਹੈ।",
    forWhom:
      "ਉਹ ਘਰ ਦੇ ਮਾਲਕ ਜਿਨ੍ਹਾਂ ਦੀਆਂ ਸ਼ਿੰਗਲਜ਼ ਵਿਆਪਕ ਤੌਰ 'ਤੇ ਘਿਸੀਆਂ ਹੋਈਆਂ ਹਨ, ਵਾਰ-ਵਾਰ ਮੁਰੰਮਤ ਕੀਤੀਆਂ ਗਈਆਂ ਹਨ, ਜਾਂ ਹੋਰ ਨਹੀਂ ਰਹਿੰਦੀਆਂ ਜੋ ਘਰ ਦੀ ਬਾਕੀ ਸੇਵਾ ਯੋਜਨਾ ਲਈ ਟਿਕਾਊ ਮੇਲ ਖਾਂਦੀਆਂ ਹਨ।",
    warningSigns: [
      "ਕਰਲਿੰਗ, ਕਰੈਕਿੰਗ ਜਾਂ ਵਿਆਪਕ ਗ੍ਰੈਨਿਊਲ ਨੁਕਸਾਨ",
      "ਕਈ ਮੁਰੰਮਤ ਕੀਤੇ ਜਹਾਜ਼ ਅਜੇ ਵੀ ਫੇਲ੍ਹ ਹੋ ਰਹੇ ਹਨ",
      "ਭੁਰਭੁਰੀਆਂ ਸ਼ਿੰਗਲਜ਼ ਜੋ ਹੁਣ ਦੁਬਾਰਾ ਸੀਲ ਨਹੀਂ ਕਰਦੀਆਂ",
      "ਬੁਢਾਪੇ ਵਾਲੀਆਂ ਵਾਦੀਆਂ, ਰਿੱਜ ਅਤੇ ਈਵਜ਼",
      "ਮੁਰੰਮਤ ਕੰਮ ਜੋ ਪੂਰੀ ਰੀਰੂਫ ਨੂੰ ਸੁਚੱਜਾ ਬਣਾਉਂਦਾ ਹੈ",
    ],
    evaluates: [
      "ਮੌਜੂਦਾ ਪਰਤ ਗਿਣਤੀ ਅਤੇ ਡੈੱਕ ਦੀ ਸਥਿਤੀ",
      "ਢਲਾਨ, ਵਾਦੀਆਂ, ਡੋਰਮਰ ਅਤੇ ਜਿਓਮੈਟਰੀ",
      "ਹਵਾਦਾਰੀ ਅਤੇ ਚੁਬਾਰੇ ਦੀ ਨਮੀ ਦੇ ਸਬੂਤ",
      "ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਪ੍ਰਵੇਸ਼ ਇਨਵੈਂਟਰੀ",
      "ਪਹੁੰਚ, ਸੁਰੱਖਿਆ ਅਤੇ ਨਿਪਟਾਰਾ",
    ],
    causes: [
      "ਸਧਾਰਨ ਜੀਵਨ-ਅੰਤ ਮੌਸਮੀ ਘਿਸਾਈ",
      "ਲਗਾਤਾਰ ਮੌਸ ਅਤੇ ਨਮੀ",
      "ਜਮ੍ਹਾ ਹੋਈ ਹਵਾ ਨੁਕਸਾਨ",
      "ਕਮਜ਼ੋਰ ਹਵਾਦਾਰੀ ਨਾਲ ਤੇਜ਼ ਬੁਢਾਪਾ",
      "ਕਮਜ਼ੋਰ ਵੇਰਵੇ ਵਾਲੀਆਂ ਪਿਛਲੀਆਂ ਸਥਾਪਨਾਵਾਂ",
    ],
    methodology: [
      "ਸਥਿਤੀਆਂ ਅਤੇ ਵਿਕਲਪਾਂ ਦਾ ਦਸਤਾਵੇਜ਼",
      "ਟੀਅਰ-ਆਫ, ਸੁਰੱਖਿਆ ਅਤੇ ਨਿਪਟਾਰੇ ਦੀ ਯੋਜਨਾ",
      "ਖੋਜੇ ਜਾਣ 'ਤੇ ਡੈੱਕ ਦੀ ਮੁਰੰਮਤ",
      "ਕ੍ਰਮ ਵਿੱਚ ਅੰਡਰਲੇਮੈਂਟ, ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਫੀਲਡ ਸ਼ਿੰਗਲ ਸਥਾਪਿਤ ਕਰੋ",
      "ਰਿੱਜ, ਵਾਦੀਆਂ, ਕਿਨਾਰੇ ਅਤੇ ਪ੍ਰਵੇਸ਼ਾਂ ਨੂੰ ਪੂਰੀ ਅਸੈਂਬਲੀ ਵਜੋਂ ਵਿਸਤਾਰ ਦਿਓ",
    ],
    materials: [
      "ਆਰਕੀਟੈਕਚਰਲ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲਜ਼",
      "ਅੰਡਰਲੇਮੈਂਟ ਅਤੇ ਜਿੱਥੇ ਢੁਕਵਾਂ ਹੋਵੇ ਆਈਸ/ਵਾਟਰ ਸੁਰੱਖਿਆ",
      "ਵਾਦੀ, ਕੰਧ ਅਤੇ ਪ੍ਰਵੇਸ਼ ਫਲੈਸ਼ਿੰਗ",
      "ਰਿੱਜ ਅਤੇ ਹਵਾਦਾਰੀ ਐਕਸੈਸਰੀਜ਼",
      "ਫਾਸਟਨਰ ਅਤੇ ਕਿਨਾਰੇ ਦੇ ਕੰਪੋਨੈਂਟ",
    ],
    bcClimate:
      "ਤੱਟਵਰਤੀ ਮੀਂਹ ਅਤੇ ਮੌਸ ਦੀ ਵਾਧਾ ਲੋਅਰ ਮੇਨਲੈਂਡ ਸ਼ਿੰਗਲ ਛੱਤਾਂ 'ਤੇ ਅੰਡਰਲੇਮੈਂਟ, ਵਾਦੀ ਵੇਰਵੇ ਅਤੇ ਹਵਾਦਾਰੀ ਨੂੰ ਖਾਸ ਤੌਰ 'ਤੇ ਮਹੱਤਵਪੂਰਨ ਬਣਾਉਂਦਾ ਹੈ।",
    whenAppropriate:
      "ਜਦੋਂ ਸ਼ਿੰਗਲ ਵਿਗੜਨਾ ਸਿਸਟਮ-ਵਿਆਪਕ ਹੈ ਜਾਂ ਜਾਰੀ ਪੈਚਿੰਗ ਹੋਰ ਨੇੜਲੇ ਸਮੇਂ ਦੀਆਂ ਅਸਫਲਤਾਵਾਂ ਨੂੰ ਅਨਸੁਲਝਿਆ ਛੱਡ ਦਿੰਦੀ ਹੈ।",
    whenOtherService:
      "ਅਲੱਗ ਹਵਾ ਨੁਕਸਾਨ ਅਜੇ ਵੀ ਸਥਾਨਕ ਮੁਰੰਮਤ ਲਈ ਢੁਕਵਾਂ ਹੋ ਸਕਦਾ ਹੈ ਜੇ ਫੀਲਡ ਹੋਰ ਨਹੀਂ ਤਾਂ ਸਿਹਤਮੰਦ ਹੈ।",
    process: [
      "ਢੱਕਣ, ਡੈੱਕ ਸੰਕੇਤਾਂ ਅਤੇ ਹਵਾਦਾਰੀ ਦਾ ਮੁਲਾਂਕਣ",
      "ਸਮੱਗਰੀ ਅਤੇ ਵੇਰਵੇ ਵਿਕਲਪਾਂ ਨਾਲ ਲਿਖਤ ਸਕੋਪ",
      "ਜਾਇਦਾਦ ਸੁਰੱਖਿਆ ਅਤੇ ਨਿਪਟਾਰੇ ਨਾਲ ਟੀਅਰ-ਆਫ",
      "ਕ੍ਰਮ ਵਿੱਚ ਡੈੱਕ ਮੁਰੰਮਤ, ਅੰਡਰਲੇਮੈਂਟ, ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਸ਼ਿੰਗਲ ਸਥਾਪਨਾ",
      "ਅੰਤਿਮ ਵਾਕਥਰੂ ਅਤੇ ਪੂਰਤੀ ਸਮੀਖਿਆ",
    ],
    solutionCategories: [
      {
        title: "ਆਰਕੀਟੈਕਚਰਲ laminate shingles",
        body: "ਜਿਓਮੈਟਰੀ, ਐਕਸਪੋਜ਼ਰ ਅਤੇ ਡਿਜ਼ਾਈਨ ਇਰਾਦੇ ਲਈ ਚੁਣੇ ਗਏ ਅਯਾਮੀ ਰਿਹਾਇਸ਼ੀ ਸ਼ਿੰਗਲ।",
      },
      {
        title: "ਅੰਡਰਲੇਮੈਂਟ ਅਤੇ ਵਾਟਰ-ਸ਼ੈੱਡਿੰਗ ਪਰਤਾਂ",
        body: "ਫੀਲਡ ਸ਼ਿੰਗਲਜ਼ ਨੂੰ ਵਾਦੀਆਂ, ਈਵਜ਼ ਅਤੇ ਪਰਿਵਰਤਨਾਂ ਨਾਲ ਤਾਲਮੇਲ ਵਿੱਚ ਰੱਖੋ।",
      },
      {
        title: "ਫਲੈਸ਼ਿੰਗ ਦੁਬਾਰਾ ਏਕੀਕਰਣ",
        body: "ਕੰਧਾਂ, ਚਿਮਨੀ, ਵੈਂਟਸ ਅਤੇ ਕਿਨਾਰੇ ਨਵੀਂ ਅਸੈਂਬਲੀ ਦਾ ਹਿੱਸਾ ਵਜੋਂ ਵਿਸਤਾਰ ਦਿੱਤੇ ਜਾਂਦੇ ਹਨ।",
      },
    ],
    repairVsReplace: {
      repair:
        "ਇੱਕ ਮੁਰੰਮਤ ਦਾ ਅਰਥ ਉਦੋਂ ਹੋ ਸਕਦਾ ਹੈ ਜਦੋਂ ਆਲੇ ਦੁਆਲੇ ਦੀ ਅਸੈਂਬਲੀ ਸੇਵਾਯੋਗ ਹੋਵੇ ਅਤੇ ਅਸਫਲਤਾ ਅਲੱਗ ਅਤੇ ਪਹੁੰਚਯੋਗ ਹੋਵੇ।",
      replace:
        "ਤਬਦੀਲੀ ਦਾ ਉਦੋਂ ਅਰਥ ਹੋ ਸਕਦਾ ਹੈ ਜਦੋਂ ਵਿਗੜਨਾ ਵਿਆਪਕ ਹੁੰਦਾ ਹੈ, ਅਸਫਲਤਾਵਾਂ ਦੁਹਰਾਉਂਦੀਆਂ ਹਨ, ਜਾਂ ਇੱਕ ਖੇਤਰ ਦੀ ਮੁਰੰਮਤ ਕਰਨ ਨਾਲ ਨੇੜਲੇ ਸਮੇਂ ਦੇ ਹੋਰ ਜੋਖਮਾਂ ਨੂੰ ਹੱਲ ਨਹੀਂ ਕੀਤਾ ਜਾਂਦਾ ਹੈ।",
    },
    scopeFactors: [
      "ਛੱਤ ਖੇਤਰ ਅਤੇ ਢਲਾਨ",
      "ਪਰਤ ਗਿਣਤੀ",
      "ਡੈੱਕ ਮੁਰੰਮਤ",
      "ਵਾਦੀ ਅਤੇ ਡੋਰਮਰ ਜਟਿਲਤਾ",
      "ਸਮੱਗਰੀ ਚੋਣ",
      "ਪਹੁੰਚ ਅਤੇ ਨਿਪਟਾਰਾ",
    ],
    publicPriceHint:
      "ਛੱਤ ਖੇਤਰ, ਢਲਾਨ, ਪਰਤ ਗਿਣਤੀ, ਡੈੱਕ ਮੁਰੰਮਤ, ਵਾਦੀ/ਡੋਰਮਰ ਜਟਿਲਤਾ ਅਤੇ ਸਮੱਗਰੀ ਚੋਣ ਪ੍ਰੋਜੈਕਟ ਕੀਮਤ ਨੂੰ ਨਿਰਧਾਰਤ ਕਰਦੇ ਹਨ। ਲਿਖਤ ਸਕੋਪ ਲਈ ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਬਦਲਣਾ ਕੀ ਹੈ?",
        answer:
          "ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਬਦਲਣਾ ਇੱਕ ਪੂਰੀ ਢਲਾਣ ਵਾਲੀ ਰੀਰੂਫ ਹੈ ਜੋ ਮੌਜੂਦਾ ਸ਼ਿੰਗਲ ਢੱਕਣ ਹਟਾਉਂਦੀ ਹੈ, ਸਬਸਟਰੇਟ ਅਤੇ ਅੰਡਰਲੇਮੈਂਟ ਦੀਆਂ ਲੋੜਾਂ ਨੂੰ ਸੰਬੋਧਿਤ ਕਰਦੀ ਹੈ, ਨਵੀਂ ਸ਼ਿੰਗਲ ਪ੍ਰਣਾਲੀ ਸਥਾਪਿਤ ਕਰਦੀ ਹੈ ਅਤੇ ਫਲੈਸ਼ਿੰਗਾਂ ਅਤੇ ਪ੍ਰਵੇਸ਼ਾਂ ਨੂੰ ਦੁਬਾਰਾ ਏਕੀਕ੍ਰਿਤ ਕਰਦੀ ਹੈ।",
      },
      {
        question: "ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਬਦਲਣ ਵਿੱਚ ਕਿੰਨਾ ਸਮਾਂ ਲੱਗਦਾ ਹੈ?",
        answer:
          "ਜ਼ਿਆਦਾਤਰ ਇਕੱਲੇ-ਪਰਿਵਾਰ ਵਾਲੀਆਂ ਰੀਰੂਫ਼ਾਂ ਦਿਨਾਂ ਵਿੱਚ ਮਾਪੀਆਂ ਜਾਂਦੀਆਂ ਹਨ, ਹਫ਼ਤਿਆਂ ਵਿੱਚ ਨਹੀਂ, ਪਰ ਮਿਆਦ ਛੱਤ ਦੇ ਆਕਾਰ, ਢਲਾਨ, ਮੌਸਮੀ ਵਿੰਡੋ ਅਤੇ ਟੀਅਰ-ਆਫ ਦੌਰਾਨ ਕਿੰਨੀ ਡੈੱਕ ਮੁਰੰਮਤ ਖੁਲ੍ਹਦੀ ਹੈ ਉੱਤੇ ਨਿਰਭਰ ਕਰਦੀ ਹੈ। ਲਿਖਤ ਸਕੋਪ ਕੰਮ ਸ਼ੁਰੂ ਹੋਣ ਤੋਂ ਪਹਿਲਾਂ ਉਮੀਦਾਂ ਸੈੱਟ ਕਰਦਾ ਹੈ।",
      },
      {
        question: "ਕੀ ਨਵੀਆਂ ਸ਼ਿੰਗਲਜ਼ ਪੁਰਾਣੀਆਂ ਦੇ ਉੱਪਰ ਲਗਾਈਆਂ ਜਾ ਸਕਦੀਆਂ ਹਨ?",
        answer:
          "ਓਵਰਲੇ ਕਈ ਵਾਰ ਤਕਨੀਕੀ ਤੌਰ 'ਤੇ ਸੰਭਵ ਹੁੰਦੇ ਹਨ, ਪਰ ਟੀਅਰ-ਆਫ ਆਮ ਤੌਰ 'ਤੇ ਪਸੰਦੀਦਾ ਹੈ: ਇਹ ਡੈੱਕ ਨਿਰੀਖਣ, ਸਹੀ ਅੰਡਰਲੇਮੈਂਟ ਅਤੇ ਫਲੈਸ਼ਿੰਗ ਏਕੀਕਰਣ ਦੀ ਆਗਿਆ ਦਿੰਦਾ ਹੈ, ਅਤੇ ਨਵੇਂ ਢੱਕਣ ਦੇ ਹੇਠਾਂ ਸਮੱਸਿਆਵਾਂ ਫਸਾਉਣ ਤੋਂ ਬਚਾਉਂਦਾ ਹੈ।",
      },
      {
        question: "ਟੀਅਰ-ਆਫ ਦੌਰਾਨ ਸੜੀ ਡੈੱਕ ਮਿਲਣ 'ਤੇ ਕੀ ਹੁੰਦਾ ਹੈ?",
        answer:
          "ਖੋਜੀ ਗਈ ਡੈੱਕ ਨੁਕਸਾਨ ਦਾ ਦਸਤਾਵੇਜ਼ ਬਣਾਇਆ ਜਾਂਦਾ ਹੈ ਅਤੇ ਨਵੀਂ ਪ੍ਰਣਾਲੀ ਲੱਗਣ ਤੋਂ ਪਹਿਲਾਂ ਮੁਰੰਮਤ ਕੀਤੀ ਜਾਂਦੀ ਹੈ। ਸਪਸ਼ਟ ਸਕੋਪ ਅਗਾਂਹ ਦੱਸਦਾ ਹੈ ਕਿ ਡੈੱਕ ਕੰਮ ਕਿਵੇਂ ਮਾਪਿਆ ਅਤੇ ਕੀਮਤ ਲਗਾਇਆ ਜਾਂਦਾ ਹੈ, ਤਾਂ ਜੋ ਮੱਧ-ਪ੍ਰੋਜੈਕਟ ਖੋਜਾਂ ਸਰਪ੍ਰਾਈਜ਼ ਨਾ ਬਣਣ।",
      },
      {
        question: "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਮੌਸਮ ਵਿੱਚ ਕਿਹੜੀਆਂ ਸ਼ਿੰਗਲਜ਼ ਸਭ ਤੋਂ ਵਧੀਆ ਚੱਲਦੀਆਂ ਹਨ?",
        answer:
          "ਆਰਕੀਟੈਕਚਰਲ laminate shingles ਇੱਥੇ ਆਮ ਰਿਹਾਇਸ਼ੀ ਚੋਣ ਹਨ। ਇਸ ਮਾਹੌਲ ਵਿੱਚ ਅੰਡਰਲੇਮੈਂਟ ਗੁਣਵੱਤਾ, ਵਾਦੀ/ਕਿਨਾਰੇ ਵੇਰਵੇ ਅਤੇ ਚੁਬਾਰੇ ਹਵਾਦਾਰੀ ਅਸਲ ਸੇਵਾ ਜੀਵਨ ਨੂੰ ਘੱਟੋ-ਘੱਟ ਉਤਪਾਦ ਜਿੰਨਾ ਪ੍ਰਭਾਵਿਤ ਕਰਦੇ ਹਨ।",
      },
    ],
  },
  "roof-repair": {
    title: "ਐਮਰਜੈਂਸੀ ਛੱਤ ਲੀਕ ਮੁਰੰਮਤ",
    shortTitle: "ਐਮਰਜੈਂਸੀ ਲੀਕ ਮੁਰੰਮਤ",
    eyebrow: "ਸਰਗਰਮ ਪਾਣੀ ਦਾ ਪ੍ਰਵੇਸ਼",
    description:
      "ਤਰਜੀਹੀ ਲੀਕ ਨਿਦਾਨ - ਸਮੇਂ-ਸਾਰਣੀ ਮੁਤਾਬਕ ਉਸੇ ਦਿਨ - ਜਦੋਂ ਪਾਣੀ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਘਰ ਵਿੱਚ ਛੱਤ ਅਸੈਂਬਲੀ ਰਾਹੀਂ ਦਾਖਲ ਹੋ ਰਿਹਾ ਹੋਵੇ ਤਾਂ ਅਸਥਾਈ ਜਾਂ ਸਥਾਈ ਸਥਾਨਕ ਮੁਰੰਮਤ ਨਾਲ।",
    definition:
      "ਐਮਰਜੈਂਸੀ ਛੱਤ ਲੀਕ ਮੁਰੰਮਤ ਸਰਗਰਮ ਜਾਂ ਤੇਜ਼ੀ ਨਾਲ ਵਿਕਸਿਤ ਹੋ ਰਹੇ ਪਾਣੀ ਦੇ ਪ੍ਰਵੇਸ਼ ਦੀ ਕੇਂਦਰਿਤ ਜਾਂਚ ਅਤੇ ਸਥਿਰਤਾ ਹੈ ਜੋ ਛੱਤ ਢੱਕਣ, ਫਲੈਸ਼ਿੰਗ, ਪ੍ਰਵੇਸ਼ ਜਾਂ ਸੰਬੰਧਿਤ ਇੰਟਰਫੇਸ ਰਾਹੀਂ ਹੁੰਦਾ ਹੈ। ਸਥਿਤੀਆਂ ਮੁਤਾਬਕ ਅਸਥਾਈ ਡ੍ਰਾਈ-ਇਨ ਅਤੇ ਸਥਾਈ ਸਥਾਨਕ ਮੁਰੰਮਤ ਸ਼ਾਮਲ ਹੋ ਸਕਦੀ ਹੈ।",
    forWhom:
      "ਸਰਗਰਮ ਟਪਕਣ, ਮੀਂਹ ਦੌਰਾਨ ਅਚਾਨਕ ਛੱਤ ਦੇ ਧੱਬੇ, ਤੂਫਾਨਾਂ ਤੋਂ ਬਾਅਦ ਚੁਬਾਰੇ ਦੀ ਨਮੀ, ਜਾਂ ਵੱਡੇ ਸਕੋਪ ਦੀ ਯੋਜਨਾ ਤੋਂ ਪਹਿਲਾਂ ਸੁਰੱਖਿਅਤ ਨਿਦਾਨ ਅਤੇ ਰੋਕਥਾਮ ਦੀ ਲੋੜ ਵਾਲੇ ਘਰ ਦੇ ਮਾਲਕ।",
    warningSigns: [
      "ਮੀਂਹ ਦੌਰਾਨ ਜਾਂ ਬਾਅਦ ਸਰਗਰਮ ਟਪਕਣ ਜਾਂ ਲਗਾਤਾਰ ਨਮੀ",
      "ਨਵੇਂ ਜਾਂ ਵਧਦੇ ਛੱਤ, ਕੰਧ ਜਾਂ ਲਾਈਟ-ਫਿਕਸਚਰ ਧੱਬੇ",
      "ਗਿੱਲਾ ਇੰਸੂਲੇਸ਼ਨ, ਸ਼ੀਥਿੰਗ ਜਾਂ ਚੁਬਾਰੇ ਫਰੇਮਿੰਗ",
      "ਵਾਦੀਆਂ, ਚਿਮਨੀ, ਸਕਾਈਲਾਈਟ ਜਾਂ ਪਲੰਬਿੰਗ ਵੈਂਟਸ ਦੇ ਨਾਲ ਪਾਣੀ ਦਾ ਟਰੈਕ",
      "ਹਰ ਮੌਸਮੀ ਘਟਨਾ ਤੋਂ ਬਾਅਦ ਵਧਦਾ ਅੰਦਰੂਨੀ ਨੁਕਸਾਨ",
    ],
    evaluates: [
      "ਅੰਦਰੂਨੀ ਸਬੂਤ ਅਤੇ ਸੰਭਾਵਿਤ ਪਾਣੀ ਦਾ ਮਾਰਗ",
      "ਪ੍ਰਭਾਵਿਤ ਜ਼ੋਨ ਦੇ ਆਲੇ-ਦੁਆਲੇ ਛੱਤ ਢੱਕਣ",
      "ਫਲੈਸ਼ਿੰਗ, ਪ੍ਰਵੇਸ਼, ਵਾਦੀਆਂ ਅਤੇ ਕੰਧ ਇੰਟਰਫੇਸ",
      "ਅਸਥਾਈ ਸੁਰੱਖਿਆ ਬਨਾਮ ਸਥਾਈ ਮੁਰੰਮਤ ਦੀ ਲੋੜ",
      "ਕੀ ਨਾਲ ਲੱਗਦੀ ਸਮੱਗਰੀ ਟਿਕਾਊ ਕੰਮ ਦਾ ਸਮਰਥਨ ਕਰ ਸਕਦੀ ਹੈ",
    ],
    causes: [
      "ਫੇਲ੍ਹ ਫਲੈਸ਼ਿੰਗ ਜਾਂ ਪਾਈਪ ਬੂਟ ਸੀਲ",
      "ਹਵਾ ਨਾਲ ਉੱਠੀਆਂ ਜਾਂ ਗੁੰਮ ਢੱਕਣ ਸਮੱਗਰੀਆਂ",
      "ਮਲਬੇ-ਬਲਾਕ ਡਰੇਨੇਜ ਜੋ ਪਾਣੀ ਇਕੱਠਾ ਕਰਦਾ ਹੈ",
      "ਤੂਫਾਨ-ਨੁਕਸਾਨ ਰਿੱਜ, ਕਿਨਾਰੇ ਜਾਂ ਪਰਿਵਰਤਨ",
      "ਪਿਛਲੇ ਪੈਚ ਜਿਨ੍ਹਾਂ ਨੇ ਅਸਲ ਸਰੋਤ ਨੂੰ ਸੰਬੋਧਿਤ ਨਹੀਂ ਕੀਤਾ",
    ],
    methodology: [
      "ਅੰਦਰੂਨੀ ਅਤੇ ਬਾਹਰੀ ਸਬੂਤ ਸੁਰੱਖਿਅਤ ਤਰੀਕੇ ਨਾਲ ਦਸਤਾਵੇਜ਼ ਕਰੋ",
      "ਸਿਰਫ ਧੱਬੇ ਦੀ ਥਾਂ ਦੀ ਬਜਾਏ ਸਭ ਤੋਂ ਸੰਭਾਵਿਤ ਪ੍ਰਵੇਸ਼ ਮਾਰਗ ਦਾ ਪਤਾ ਲਗਾਓ",
      "ਮੌਸਮ ਜਾਂ ਪਹੁੰਚ ਲੋੜ ਹੋਣ 'ਤੇ ਅਸਥਾਈ ਡ੍ਰਾਈ-ਇਨ ਨਾਲ ਸਥਿਰ ਕਰੋ",
      "ਜਦੋਂ ਆਲੇ-ਦੁਆਲੇ ਦੀ ਅਸੈਂਬਲੀ ਸੇਵਾਯੋਗ ਹੋਵੇ ਤਾਂ ਅਨੁਕੂਲ ਸਥਾਨਕ ਮੁਰੰਮਤ ਕਰੋ",
      "ਬਾਕੀ ਜੋਖਮ ਅਤੇ ਕੀ ਵਿਆਪਕ ਕੰਮ ਫਾਲੋ ਕਰਨਾ ਚਾਹੀਦਾ ਹੈ ਸਮਝਾਓ",
    ],
    materials: [
      "ਮੌਜੂਦਾ ਪ੍ਰਣਾਲੀ ਲਈ ਅਨੁਕੂਲ ਢੱਕਣ ਸਮੱਗਰੀ",
      "ਜਿੱਥੇ ਢੁਕਵਾਂ ਹੋਵੇ ਅੰਡਰਲੇਮੈਂਟ ਜਾਂ ਝਿੱਲੀ ਪੈਚ",
      "ਫਲੈਸ਼ਿੰਗ ਧਾਤ ਅਤੇ ਪ੍ਰਵੇਸ਼ ਬੂਟ",
      "ਸੀਲੈਂਟ ਸਿਰਫ ਸਹੀ ਵੇਰਵੇ ਦਾ ਹਿੱਸਾ, ਇਕੱਲਾ ਹੱਲ ਨਹੀਂ",
      "ਲੋੜ ਪੈਣ 'ਤੇ ਅਸਥਾਈ ਤਰਪਾਲ ਜਾਂ ਡ੍ਰਾਈ-ਇਨ ਸਮੱਗਰੀ",
    ],
    bcClimate:
      "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਦੀ ਲਗਾਤਾਰ ਬਾਰਿਸ਼ ਦਾ ਮਤਲਬ ਹੈ ਕਿ ਛੋਟੀਆਂ ਖਾਮੀਆਂ ਵਾਰ-ਵਾਰ ਅੰਦਰੂਨੀ ਨੁਕਸਾਨ ਪੈਦਾ ਕਰ ਸਕਦੀਆਂ ਹਨ। ਸਮੇਂ ਸਿਰ ਨਿਦਾਨ ਸਤਹੀ ਪੈਚ ਨਾਲੋਂ ਵਧੇਰੇ ਮਹੱਤਵਪੂਰਨ ਹੈ ਜੋ ਅਸਲ ਮਾਰਗ ਨੂੰ ਅਨਸੁਲਝਿਆ ਛੱਡ ਦੇਵੇ।",
    whenAppropriate:
      "ਜਦੋਂ ਪਾਣੀ ਦਾ ਪ੍ਰਵੇਸ਼ ਸਥਾਨਿਕ ਹੈ, ਆਲੇ-ਦੁਆਲੇ ਦੀ ਛੱਤ ਸੇਵਾਯੋਗ ਹੈ, ਅਤੇ ਟਿਕਾਊ ਮੁਰੰਮਤ ਜਾਂ ਅਸਥਾਈ ਡ੍ਰਾਈ-ਇਨ ਸੁਰੱਖਿਅਤ ਤੌਰ 'ਤੇ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ।",
    whenOtherService:
      "ਵਿਆਪਕ ਢੱਕਣ ਅਸਫਲਤਾ, ਕਈ ਸੁਤੰਤਰ ਲੀਕ, ਜਾਂ ਜੀਵਨ-ਅੰਤ ਅਸੈਂਬਲੀਆਂ ਲਈ ਵਿਆਪਕ ਮੁਰੰਮਤ ਯੋਜਨਾ, ਸਿਰਫ ਤੂਫਾਨ ਡ੍ਰਾਈ-ਇਨ, ਜਾਂ ਪੂਰੀ ਬਦਲੀ ਦੀ ਚਰਚਾ ਲੋੜੀਂਦੀ ਹੋ ਸਕਦੀ ਹੈ।",
    process: [
      "ਜੋ ਦੇਖ ਰਹੇ ਹੋ ਉਸਦੇ ਵੇਰਵੇ ਅਤੇ ਫੋਟੋ ਕਾਲ ਜਾਂ ਭੇਜੋ",
      "ਟ੍ਰਾਇਅਜ ਅਤੇ ਸਮੇਂ-ਸਾਰਣੀ: ਉਪਲਬਧਤਾ ਮੁਤਾਬਕ ਉਸੇ ਦਿਨ ਹਾਜ਼ਰੀ",
      "ਅੰਦਰੂਨੀ ਅਤੇ ਬਾਹਰੀ ਦਸਤਾਵੇਜ਼ੀਕਰਨ ਨਾਲ ਛੱਤ 'ਤੇ ਸਰੋਤ ਨਿਦਾਨ",
      "ਸਥਿਤੀਆਂ ਮੁਤਾਬਕ ਅਸਥਾਈ ਡ੍ਰਾਈ-ਇਨ ਜਾਂ ਸਥਾਈ ਸਥਾਨਕ ਮੁਰੰਮਤ",
      "ਖੋਜਾਂ, ਪੂਰੇ ਕੰਮ ਅਤੇ ਸਿਫ਼ਾਰਸ਼ੀ ਅਗਲੇ ਕਦਮਾਂ ਦਾ ਲਿਖਤ ਸਾਰ",
    ],
    solutionCategories: [
      {
        title: "ਸਰੋਤ ਨਿਦਾਨ",
        body: "ਅੰਦਰੂਨੀ ਸਬੂਤ ਨੂੰ ਬਾਹਰੀ ਵੇਰਵੇ ਨਾਲ ਜੋੜੋ ਜੋ ਸਭ ਤੋਂ ਸੰਭਾਵਿਤ ਪਾਣੀ ਦਾਖਲ ਕਰਦਾ ਹੈ, ਢੱਕਣ ਦੇ ਹੇਠਾਂ ਪਾਰਪਾਰੀ ਯਾਤਰਾ ਸਮੇਤ।",
      },
      {
        title: "ਅਸਥਾਈ ਡ੍ਰਾਈ-ਇਨ",
        body: "ਤੂਫਾਨ ਨੁਕਸਾਨ ਜਾਂ ਜਦੋਂ ਸਥਾਈ ਸਮੱਗਰੀ ਉਸੇ ਵਿਜ਼ਿਟ ਵਿੱਚ ਪੂਰੀ ਨਹੀਂ ਹੋ ਸਕਦੀ ਤਾਂ ਖੁੱਲ੍ਹਣਾਂ ਨੂੰ ਸਥਿਰ ਕਰੋ।",
      },
      {
        title: "ਸਥਾਨਕ ਸਥਾਈ ਮੁਰੰਮਤ",
        body: "ਫੇਲ੍ਹ ਕੰਪੋਨੈਂਟ ਨੂੰ ਆਲੇ-ਦੁਆਲੇ ਦੀ ਛੱਤ ਪ੍ਰਣਾਲੀ ਨਾਲ ਅਨੁਕੂਲ ਸਮੱਗਰੀ ਨਾਲ ਬਦਲੋ ਜਾਂ ਦੁਬਾਰਾ ਵਿਸਤਾਰ ਦਿਓ।",
      },
    ],
    repairVsReplace: {
      repair:
        "ਇੱਕ ਕੇਂਦਰਿਤ ਮੁਰੰਮਤ ਆਮ ਤੌਰ 'ਤੇ ਢੁਕਵੀਂ ਹੁੰਦੀ ਹੈ ਜਦੋਂ ਇੱਕ ਅਸਫਲਤਾ ਜ਼ੋਨ ਪਛਾਣਿਆ ਜਾਂਦਾ ਹੈ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਦੀ ਸਮੱਗਰੀ ਅਨੁਕੂਲ ਕੰਮ ਸਵੀਕਾਰ ਕਰਨ ਲਈ ਕਾਫ਼ੀ ਸਿਹਤਮੰਦ ਹੈ।",
      replace:
        "ਜਦੋਂ ਜਾਂਚ ਵਿਆਪਕ ਵਿਗਾੜ, ਕਈ ਸੁਤੰਤਰ ਅਸਫਲਤਾਵਾਂ, ਜਾਂ ਅਸੈਂਬਲੀ ਜੋ ਟਿਕਾਊ ਪੈਚ ਸਵੀਕਾਰ ਨਹੀਂ ਕਰ ਸਕਦੀ ਦਿਖਾਉਂਦੀ ਹੈ ਤਾਂ ਬਦਲੀ ਚਰਚਾ ਵਿੱਚ ਆਉਂਦੀ ਹੈ।",
    },
    scopeFactors: [
      "ਪਹੁੰਚ ਅਤੇ ਛੱਤ ਦੀ ਉਚਾਈ",
      "ਮੌਸਮੀ ਵਿੰਡੋ",
      "ਛੁਪੇ ਨੁਕਸਾਨ ਦੀ ਹੱਦ",
      "ਸਮੱਗਰੀ ਅਨੁਕੂਲਤਾ",
      "ਸ਼ਾਮਲ ਪ੍ਰਵੇਸ਼ਾਂ ਦੀ ਗਿਣਤੀ",
      "ਅਸਥਾਈ ਸੁਰੱਖਿਆ ਦੀ ਲੋੜ",
    ],
    publicPriceHint:
      "ਐਮਰਜੈਂਸੀ ਸਕੋਪ ਪਹੁੰਚ, ਕੰਮ ਦੌਰਾਨ ਮੌਸਮ, ਪਾਣੀ ਕਿੰਨੀ ਦੂਰ ਯਾਤਰਾ ਕੀਤੀ ਅਤੇ ਸਥਾਈ ਮੁਰੰਮਤ ਤੋਂ ਪਹਿਲਾਂ ਅਸਥਾਈ ਸੁਰੱਖਿਆ ਦੀ ਲੋੜ 'ਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ। ਪ੍ਰੋਜੈਕਟ-ਵਿਸ਼ੇਸ਼ ਕੀਮਤ ਲਈ ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਐਮਰਜੈਂਸੀ ਛੱਤ ਲੀਕ ਮੁਰੰਮਤ ਕੀ ਹੈ?",
        answer:
          "ਐਮਰਜੈਂਸੀ ਛੱਤ ਲੀਕ ਮੁਰੰਮਤ ਸਰਗਰਮ ਜਾਂ ਤੇਜ਼ੀ ਨਾਲ ਵਿਕਸਿਤ ਹੋ ਰਹੇ ਪਾਣੀ ਦੇ ਪ੍ਰਵੇਸ਼ ਦੀ ਕੇਂਦਰਿਤ ਜਾਂਚ ਅਤੇ ਸਥਿਰਤਾ ਹੈ ਜੋ ਛੱਤ ਢੱਕਣ, ਫਲੈਸ਼ਿੰਗ, ਪ੍ਰਵੇਸ਼ ਜਾਂ ਸੰਬੰਧਿਤ ਇੰਟਰਫੇਸ ਰਾਹੀਂ ਹੁੰਦਾ ਹੈ। ਸਥਿਤੀਆਂ ਮੁਤਾਬਕ ਅਸਥਾਈ ਡ੍ਰਾਈ-ਇਨ ਅਤੇ ਸਥਾਈ ਸਥਾਨਕ ਮੁਰੰਮਤ ਸ਼ਾਮਲ ਹੋ ਸਕਦੀ ਹੈ।",
      },
      {
        question: "ਕੀ ਮੀਂਹ ਹੁੰਦੇ ਹੋਏ ਛੱਤ ਲੀਕ ਠੀਕ ਕੀਤੀ ਜਾ ਸਕਦੀ ਹੈ?",
        answer:
          "ਸਰਗਰਮ ਮੀਂਹ ਵਿੱਚ ਸੁਰੱਖਿਅਤ ਪਹਿਲਾ ਕਦਮ ਆਮ ਤੌਰ 'ਤੇ ਅਸਥਾਈ ਡ੍ਰਾਈ-ਇਨ - ਤਰਪਾਲ ਜਾਂ ਪ੍ਰਵੇਸ਼ ਖੇਤਰ ਸੀਲ - ਹੈ, ਕਿਉਂਕਿ ਜ਼ਿਆਦਾਤਰ ਸਥਾਈ ਛੱਤ ਸਮੱਗਰੀ ਨੂੰ ਸਹੀ ਬੰਧਨ ਲਈ ਸੁੱਕੀਆਂ ਸਥਿਤੀਆਂ ਚਾਹੀਦੀਆਂ ਹਨ। ਫਿਰ ਸਥਾਈ ਮੁਰੰਮਤ ਢੁਕਵੀਂ ਮੌਸਮੀ ਵਿੰਡੋ ਵਿੱਚ ਪੂਰੀ ਹੁੰਦੀ ਹੈ।",
      },
      {
        question: "ਮੇਰਾ ਛੱਤ ਧੱਬਾ ਕਿਸੇ ਵੀ ਦਿਖਾਈ ਦੇਣ ਵਾਲੇ ਛੱਤ ਨੁਕਸਾਨ ਤੋਂ ਦੂਰ ਕਿਉਂ ਹੈ?",
        answer:
          "ਪਾਣੀ ਅਕਸਰ ਇੱਕ ਵੇਰਵੇ 'ਤੇ ਦਾਖਲ ਹੁੰਦਾ ਹੈ ਅਤੇ ਅੰਦਰ ਦਿਖਾਈ ਦੇਣ ਤੋਂ ਪਹਿਲਾਂ ਅੰਡਰਲੇਮੈਂਟ, ਫਰੇਮਿੰਗ ਜਾਂ ਸ਼ੀਥਿੰਗ ਦੇ ਨਾਲ ਚੱਲਦਾ ਹੈ। ਇਸ ਲਈ ਨਿਦਾਨ ਧੱਬੇ ਦੇ ਸਿੱਧੇ ਉੱਪਰ ਪੈਚ ਕਰਨ ਦੀ ਬਜਾਏ ਛੱਤ ਭਰ ਵਿੱਚ ਸੰਭਾਵਿਤ ਪ੍ਰਵੇਸ਼ ਮਾਰਗ ਦਾ ਪਤਾ ਲਗਾਉਂਦਾ ਹੈ।",
      },
      {
        question: "ਕੀ ਤੁਸੀਂ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਵਿੱਚ ਉਸੇ ਦਿਨ ਛੱਤ ਲੀਕ ਮੁਰੰਮਤ ਕਰਦੇ ਹੋ?",
        answer:
          "ਰੇਵੋਲਿਨ ਸਰਗਰਮ ਲੀਕਾਂ 'ਤੇ ਉਸੇ ਦਿਨ ਹਾਜ਼ਰ ਹੋਣ ਦਾ ਟੀਚਾ ਰੱਖਦੀ ਹੈ ਜਦੋਂ ਸਮੇਂ-ਸਾਰਣੀ ਅਤੇ ਦਿਨ ਦੀ ਰੋਸ਼ਨੀ ਇਜਾਜ਼ਤ ਦੇਵੇ, ਪਰ ਹਾਜ਼ਰੀ ਦੇ ਸਮੇਂ ਗਾਰੰਟੀ ਨਹੀਂ। ਫੋਟੋ ਅਤੇ ਸਪਸ਼ਟ ਵਰਣਨ ਟ੍ਰਾਇਅਜ ਕਾਲ ਵਿੱਚ ਮਦਦ ਕਰਦੇ ਹਨ।",
      },
      {
        question: "ਕੀ ਮੇਰੀ ਲੀਕ ਮੁਰੰਮਤ ਅਸਥਾਈ ਜਾਂ ਸਥਾਈ ਹੋਵੇਗੀ?",
        answer:
          "ਇਹ ਮੌਸਮ, ਸਮੱਗਰੀ ਉਪਲਬਧਤਾ ਅਤੇ ਜਾਂਚ ਖੋਜਾਂ 'ਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ। ਜਦੋਂ ਪਹਿਲੀ ਵਿਜ਼ਿਟ 'ਤੇ ਟਿਕਾਊ ਸਥਾਨਕ ਮੁਰੰਮਤ ਸੁਰੱਖਿਅਤ ਤੌਰ 'ਤੇ ਕੀਤੀ ਜਾ ਸਕਦੀ ਹੈ, ਉਹ ਕੀਤੀ ਜਾਂਦੀ ਹੈ। ਨਹੀਂ ਤਾਂ ਛੱਤ ਅਸਥਾਈ ਡ੍ਰਾਈ-ਇਨ ਨਾਲ ਸਥਿਰ ਕੀਤੀ ਜਾਂਦੀ ਹੈ ਅਤੇ ਸਥਾਈ ਕੰਮ ਲਿਖਤ ਵਿੱਚ ਸਕੋਪ ਕੀਤਾ ਜਾਂਦਾ ਹੈ।",
      },
      {
        question: "ਐਮਰਜੈਂਸੀ ਛੱਤ ਲੀਕ ਮੁਰੰਮਤ ਦੀ ਕੀਮਤ ਕਿੰਨੀ ਹੈ?",
        answer:
          "ਕੀਮਤ ਛੱਤ ਦੀ ਉਚਾਈ/ਪਹੁੰਚ, ਛੁਪੇ ਨੁਕਸਾਨ ਦੀ ਹੱਦ, ਅਤੇ ਕੀ ਮੁਰੰਮਤ ਦੇ ਨਾਲ ਅਸਥਾਈ ਸੁਰੱਖਿਆ ਲੋੜੀਂਦੀ ਹੈ ਉੱਤੇ ਨਿਰਭਰ ਕਰਦੀ ਹੈ। ਰੇਵੋਲਿਨ ਮੁਲਾਂਕਣ ਤੋਂ ਬਾਅਦ ਪ੍ਰੋਜੈਕਟ-ਵਿਸ਼ੇਸ਼ ਕੀਮਤ ਦਿੰਦੀ ਹੈ, ਬਿਨਾਂ ਦੇਖੇ ਕੋਟ ਨਹੀਂ।",
      },
    ],
  },
  "asphalt-shingle-roofing": {
    title: "ਆਰਕੀਟੈਕਚਰਲ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਛੱਤ",
    shortTitle: "ਅਸਫਾਲਟ ਸ਼ਿੰਗਲਜ਼",
    eyebrow: "ਢਲਾਣ ਵਾਲੇ ਸਿਸਟਮ",
    description:
      "ਢੁਕਵੀਂ ਢਲਾਣ ਵਾਲੀਆਂ ਛੱਤ ਅਸੈਂਬਲੀਆਂ ਵਾਲੇ ਬਹੁਤ ਸਾਰੇ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਘਰਾਂ ਲਈ ਇੱਕ ਵਿਹਾਰਕ, ਡਿਜ਼ਾਈਨ-ਸਚੇਤ ਛੱਤ ਵਾਲੀ ਸ਼੍ਰੇਣੀ।",
    definition:
      "ਆਰਕੀਟੈਕਚਰਲ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਛੱਤ ਇੱਕ ਜਾਣੀ-ਪਛਾਣੀ ਢਲਾਣ ਵਾਲੀ ਰਿਹਾਇਸ਼ੀ ਛੱਤ ਪ੍ਰਣਾਲੀ ਹੈ ਜਿਸ ਵਿੱਚ ਡਿਜ਼ਾਈਨ ਵਿਕਲਪ ਅਤੇ ਸਿੱਧੀ ਭਵਿੱਖ ਦੀ ਸੇਵਾਯੋਗਤਾ ਸ਼ਾਮਲ ਹੈ।",
    forWhom:
      "ਆਰਕੀਟੈਕਚਰਲ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲਜ਼ ਬਹੁਤ ਸਾਰੀਆਂ ਢਲਾਣ ਵਾਲੀਆਂ ਰਿਹਾਇਸ਼ੀ ਛੱਤਾਂ ਦੇ ਅਨੁਕੂਲ ਹਨ ਜਿੱਥੇ ਘਰ ਦੇ ਮਾਲਕ ਇੱਕ ਜਾਣੀ-ਪਛਾਣੀ ਪ੍ਰਣਾਲੀ, ਵਿਆਪਕ ਸੁਹਜ ਵਿਕਲਪ ਅਤੇ ਸਿੱਧੇ ਭਵਿੱਖ ਦੀ ਸੇਵਾਯੋਗਤਾ ਚਾਹੁੰਦੇ ਹਨ।",
    warningSigns: [
      "ਗ੍ਰੈਨਿਊਲ ਦਾ ਨੁਕਸਾਨ ਜਾਂ ਐਕਸਪੋਜ਼ਡ ਮੈਟਿੰਗ",
      "ਕਰਲਿੰਗ, ਕਰੈਕਿੰਗ ਜਾਂ ਵਿਸਥਾਪਿਤ ਸ਼ਿੰਗਲਜ਼",
      "ਘਾਟੀਆਂ, ਕਿਨਾਰਿਆਂ ਜਾਂ ਪ੍ਰਵੇਸ਼ ਦੇ ਆਲੇ-ਦੁਆਲੇ ਨੁਕਸਾਨ",
      "ਮੌਸ ਦਾ ਵਾਧਾ ਜੋ ਛੱਤ ਦੀ ਸਤ੍ਹਾ ਨੂੰ ਅਸਪਸ਼ਟ ਕਰਦਾ ਹੈ",
      "ਕਈ ਜਹਾਜ਼ਾਂ ਵਿੱਚ ਵਾਰ-ਵਾਰ ਮੁਰੰਮਤ",
    ],
    evaluates: [
      "ਛੱਤ ਦੀ ਢਲਾਣ ਅਤੇ ਜਿਓਮੈਟਰੀ",
      "ਢੁਕਵੀਂ ਜਾਂਚ ਤੋਂ ਬਾਅਦ ਡੇਕ ਦੀ ਸਥਿਤੀ",
      "ਅੰਡਰਲੇਮੈਂਟ, ਈਵਜ਼ ਅਤੇ ਵੈਲੀ ਪਹੁੰਚ",
      "ਹਵਾਦਾਰੀ ਅਤੇ ਦਾਖਲੇ/ਨਿਕਾਸ ਮਾਰਗ",
      "ਫਲੈਸ਼ਿੰਗ ਇੰਟਰਫੇਸ ਅਤੇ ਡਰੇਨੇਜ",
    ],
    causes: [
      "ਸਧਾਰਨ ਮੌਸਮੀ ਘਿਸਾਈ",
      "ਮੌਸ ਅਤੇ ਨਮੀ",
      "ਹਵਾ ਨੁਕਸਾਨ",
      "ਕਮਜ਼ੋਰ ਹਵਾਦਾਰੀ",
      "ਕਮਜ਼ੋਰ ਵੇਰਵੇ ਵਾਲੀਆਂ ਸਥਾਪਨਾਵਾਂ",
    ],
    methodology: [
      "ਛੱਤ ਜਿਓਮੈਟਰੀ ਅਤੇ ਡੈੱਕ ਸੰਕੇਤਾਂ ਦਾ ਮੁਲਾਂਕਣ",
      "ਅੰਡਰਲੇਮੈਂਟ ਅਤੇ ਵਾਟਰ-ਸ਼ੈੱਡਿੰਗ ਵੇਰਵਿਆਂ ਦੀ ਯੋਜਨਾ",
      "ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਪ੍ਰਵੇਸ਼ ਕ੍ਰਮ ਦੀ ਯੋਜਨਾ",
      "ਸਮੱਗਰੀ ਅਤੇ ਰੰਗ ਚੋਣ",
      "ਸੇਵਾਯੋਗਤਾ ਲਈ ਰੱਖ-ਰਖਾਅ ਮਾਰਗਦਰਸ਼ਨ",
    ],
    materials: [
      "ਆਰਕੀਟੈਕਚਰਲ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲਜ਼",
      "ਅੰਡਰਲੇਮੈਂਟ",
      "ਫਲੈਸ਼ਿੰਗ ਧਾਤ",
      "ਰਿੱਜ ਅਤੇ ਹਵਾਦਾਰੀ ਐਕਸੈਸਰੀਜ਼",
    ],
    bcClimate:
      "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਵਿੱਚ ਮੌਸ, ਲੰਬੇ ਮੀਂਹ ਅਤੇ ਛਾਂ ਵਾਲੀਆਂ ਢਲਾਣਾਂ ਸ਼ਿੰਗਲ ਘਿਸਾਈ ਨੂੰ ਤੇਜ਼ ਕਰ ਸਕਦੀਆਂ ਹਨ।",
    whenAppropriate:
      "ਜਦੋਂ ਢਲਾਣ ਵਾਲੀ ਜਿਓਮੈਟਰੀ, ਡਿਜ਼ਾਈਨ ਇਰਾਦਾ ਅਤੇ ਸੇਵਾਯੋਗਤਾ ਇੱਕ ਜਾਣੀ-ਪਛਾਣੀ ਸ਼ਿੰਗਲ ਪ੍ਰਣਾਲੀ ਨਾਲ ਮੇਲ ਖਾਂਦੇ ਹਨ।",
    whenOtherService:
      "ਘੱਟ ਢਲਾਨ ਵਾਲੇ ਹਿੱਸੇ ਜਾਂ ਵਿਆਪਕ ਘਿਸਾਈ ਲਈ ਹੋਰ ਸੇਵਾਵਾਂ ਵਧੇਰੇ ਢੁਕਵੀਆਂ ਹੋ ਸਕਦੀਆਂ ਹਨ।",
    process: [
      "ਛੱਤ ਜਿਓਮੈਟਰੀ ਅਤੇ ਮੌਜੂਦਾ ਢੱਕਣ ਦਾ ਮੁਲਾਂਕਣ",
      "ਸਮੱਗਰੀ ਅਤੇ ਵੇਰਵੇ ਵਿਕਲਪਾਂ ਦੀ ਚਰਚਾ",
      "ਲਿਖਤ ਸਕੋਪ ਜੇ ਸਥਾਪਨਾ ਜਾਂ ਬਦਲੀ ਅੱਗੇ ਵਧਦੀ ਹੈ",
      "ਅਸੈਂਬਲੀ ਕ੍ਰਮ ਵਿੱਚ ਸਥਾਪਨਾ",
      "ਪੂਰਤੀ ਸਮੀਖਿਆ",
    ],
    solutionCategories: [
      {
        title: "ਆਰਕੀਟੈਕਚਰਲ laminate shingles",
        body: "ਅਸੈਂਬਲੀ ਅਤੇ ਡਿਜ਼ਾਈਨ ਲੋੜਾਂ ਦੇ ਆਧਾਰ 'ਤੇ ਚੋਣ ਦੇ ਨਾਲ, ਰਿਹਾਇਸ਼ੀ ਢਲਾਣ ਵਾਲੀਆਂ ਛੱਤਾਂ 'ਤੇ ਵਿਆਪਕ ਤੌਰ 'ਤੇ ਵਰਤੇ ਜਾਂਦੇ ਅਯਾਮੀ ਪ੍ਰੋਫਾਈਲਾਂ।",
      },
      {
        title: "ਅੰਡਰਲੇਮੈਂਟ ਅਤੇ ਵਾਟਰ-ਸ਼ੈੱਡਿੰਗ ਵੇਰਵੇ",
        body: "ਦਿਖਾਈ ਦੇਣ ਵਾਲੀ ਸ਼ਿੰਗਲ ਇੱਕ ਤਾਲਮੇਲ ਵਾਲੀ ਅਸੈਂਬਲੀ ਵਿੱਚ ਇੱਕ ਪਰਤ ਹੁੰਦੀ ਹੈ ਜਿਸ ਵਿੱਚ ਲੈਪਸ, ਘਾਟੀਆਂ, ਕਿਨਾਰੇ ਅਤੇ ਪਰਿਵਰਤਨ ਸ਼ਾਮਲ ਹੁੰਦੇ ਹਨ।",
      },
      {
        title: "ਫਲੈਸ਼ਿੰਗ ਏਕੀਕਰਣ",
        body: "ਕੰਧਾਂ, ਚਿਮਨੀ, ਪਲੰਬਿੰਗ ਵੈਂਟਸ ਅਤੇ ਛੱਤ ਦੀਆਂ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਦੇ ਇੰਟਰਫੇਸਾਂ ਨੂੰ ਸ਼ਿੰਗਲ ਫੀਲਡ ਨਾਲ ਜਾਣਬੁੱਝ ਕੇ ਕ੍ਰਮ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ।",
      },
    ],
    repairVsReplace: {
      repair:
        "ਮੇਲ ਖਾਂਦੇ ਸਮੇਂ ਇੱਕ ਸ਼ਾਮਲ ਮੁਰੰਮਤ ਵਿਹਾਰਕ ਹੋ ਸਕਦੀ ਹੈ, ਅਨੁਕੂਲ ਸ਼ਿੰਗਲਜ਼ ਨੂੰ ਇੱਕ ਨਾਜ਼ੁਕ ਆਲੇ ਦੁਆਲੇ ਦੇ ਖੇਤਰ ਨੂੰ ਨੁਕਸਾਨ ਪਹੁੰਚਾਏ ਬਿਨਾਂ ਜੋੜਿਆ ਜਾ ਸਕਦਾ ਹੈ।",
      replace:
        "ਬਦਲਣਾ ਵਧੇਰੇ ਉਚਿਤ ਹੋ ਸਕਦਾ ਹੈ ਜਦੋਂ ਸ਼ਿੰਗਲਜ਼ ਮੋਟੇ ਤੌਰ 'ਤੇ ਭੁਰਭੁਰਾ, ਖਰਾਬ ਜਾਂ ਛੱਤ ਦੇ ਕਈ ਜਹਾਜ਼ਾਂ ਵਿੱਚ ਪ੍ਰਭਾਵਿਤ ਹੋਣ।",
    },
    scopeFactors: [
      "ਛੱਤ ਦੀ ਪਿੱਚ ਅਤੇ ਕੁੱਲ ਖੇਤਰ",
      "ਵਾਦੀਆਂ, ਡੋਰਮਰ ਅਤੇ ਪ੍ਰਵੇਸ਼ ਦੀ ਸੰਖਿਆ",
      "ਮੌਜੂਦਾ ਪਰਤਾਂ ਅਤੇ ਡੈੱਕ ਦੀ ਮੁਰੰਮਤ",
      "ਸ਼ਿੰਗਲ ਪ੍ਰੋਫਾਈਲ ਅਤੇ ਐਕਸੈਸਰੀ ਦੀ ਚੋਣ",
      "ਹਵਾਦਾਰੀ ਅਤੇ ਫਲੈਸ਼ਿੰਗ ਦਾ ਕੰਮ",
      "ਪਹੁੰਚ ਅਤੇ ਸਾਈਟ ਸੁਰੱਖਿਆ",
    ],
    publicPriceHint:
      "ਸਕੋਪ ਛੱਤ ਖੇਤਰ, ਢਲਾਨ, ਵਾਦੀ/ਡੋਰਮਰ ਜਟਿਲਤਾ ਅਤੇ ਸਮੱਗਰੀ ਚੋਣ 'ਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਕੀ ਹਰ ਢਲਾਣ ਵਾਲੀ ਛੱਤ ਲਈ ਆਰਕੀਟੈਕਚਰਲ ਸ਼ਿੰਗਲਜ਼ ਸਹੀ ਹਨ?",
        answer: "ਸੰ. ਕਿਸੇ ਉਤਪਾਦ ਦੀ ਚੋਣ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਛੱਤ ਦਾ ਮੁਲਾਂਕਣ ਅਸੈਂਬਲੀ ਵਜੋਂ ਕੀਤਾ ਜਾਂਦਾ ਹੈ।",
      },
      {
        question: "ਕੀ ਰੰਗ ਆਰਕੀਟੈਕਚਰਲ ਨਤੀਜੇ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਕਰਦਾ ਹੈ?",
        answer:
          "ਹਾਂ। ਛੱਤ ਦਾ ਰੰਗ ਕਲਾਡਿੰਗ, ਟ੍ਰਿਮ, ਪੁੰਜ ਅਤੇ ਗਲੀ ਤੋਂ ਦਿੱਖ ਦੇ ਨਾਲ ਇੰਟਰੈਕਟ ਕਰਦਾ ਹੈ। ਨਮੂਨਿਆਂ ਨੂੰ ਅਸਲ ਇਮਾਰਤ ਦੇ ਵਿਰੁੱਧ ਵਿਚਾਰਿਆ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ, ਨਾ ਕਿ ਸਿਰਫ਼ ਇੱਕ ਸਕ੍ਰੀਨ 'ਤੇ.",
      },
    ],
  },
  "metal-roofing": {
    title: "ਧਾਤੂ ਛੱਤ ਬਦਲਣਾ",
    shortTitle: "ਧਾਤੂ ਬਦਲਣਾ",
    eyebrow: "ਪ੍ਰੀਮੀਅਮ ਧਾਤੂ ਰੀਰੂਫ",
    description: "ਢੁਕਵੀਂ ਢਲਾਣ ਵਾਲੀ ਆਰਕੀਟੈਕਚਰ ਲਈ standing-seam ਜਾਂ ਹੋਰ ਪ੍ਰੀਮੀਅਮ ਧਾਤੂ ਰੀਰੂਫ।",
    definition:
      "ਧਾਤੂ ਛੱਤ ਬਦਲਣਾ ਮੁਲਾਂਕਣ ਤੋਂ ਬਾਅਦ ਇੱਕ ਨਵੀਂ ਧਾਤੂ ਛੱਤ ਪ੍ਰਣਾਲੀ - ਅਕਸਰ standing seam - ਸਥਾਪਿਤ ਕਰਦਾ ਹੈ, ਜਿਸ ਵਿੱਚ ਜਿਓਮੈਟਰੀ, ਸਬਸਟਰੇਟ, ਅੰਡਰਲੇਮੈਂਟ ਅਤੇ ਆਰਕੀਟੈਕਚਰਲ ਇਰਾਦਾ ਸ਼ਾਮਲ ਹੈ।",
    forWhom:
      "ਉਹ ਮਾਲਕ ਜੋ ਢੁਕਵੀਂ ਜਿਓਮੈਟਰੀ, ਆਰਕੀਟੈਕਚਰ ਅਤੇ ਲੰਬੀ-ਮਿਆਦ ਦੀ ਯੋਜਨਾ ਲਈ ਪ੍ਰੀਮੀਅਮ ਧਾਤੂ ਪ੍ਰਣਾਲੀ ਚੁਣਦੇ ਹਨ।",
    warningSigns: [
      "ਢਿੱਲੇ, ਖਰਾਬ ਜਾਂ ਵਿਗੜ ਗਏ ਪੈਨਲ",
      "ਖੋਰ ਜ ਮੁਕੰਮਲ ਟੁੱਟ",
      "ਖੁੱਲ੍ਹੀਆਂ ਸੀਮਾਂ, ਕਮਜ਼ੋਰ ਕਿਨਾਰਿਆਂ ਜਾਂ ਅਸਫਲ ਬੰਦ ਹੋਣ",
      "ਪ੍ਰਵੇਸ਼ ਅਤੇ ਪਰਿਵਰਤਨ ਦੇ ਨੇੜੇ ਪਾਣੀ ਦੇ ਸਬੂਤ",
      "ਅੰਦੋਲਨ ਜਾਂ ਰੌਲੇ ਦੀਆਂ ਚਿੰਤਾਵਾਂ ਜਿਨ੍ਹਾਂ ਲਈ ਸਿਸਟਮ ਮੁਲਾਂਕਣ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ",
    ],
    evaluates: [
      "ਛੱਤ ਦੀ ਢਲਾਣ, ਜਹਾਜ਼ ਦੀ ਲੰਬਾਈ ਅਤੇ ਪੈਨਲ ਲੇਆਉਟ",
      "ਸਬਸਟਰੇਟ ਅਤੇ ਅੰਡਰਲੇਮੈਂਟ ਦੀਆਂ ਲੋੜਾਂ",
      "ਥਰਮਲ ਅੰਦੋਲਨ ਅਤੇ ਬੰਨ੍ਹਣ ਦੀ ਪਹੁੰਚ",
      "ਸਾਈਟ ਲਈ ਬਰਫ਼, ਹਵਾ ਅਤੇ ਡਰੇਨੇਜ ਦੇ ਵਿਚਾਰ",
      "ਕਿਨਾਰਿਆਂ, ਪ੍ਰਵੇਸ਼ ਅਤੇ ਹੋਰ ਸਮੱਗਰੀਆਂ ਵਿੱਚ ਤਬਦੀਲੀ",
    ],
    causes: [
      "ਯੋਜਨਾਬੱਧ ਪ੍ਰਣਾਲੀ ਅਪਗ੍ਰੇਡ",
      "ਮੌਜੂਦਾ ਛੱਤ ਜੀਵਨ-ਅੰਤ",
      "ਡਿਜ਼ਾਈਨ ਮੁਰੰਮਤ",
      "ਧਾਤੂ ਅਸੈਂਬਲੀ ਨਾਲ ਮੇਲ ਖਾਂਦੇ ਪ੍ਰਦਰਸ਼ਨ ਲਕਸ਼",
    ],
    methodology: [
      "ਜਿਓਮੈਟਰੀ ਅਨੁਕੂਲਤਾ ਦੀ ਪੁਸ਼ਟੀ",
      "ਪੈਨਲ ਪ੍ਰਣਾਲੀ ਅਤੇ ਅੰਡਰਲੇਮੈਂਟ ਨਿਰਧਾਰਿਤ ਕਰੋ",
      "ਸਬਸਟਰੇਟ ਤਿਆਰ ਕਰੋ",
      "ਪੈਨਲ ਅਤੇ ਫਲੈਸ਼ਿੰਗ ਪੂਰੀ ਪ੍ਰਣਾਲੀ ਵਜੋਂ ਸਥਾਪਿਤ ਕਰੋ",
      "ਰਿੱਜ, ਕਿਨਾਰੇ ਅਤੇ ਪ੍ਰਵੇਸ਼ਾਂ ਨੂੰ ਜਾਣਬੁੱਝ ਕੇ ਵਿਸਤਾਰ ਦਿਓ",
    ],
    materials: [
      "standing-seam ਜਾਂ ਨਿਰਧਾਰਿਤ ਧਾਤੂ ਪੈਨਲ",
      "ਅੰਡਰਲੇਮੈਂਟ ਪ੍ਰਣਾਲੀਆਂ",
      "ਪ੍ਰਣਾਲੀ ਅਨੁਸਾਰ ਕਲਿੱਪ/ਫਾਸਟਨਰ",
      "ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਕਲੋਜ਼ਰ",
    ],
    bcClimate:
      "ਵੈਸਟ ਕੋਸਟ ਆਰਕੀਟੈਕਚਰ ਅਕਸਰ standing-seam ਧਾਤ ਨਾਲ ਚੰਗਾ ਮੇਲ ਖਾਂਦਾ ਹੈ, ਪਰ ਗੀਲੇ ਮੌਸਮ ਵਿੱਚ ਅਸਲ ਪ੍ਰਦਰਸ਼ਨ ਅੰਡਰਲੇਮੈਂਟ, ਹਵਾਦਾਰੀ ਅਤੇ ਵੇਰਵੇ ਤੋਂ ਨਿਰਭਰ ਕਰਦਾ ਹੈ।",
    whenAppropriate: "ਜਦੋਂ ਧਾਤੂ ਚੁਣੀ ਗਈ ਪ੍ਰਣਾਲੀ ਹੈ ਅਤੇ ਸਕੋਪ ਪੂਰੀ ਰੀਰੂਫ ਹੈ।",
    whenOtherService:
      "ਜੇ ਮੌਜੂਦਾ ਧਾਤੂ ਛੱਤ ਹੋਰ ਨਹੀਂ ਤਾਂ ਸਿਹਤਮੰਦ ਹੈ ਤਾਂ ਕੰਪੋਨੈਂਟ ਮੁਰੰਮਤ ਅਜੇ ਵੀ ਢੁਕਵੀਂ ਹੋ ਸਕਦੀ ਹੈ।",
    process: [
      "ਜਿਓਮੈਟਰੀ ਅਤੇ ਪ੍ਰਣਾਲੀ ਅਨੁਕੂਲਤਾ ਦੀ ਪੁਸ਼ਟੀ",
      "ਪੈਨਲ ਪ੍ਰੋਫਾਈਲ, ਅੰਡਰਲੇਮੈਂਟ ਅਤੇ ਵੇਰਵੇ ਨਿਰਧਾਰਿਤ ਕਰੋ",
      "ਡਿਜ਼ਾਈਨ ਫੈਸਲਿਆਂ ਨਾਲ ਲਿਖਤ ਸਕੋਪ",
      "ਸਬਸਟਰੇਟ ਤਿਆਰੀ ਅਤੇ ਪੈਨਲ ਸਥਾਪਨਾ",
      "ਵੇਰਵੇ ਸਮੀਖਿਆ ਅਤੇ ਪੂਰਤੀ ਵਾਕਥਰੂ",
    ],
    solutionCategories: [
      {
        title: "standing-seam ਪ੍ਰਣਾਲੀਆਂ",
        body: "ਨਿਰਧਾਰਿਤ ਹੋਣ 'ਤੇ ਛੁਪੇ ਫਾਸਟਨਿੰਗ ਵਾਲੇ ਪ੍ਰੀਮੀਅਮ ਪੈਨਲ ਸੁਹਜ।",
      },
      {
        title: "ਅੰਡਰਲੇਮੈਂਟ ਅਤੇ ਸਬਸਟਰੇਟ ਤਿਆਰੀ",
        body: "ਧਾਤ ਦੇ ਹੇਠਾਂ ਵਾਟਰ-ਸ਼ੈੱਡਿੰਗ ਬੁਨਿਆਦ ਬਣਾਓ।",
      },
      {
        title: "ਆਰਕੀਟੈਕਚਰਲ ਵੇਰਵਾ",
        body: "ਕਿਨਾਰੇ, ਵਾਦੀਆਂ ਅਤੇ ਕੰਧਾਂ ਪ੍ਰਦਰਸ਼ਨ ਅਤੇ ਦਿੱਖ ਦੋਵਾਂ ਲਈ ਵਿਸਤਾਰ।",
      },
    ],
    repairVsReplace: {
      repair: "ਜਦੋਂ ਪੈਨਲ ਸੇਵਾਯੋਗ ਹੋਣ ਤਾਂ ਮੌਜੂਦਾ ਧਾਤੂ ਦੀ ਮੁਰੰਮਤ।",
      replace: "ਜਦੋਂ ਨਵੀਂ ਧਾਤੂ ਪ੍ਰਣਾਲੀ ਪ੍ਰੋਜੈਕਟ ਲਕਸ਼ ਹੈ ਜਾਂ ਪੁਰਾਣਾ ਢੱਕਣ ਖਤਮ ਹੋ ਚੁੱਕਾ ਹੈ।",
    },
    scopeFactors: [
      "ਛੱਤ ਖੇਤਰ ਅਤੇ ਜਿਓਮੈਟਰੀ",
      "ਪੈਨਲ ਪ੍ਰੋਫਾਈਲ",
      "ਅੰਡਰਲੇਮੈਂਟ ਚੋਣ",
      "ਪਹੁੰਚ",
      "ਪ੍ਰਵੇਸ਼ ਜਟਿਲਤਾ",
    ],
    publicPriceHint:
      "ਧਾਤੂ ਰੀਰੂਫ ਕੀਮਤ ਛੱਤ ਜਿਓਮੈਟਰੀ, ਪੈਨਲ ਪ੍ਰੋਫਾਈਲ, ਅੰਡਰਲੇਮੈਂਟ ਰਣਨੀਤੀ ਅਤੇ ਪ੍ਰਵੇਸ਼ ਜਟਿਲਤਾ 'ਤੇ ਨਿਰਭਰ ਕਰਦੀ ਹੈ। ਲਿਖਤ ਸਕੋਪ ਲਈ ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਧਾਤੂ ਛੱਤ ਬਦਲਣਾ ਕੀ ਹੈ?",
        answer:
          "ਧਾਤੂ ਛੱਤ ਬਦਲਣਾ ਮੁਲਾਂਕਣ ਤੋਂ ਬਾਅਦ ਇੱਕ ਨਵੀਂ ਧਾਤੂ ਛੱਤ ਪ੍ਰਣਾਲੀ - ਅਕਸਰ standing seam - ਸਥਾਪਿਤ ਕਰਦਾ ਹੈ, ਜਿਸ ਵਿੱਚ ਜਿਓਮੈਟਰੀ, ਸਬਸਟਰੇਟ, ਅੰਡਰਲੇਮੈਂਟ ਅਤੇ ਆਰਕੀਟੈਕਚਰਲ ਇਰਾਦਾ ਸ਼ਾਮਲ ਹੈ।",
      },
      {
        question: "ਕੀ ਧਾਤੂ ਛੱਤ ਮੀਂਹ ਵਿੱਚ ਸ਼ੋਰ ਕਰਦੀ ਹੈ?",
        answer:
          "ਠੋਸ ਡੈਕਿੰਗ, ਅੰਡਰਲੇਮੈਂਟ ਅਤੇ ਹੇਠਾਂ ਇੰਸੂਲੇਸ਼ਨ ਵਾਲੀ ਰਿਹਾਇਸ਼ੀ ਰੀਰੂਫ 'ਤੇ ਮੀਂਹ ਦਾ ਸ਼ੋਰ ਜ਼ਿਆਦਾਤਰ ਉਮੀਦ ਨਾਲੋਂ ਬਹੁਤ ਘੱਟ ਹੁੰਦਾ ਹੈ - ਤੇਜ਼ ਸ਼ੋਰ ਆਮ ਤੌਰ 'ਤੇ ਖੁੱਲ੍ਹੇ ਫਰੇਮਿੰਗ ਉੱਤੇ ਪੈਨਲਾਂ ਨਾਲ ਜੁੜਦਾ ਹੈ। ਧੁਨੀ ਉਮੀਦਾਂ ਪ੍ਰਣਾਲੀ ਚੋਣ ਦੌਰਾਨ ਚਰਚਾ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
      },
      {
        question: "standing seam ਬਨਾਮ exposed-fastener ਧਾਤ: ਕੀ ਫਰਕ ਹੈ?",
        answer:
          "standing seam ਕਲਿੱਪਾਂ ਦੇ ਹੇਠਾਂ ਛੁਪੀ ਫਾਸਟਨਿੰਗ ਨਾਲ ਉੱਚੀਆਂ ਸੀਮਾਂ ਵਰਤਦਾ ਹੈ, ਪੈਨਲ ਹਰਕਤ ਦੀ ਆਗਿਆ ਦਿੰਦਾ ਹੈ ਅਤੇ ਗੈਸਕਟ ਵਾਲੇ ਸਕ੍ਰੂ ਮੌਸਮ ਤੋਂ ਬਾਹਰ ਰਹਿੰਦੇ ਹਨ। exposed-fastener ਪੈਨਲ ਘੱਟ ਖਰਚੇ ਹਨ ਪਰ ਲੰਬੀ-ਮਿਆਦੀ ਫਾਸਟਨਰ ਰੱਖ-ਰਖਾਅ ਲੈਂਦੇ ਹਨ। ਪ੍ਰੀਮੀਅਮ ਰਿਹਾਇਸ਼ੀ ਕੰਮ ਲਈ standing seam ਆਮ ਤੌਰ 'ਤੇ ਸਿਫ਼ਾਰਸ਼ ਹੈ।",
      },
      {
        question: "ਕੀ ਧਾਤੂ ਛੱਤ ਮੌਜੂਦਾ ਸ਼ਿੰਗਲਜ਼ ਉੱਤੇ ਲਗਾਈ ਜਾ ਸਕਦੀ ਹੈ?",
        answer:
          "ਕਈ ਵਾਰ ਢਾਂਚਾਗਤ ਤੌਰ 'ਤੇ ਸੰਭਵ, ਪਰ ਟੀਅਰ-ਆਫ ਆਮ ਤੌਰ 'ਤੇ ਪਸੰਦੀਦਾ ਹੈ ਤਾਂ ਜੋ ਡੈੱਕ ਦੀ ਜਾਂਚ, ਸਹੀ ਅੰਡਰਲੇਮੈਂਟ ਅਤੇ ਫਲੈਸ਼ਿੰਗ ਹੋ ਸਕੇ। ਪੁਰਾਣਾ ਢੱਕਣ ਫਸਾਉਣਾ ਬਾਅਦ ਦੀ ਜਾਂਚ ਮੁਸ਼ਕਲ ਬਣਾਉਂਦਾ ਹੈ।",
      },
      {
        question: "ਕੀ ਧਾਤੂ ਛੱਤ ਗੁੰਝਲਦਾਰ ਛੱਤ ਆਕਾਰਾਂ 'ਤੇ ਕੰਮ ਕਰਦੀ ਹੈ?",
        answer:
          "ਹਾਂ, ਪਰ ਜਟਿਲਤਾ ਉੱਥੇ ਜਿੱਤ ਜਾਂ ਹਾਰ ਤੈਅ ਕਰਦੀ ਹੈ: ਹਿਪ, ਵਾਦੀਆਂ, ਡੋਰਮਰ ਅਤੇ ਡੈੱਡ-ਐਂਡ ਵੇਰਵਿਆਂ ਲਈ ਕੁਸ਼ਲ ਧਾਤ ਕਾਰੀਗਰੀ ਚਾਹੀਦੀ ਹੈ ਅਤੇ ਖਰਚਾ ਵਧਦਾ ਹੈ। ਜਿਓਮੈਟਰੀ ਸਮੀਖਿਆ ਪਹਿਲਾ ਕਦਮ ਹੈ।",
      },
    ],
  },
  "flat-roofing": {
    title: "ਫਲੈਟ ਛੱਤ ਬਦਲਣਾ: SBS / TPO / PVC",
    shortTitle: "ਫਲੈਟ ਛੱਤ ਬਦਲਣਾ",
    eyebrow: "ਘੱਟ-ਢਲਾਨ ਰੀਰੂਫ",
    description:
      "SBS, TPO, PVC ਜਾਂ ਹੋਰ ਨਿਰਧਾਰਿਤ ਝਿੱਲੀ ਪ੍ਰਣਾਲੀਆਂ ਨਾਲ ਪੂਰੀ ਰਿਹਾਇਸ਼ੀ ਜਾਂ ਵਪਾਰਕ ਘੱਟ-ਢਲਾਨ ਰੀਰੂਫ।",
    definition:
      "ਫਲੈਟ ਛੱਤ ਬਦਲਣਾ ਘੱਟ-ਢਲਾਨ ਛੱਤ ਅਸੈਂਬਲੀ ਹਟਾਉਂਦਾ ਜਾਂ ਰੀਕਵਰ ਕਰਦਾ ਹੈ ਅਤੇ ਡਰੇਨੇਜ, ਸਬਸਟਰੇਟ ਅਤੇ ਪ੍ਰੋਜੈਕਟ ਲੋੜਾਂ ਲਈ ਚੁਣੀ ਨਵੀਂ ਝਿੱਲੀ ਪ੍ਰਣਾਲੀ ਸਥਾਪਿਤ ਕਰਦਾ ਹੈ।",
    forWhom:
      "ਵਾਰ-ਵਾਰ ਝਿੱਲੀ ਅਸਫਲਤਾਵਾਂ, ਗਿੱਲਾ ਇੰਸੂਲੇਸ਼ਨ, ਪੁਰਾਣੀਆਂ ਪ੍ਰਣਾਲੀਆਂ ਜਾਂ ਘੱਟ-ਢਲਾਨ ਛੱਤਾਂ 'ਤੇ ਤਾਲਮੇਲ ਵਾਲੇ ਬਾਹਰੀ ਮੁਰੰਮਤ ਵਾਲੇ ਮਾਲਕ।",
    warningSigns: [
      "ਕਈ ਝਿੱਲੀ ਅਸਫਲਤਾਵਾਂ",
      "ਗਿੱਲਾ ਇੰਸੂਲੇਸ਼ਨ",
      "ਪੁਰਾਣੀ ਜਾਂ ਸੇਵਾ-ਯੋਗ ਨਹੀਂ ਪ੍ਰਣਾਲੀ",
      "ਤਾਲਮੇਲ ਵਾਲੀ ਬਾਹਰੀ ਮੁਰੰਮਤ",
      "ਲਗਾਤਾਰ ਪਾਣੀ ਭਰਨ ਨਾਲ ਸਿਸਟਮ-ਵਿਆਪਕ ਘਿਸਾਈ",
    ],
    evaluates: [
      "ਢਲਾਨ ਅਤੇ ਡਰੇਨੇਜ ਮਾਰਗ",
      "ਝਿੱਲੀ ਖੇਤਰ, ਸੀਮ ਅਤੇ ਸਮਾਪਤੀ",
      "ਨਾਲੀਆਂ, ਸਕੂਪਰ ਅਤੇ ਓਵਰਫਲੋ ਪ੍ਰਬੰਧ",
      "ਪੈਰਾਪੇਟਸ, ਕਰਬਸ, ਪ੍ਰਵੇਸ਼ ਅਤੇ ਪਰਿਵਰਤਨ",
      "ਪ੍ਰਤੱਖ ਸਬਸਟਰੇਟ ਜਾਂ ਨਮੀ ਦੀਆਂ ਚਿੰਤਾਵਾਂ",
    ],
    causes: [
      "ਝਿੱਲੀ ਜੀਵਨ-ਅੰਤ",
      "ਇੰਸੂਲੇਸ਼ਨ ਸੰਤ੍ਰਿਪਤੀ",
      "ਡਰੇਨੇਜ ਡਿਜ਼ਾਈਨ ਸੀਮਾਵਾਂ",
      "UV ਅਤੇ ਥਰਮਲ ਬੁਢਾਪਾ",
      "ਜਮ੍ਹਾ ਹੋਏ ਵੇਰਵੇ ਅਸਫਲਤਾਵਾਂ",
    ],
    methodology: [
      "ਗਿੱਲੇ ਕੰਪੋਨੈਂਟ ਸਮੇਤ ਅਸੈਂਬਲੀ ਮੁਲਾਂਕਣ",
      "ਪ੍ਰੋਜੈਕਟ ਲਈ ਝਿੱਲੀ ਰਣਨੀਤੀ ਚੁਣੋ",
      "ਨਿਰਧਾਰਿਤ ਅਨੁਸਾਰ ਹਟਾਓ ਜਾਂ ਰੀਕਵਰ ਕਰੋ",
      "ਕ੍ਰਮ ਵਿੱਚ ਇੰਸੂਲੇਸ਼ਨ ਅਤੇ ਝਿੱਲੀ ਪਰਤਾਂ ਸਥਾਪਿਤ ਕਰੋ",
      "ਡਰੇਨ, ਪੈਰਾਪੇਟ ਅਤੇ ਪ੍ਰਵੇਸ਼ਾਂ ਨੂੰ ਪ੍ਰਣਾਲੀ ਵਜੋਂ ਵਿਸਤਾਰ ਦਿਓ",
    ],
    materials: [
      "SBS, TPO, PVC ਜਾਂ ਹੋਰ ਨਿਰਧਾਰਿਤ ਝਿੱਲੀਆਂ",
      "ਸਕੋਪ ਅਨੁਸਾਰ ਇੰਸੂਲੇਸ਼ਨ ਅਤੇ ਕਵਰ ਬੋਰਡ",
      "ਡਰੇਨ ਅਤੇ ਫਲੈਸ਼ਿੰਗ ਐਕਸੈਸਰੀਜ਼",
      "ਪ੍ਰਣਾਲੀ-ਅਨੁਕੂਲ ਐਡਹੀਸਿਵ, ਫਾਸਟਨਰ ਜਾਂ ਹੀਟ ਪ੍ਰਕਿਰਿਆਵਾਂ",
    ],
    bcClimate:
      "ਮੀਂਹ ਵਾਲੇ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਵਿੱਚ ਘੱਟ-ਢਲਾਨ ਛੱਤਾਂ ਲਈ ਡਰੇਨੇਜ ਡਿਜ਼ਾਈਨ ਅਤੇ ਮਜ਼ਬੂਤ ਝਿੱਲੀ ਵੇਰਵੇ ਮਾਰਕੀਟਿੰਗ ਲੇਬਲਾਂ ਨਾਲੋਂ ਵਧੇਰੇ ਮਹੱਤਵਪੂਰਨ ਹਨ।",
    whenAppropriate:
      "ਜਦੋਂ ਘੱਟ-ਢਲਾਨ ਅਸੈਂਬਲੀ ਖਤਮ ਹੋ ਚੁੱਕੀ ਹੈ ਜਾਂ ਵਿਆਪਕ ਪ੍ਰੋਜੈਕਟ ਦਾ ਹਿੱਸਾ ਨਵੀਨੀਕਰਨ ਹੈ।",
    whenOtherService: "ਹੋਰ ਨਹੀਂ ਤਾਂ ਸਿਹਤਮੰਦ ਪ੍ਰਣਾਲੀ 'ਤੇ ਸਥਾਨਕ ਝਿੱਲੀ ਮੁਰੰਮਤ ਅਜੇ ਵੀ ਸੰਭਵ ਹੋ ਸਕਦੀ ਹੈ।",
    process: [
      "ਲੋੜ ਹੋਣ 'ਤੇ ਨਮੀ ਜਾਂਚ ਸਮੇਤ ਅਸੈਂਬਲੀ ਮੁਲਾਂਕਣ",
      "ਝਿੱਲੀ ਪ੍ਰਣਾਲੀ ਚੋਣ ਅਤੇ ਲਿਖਤ ਸਕੋਪ",
      "ਨਿਰਧਾਰਿਤ ਅਨੁਸਾਰ ਮੌਜੂਦਾ ਅਸੈਂਬਲੀ ਹਟਾਉਣਾ ਜਾਂ ਰੀਕਵਰ",
      "ਕ੍ਰਮ ਵਿੱਚ ਇੰਸੂਲੇਸ਼ਨ ਅਤੇ ਝਿੱਲੀ ਸਥਾਪਨਾ",
      "ਡਰੇਨ, ਪੈਰਾਪੇਟ ਅਤੇ ਪ੍ਰਵੇਸ਼ ਵੇਰਵੇ ਸਮੀਖਿਆ",
    ],
    solutionCategories: [
      {
        title: "ਝਿੱਲੀ ਪ੍ਰਣਾਲੀ ਚੋਣ",
        body: "SBS, TPO, PVC ਜਾਂ ਹੋਰ ਨਿਰਧਾਰਿਤ ਅਸੈਂਬਲੀ ਪ੍ਰੋਜੈਕਟ ਸਥਿਤੀਆਂ ਲਈ ਚੁਣੋ।",
      },
      {
        title: "ਅਸੈਂਬਲੀ ਬਦਲਣਾ",
        body: "ਮਨਜ਼ੂਰ ਸਕੋਪ ਅਨੁਸਾਰ ਝਿੱਲੀ ਅਤੇ ਸੰਬੰਧਿਤ ਪਰਤਾਂ ਨੂੰ ਸੰਬੋਧਿਤ ਕਰੋ।",
      },
      {
        title: "ਡਰੇਨੇਜ ਅਤੇ ਵੇਰਵਾ",
        body: "ਡਰੇਨ, ਪੈਰਾਪੇਟ ਅਤੇ ਪ੍ਰਵੇਸ਼ਾਂ ਨੂੰ ਮੁੱਖ ਵਾਟਰਪ੍ਰੂਫਿੰਗ ਕੰਮ ਵਜੋਂ ਵਿਵੇਚਿਤ ਕਰੋ।",
      },
    ],
    repairVsReplace: {
      repair: "ਮੁਰੰਮਤ ਜੇ ਝਿੱਲੀ ਫੀਲਡ ਅਜੇ ਵੀ ਸੇਵਾਯੋਗ ਹੈ।",
      replace: "ਪੂਰਾ ਘੱਟ-ਢਲਾਨ ਬਦਲਣਾ ਜਦੋਂ ਪ੍ਰਣਾਲੀ ਖਤਮ ਹੋ ਚੁੱਕੀ ਹੈ।",
    },
    scopeFactors: [
      "ਖੇਤਰ ਅਤੇ ਜਿਓਮੈਟਰੀ",
      "ਝਿੱਲੀ ਕਿਸਮ",
      "ਇੰਸੂਲੇਸ਼ਨ ਲੋੜਾਂ",
      "ਪ੍ਰਵੇਸ਼ ਘਣਤਾ",
      "ਪਹੁੰਚ ਅਤੇ ਨਿਪਟਾਰਾ",
    ],
    publicPriceHint:
      "ਘੱਟ-ਢਲਾਨ ਬਦਲਣ ਦੀ ਕੀਮਤ ਖੇਤਰ, ਝਿੱਲੀ ਚੋਣ, ਇੰਸੂਲੇਸ਼ਨ, ਡਰੇਨੇਜ ਕੰਮ ਅਤੇ ਪ੍ਰਵੇਸ਼ ਘਣਤਾ 'ਤੇ ਨਿਰਭਰ ਕਰਦੀ ਹੈ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "SBS, TPO ਜਾਂ PVC ਨਾਲ ਫਲੈਟ ਛੱਤ ਬਦਲਣਾ ਕੀ ਹੈ?",
        answer:
          "ਫਲੈਟ ਛੱਤ ਬਦਲਣਾ ਘੱਟ-ਢਲਾਨ ਛੱਤ ਅਸੈਂਬਲੀ ਹਟਾਉਂਦਾ ਜਾਂ ਰੀਕਵਰ ਕਰਦਾ ਹੈ ਅਤੇ ਡਰੇਨੇਜ, ਸਬਸਟਰੇਟ ਅਤੇ ਪ੍ਰੋਜੈਕਟ ਲੋੜਾਂ ਲਈ ਚੁਣੀ ਨਵੀਂ ਝਿੱਲੀ ਪ੍ਰਣਾਲੀ ਸਥਾਪਿਤ ਕਰਦਾ ਹੈ।",
      },
      {
        question: "SBS, TPO ਜਾਂ PVC: ਕਿਹੜੀ ਝਿੱਲੀ ਸਭ ਤੋਂ ਵਧੀਆ?",
        answer:
          "ਕੋਈ ਵੀ ਹਰ ਪ੍ਰੋਜੈਕਟ ਲਈ ਵਧੀਆ ਨਹੀਂ। ਦੋ-ਪਲਾਈ SBS ਇੱਕ ਮਜ਼ਬੂਤ ਖੇਤਰੀ ਵਿਕਲਪ ਹੈ; TPO ਅਤੇ PVC ਗਰਮ-ਵੈਲਡਡ ਸੀਮਾਂ ਵਾਲੀਆਂ ਸਿੰਗਲ-ਪਲਾਈ ਪ੍ਰਣਾਲੀਆਂ ਹਨ। ਸਬਸਟਰੇਟ, ਡਰੇਨੇਜ ਅਤੇ ਛੱਤ ਦੀ ਵਰਤੋਂ ਫੈਸਲਾ ਕਰਦੇ ਹਨ।",
      },
      {
        question: "ਕੀ ਮੌਜੂਦਾ ਫਲੈਟ ਛੱਤ tear-off ਕਰਨੀ ਚਾਹੀਦੀ ਹੈ ਜਾਂ recover?",
        answer:
          "recover ਖਰਚ ਬਚਾ ਸਕਦਾ ਹੈ ਜਦੋਂ ਮੌਜੂਦਾ ਅਸੈਂਬਲੀ ਸੁੱਕੀ ਅਤੇ ਸਿਹਤਮੰਦ ਹੈ, ਪਰ ਗਿੱਲਾ ਇੰਸੂਲੇਸ਼ਨ ਜਾਂ ਕਈ ਮੌਜੂਦਾ ਪਰਤਾਂ tear-off ਨੂੰ ਸਹੀ ਰਸਤਾ ਬਣਾਉਂਦੀਆਂ ਹਨ। ਫੈਸਲੇ ਤੋਂ ਪਹਿਲਾਂ ਨਮੀ ਜਾਂਚ ਸੁਰੱਖਿਆ ਦਿੰਦੀ ਹੈ।",
      },
      {
        question: "ਫਲੈਟ ਛੱਤ ਬਦਲਣਾ ਕਿੰਨਾ disruptive ਹੈ?",
        answer:
          "ਸ਼ੋਰ, torch ਜਾਂ adhesive ਕੰਮ ਦੌਰਾਨ ਗੰਧ, ਅਤੇ ਸੁਰੱਖਿਅਤ ਪਹੁੰਚ ਦੀ ਉਮੀਦ ਕਰੋ। ਆਮ ਤੌਰ 'ਤੇ ਮਕਾਨ ਮਾਲਕ ਰਹਿ ਸਕਦੇ ਹਨ; ਲਿਖਤ ਸਕੋਪ sequencing ਅਤੇ ਸੁਰੱਖਿਆ ਪਹਿਲਾਂ ਤੈਅ ਕਰਦਾ ਹੈ।",
      },
      {
        question: "ਕੀ ਬਦਲਣ ਦੌਰਾਨ ਡਰੇਨੇਜ ਸੁਧਾਰਿਆ ਜਾ ਸਕਦਾ ਹੈ?",
        answer:
          "ਹਾਂ - chronic ponding ਠੀਕ ਕਰਨ ਲਈ tapered insulation, ਨਵੇਂ ਡਰੇਨ ਜਾਂ scupper ਕੰਮ ਨਵੀਂ ਅਸੈਂਬਲੀ ਵਿੱਚ ਡਿਜ਼ਾਈਨ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ।",
      },
    ],
  },
  "roof-inspection-maintenance": {
    title: "ਛੱਤ ਸਿਹਤ ਜਾਂਚ + ਰੱਖ-ਰਖਾਅ",
    shortTitle: "ਸਿਹਤ ਜਾਂਚ",
    eyebrow: "ਪਹਿਲਾਂ ਸਥਿਤੀ",
    description: "ਨਿਰੀਖਣ, ਫੋਟੋ, ਛੋਟਾ ਸੀਲੈਂਟ ਜਾਂ ਰੱਖ-ਰਖਾਅ ਕੰਮ ਅਤੇ ਸੂਚਿਤ ਯੋਜਨਾ ਲਈ ਛੱਤ ਸਥਿਤੀ ਰਿਪੋਰਟ।",
    definition:
      "ਛੱਤ ਸਿਹਤ ਜਾਂਚ ਢੱਕਣ, ਫਲੈਸ਼ਿੰਗ, ਡਰੇਨੇਜ ਅਤੇ ਪਹੁੰਚਯੋਗ ਸੰਬੰਧਿਤ ਕੰਪੋਨੈਂਟਾਂ ਦਾ ਸੰਰਚਿਤ ਦ੍ਰਿਸ਼ਟੀਗਤ ਮੁਲਾਂਕਣ ਹੈ, ਆਮ ਤੌਰ 'ਤੇ ਫੋਟੋ ਦਸਤਾਵੇਜ਼ੀਕਰਨ ਅਤੇ ਪਹਿਲਾਂ ਸਹਿਮਤ ਸੀਮਤ ਰੱਖ-ਰਖਾਅ ਨਾਲ।",
    forWhom:
      "ਖਰੀਦ/ਵਿਕਰੀ, ਨਵੀਨੀਕਰਨ, ਛੇਤੀ ਚੇਤਾਵਨੀ ਦੇ ਨਿਸ਼ਾਨ, ਜਾਂ ਮੀਂਹ ਦੇ ਮੌਸਮ ਤੋਂ ਪਹਿਲਾਂ ਦਸਤਾਵੇਜ਼ੀ baseline ਚਾਹੁਣ ਵਾਲੇ ਮਾਲਕ।",
    warningSigns: [
      "ਛੱਤ ਦੀ ਉਮਰ ਜਾਂ ਬਾਕੀ ਸਥਿਤੀ ਬਾਰੇ ਅਨਿਸ਼ਚਿਤਤਾ",
      "ਸਪਸ਼ਟ ਸਰੋਤ ਬਿਨਾਂ ਛੋਟੇ ਧੱਬੇ",
      "ਮੌਸਮੀ ਮਲਬਾ ਅਤੇ ਕਾਈ ਜਮ੍ਹਾ",
      "ਪ੍ਰਵੇਸ਼ਾਂ 'ਤੇ ਬੁਢਾਪੇ ਵਾਲਾ ਸੀਲੈਂਟ",
      "ਲਿਖਤ ਯੋਜਨਾ baseline ਦੀ ਲੋੜ",
    ],
    evaluates: [
      "ਸਤ੍ਹਾ ਅਨੁਸਾਰ ਢੱਕਣ ਦੀ ਸਥਿਤੀ",
      "ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਪ੍ਰਵੇਸ਼",
      "ਡਰੇਨੇਜ ਅਤੇ ਗਟਰ ਇੰਟਰਫੇਸ",
      "ਦਿਖਾਈ ਦੇਣ ਵਾਲੇ ਹਵਾਦਾਰੀ ਕੰਪੋਨੈਂਟ",
      "ਰੱਖ-ਰਖਾਅ ਬਨਾਮ ਮੁਰੰਮਤ ਤਰਜੀਹ",
    ],
    causes: [
      "ਦਸਤਾਵੇਜ਼ੀਕਰਨ ਬਿਨਾਂ ਸਧਾਰਨ ਬੁਢਾਪਾ",
      "ਮੁਲਤਵੀ ਰੱਖ-ਰਖਾਅ",
      "ਸਾਈਟ-ਵਿਸ਼ੇਸ਼ ਮੌਸਮੀ ਐਕਸਪੋਜ਼ਰ",
      "ਅਗਿਆਤ ਗੁਣਵੱਤਾ ਵਾਲਾ ਪਿਛਲਾ ਕੰਮ",
      "ਖਰੀਦਦਾਰ ਜਾਂ ਨਵੀਨੀਕਰਨ ਫੈਸਲੇ ਦੀ ਲੋੜ",
    ],
    methodology: [
      "ਚਿੰਤਾਵਾਂ ਅਤੇ ਉਪਲਬਧ ਇਤਿਹਾਸ ਦੀ ਸਮੀਖਿਆ",
      "ਬਾਹਰੀ ਛੱਤ ਜ਼ੋਨਾਂ ਦਾ ਸਿਸਟਮੈਟਿਕ ਨਿਰੀਖਣ",
      "ਨਮੂਨਾਤਮਕ ਸਥਿਤੀਆਂ ਦੀਆਂ ਫੋਟੋ",
      "ਸਿਰਫ ਸਹਿਮਤ ਛੋਟੀ ਰੱਖ-ਰਖਾਅ ਪੂਰੀ ਕਰੋ",
      "ਸਪਸ਼ਟ ਸਥਿਤੀ ਸਾਰ ਅਤੇ ਵਿਕਲਪ ਭੇਜੋ",
    ],
    materials: [
      "ਫੋਟੋ ਦਸਤਾਵੇਜ਼ੀਕਰਨ",
      "ਸ਼ਾਮਲ ਹੋਣ 'ਤੇ ਛੋਟਾ ਸੀਲੈਂਟ ਜਾਂ ਫਾਸਟਨਰ",
      "ਸਕੋਪ ਵਿੱਚ ਸੀਮਤ ਮਲਬਾ ਸਫਾਈ",
      "ਲਿਖਤ ਸਥਿਤੀ ਨੋਟ",
    ],
    bcClimate:
      "ਮੌਸਮੀ ਮੀਂਹ ਸਰਦੀਆਂ ਤੋਂ ਪਹਿਲਾਂ ਅਤੇ ਤੂਫਾਨਾਂ ਤੋਂ ਬਾਅਦ ਸਿਹਤ ਜਾਂਚਾਂ ਨੂੰ ਲਾਭਦਾਇਕ ਬਣਾਉਂਦਾ ਹੈ - ਰੁਕੀ ਡrerਨੇਜ, ਉੱਠੀ ਸਮੱਗਰੀ ਅਤੇ ਛੇਤੀ ਫਲੈਸ਼ਿੰਗ ਅਸਫਲਤਾ।",
    whenAppropriate: "ਜਦੋਂ ਮੁਰੰਮਤ, ਬਦਲਣ ਜਾਂ ਹੋਰ ਜਾਂਚ ਤੋਂ ਪਹਿਲਾਂ ਸਪਸ਼ਟਤਾ ਚਾਹੀਦੀ ਹੈ।",
    whenOtherService:
      "ਸਰਗਰਮ ਵੱਡੇ ਲੀਕ ਜਾਂ ਤੂਫਾਨ ਖੁੱਲ੍ਹਣ ਐਮਰਜੈਂਸੀ ਜਾਂ ਮੁਰੰਮਤ ਮਾਰਗਾਂ ਵੱਲ ਜਾਣੇ ਚਾਹੀਦੇ ਹਨ।",
    process: [
      "ਸਿਹਤ ਜਾਂਚ ਬੁੱਕ ਕਰੋ ਅਤੇ ਚਿੰਤਾਵਾਂ ਦੱਸੋ",
      "ਫੋਟੋ ਦਸਤਾਵੇਜ਼ੀਕਰਨ ਨਾਲ ਸਿਸਟਮੈਟਿਕ ਬਾਹਰੀ ਨਿਰੀਖਣ",
      "ਵਿਜ਼ਿਟ ਦੌਰਾਨ ਸਹਿਮਤ ਛੋਟੀ ਰੱਖ-ਰਖਾਅ",
      "ਤਰਜੀਹਾਂ ਨਾਲ ਲਿਖਤ ਸਥਿਤੀ ਸਾਰ",
      "ਸਿਫ਼ਾਰਸ਼ੀ ਮੁਰੰਮਤਾਂ 'ਤੇ ਫਾਲੋ-ਅੱਪ",
    ],
    solutionCategories: [
      {
        title: "ਦਸਤਾਵੇਜ਼ੀ ਨਿਰੀਖਣ",
        body: "ਛੱਤ ਅਸੈਂਬਲੀ 'ਤੇ ਦਿਖਾਈ ਅਤੇ ਪਹੁੰਚਯੋਗ ਕੀ ਹੈ ਉਸਦੀ ਸੰਰਚਿਤ ਸਮੀਖਿਆ।",
      },
      {
        title: "ਛੋਟੀ ਰੱਖ-ਰਖਾਅ",
        body: "ਸਿਰਫ ਜਦੋਂ ਸ਼ਾਮਲ ਅਤੇ ਢੁਕਵਾਂ ਹੋਵੇ - ਸੀਮਤ ਸੀਲੈਂਟ ਜਾਂ ਮਲਬਾ ਕੰਮ।",
      },
      {
        title: "ਯੋਜਨਾ ਸਾਰ",
        body: "ਤੁਰੰਤ ਚਿੰਤਾਵਾਂ ਨੂੰ ਮੱਧਮ-ਮਿਆਦੀ ਨਿਗਰਾਨੀ ਤੋਂ ਅਲੱਗ ਕਰੋ।",
      },
    ],
    repairVsReplace: {
      repair: "ਕਈ ਨਤੀਜੇ ਰੱਖ-ਰਖਾਅ ਜਾਂ ਸਥਾਨਕ ਮੁਰੰਮਤ ਹਨ, ਪੂਰੀ ਬਦਲੀ ਟrigger ਨਹੀਂ।",
      replace: "ਬਦਲੀ ਸਿਰਫ ਤਾਂ ਚਰਚਾ ਹੁੰਦੀ ਹੈ ਜਦੋਂ ਦੇਖੀ ਸਥਿਤੀ ਵਿਆਪਕ ਮਾਰਗ ਦਾ ਸਮਰਥਨ ਕਰੇ।",
    },
    scopeFactors: [
      "ਛੱਤ ਦਾ ਆਕਾਰ ਅਤੇ ਜਟਿਲਤਾ",
      "ਪਹੁੰਚ",
      "ਫੋਟੋ ਦਸਤਾਵੇਜ਼ੀ ਡੂੰਘਾਈ",
      "ਸ਼ਾਮਲ ਰੱਖ-ਰਖਾਅ ਆਈਟਮ",
      "ਜਾਇਦਾਦ 'ਤੇ ਛੱਤ ਪ੍ਰਣਾਲੀਆਂ ਦੀ ਗਿਣਤੀ",
    ],
    publicPriceHint:
      "ਸਿਹਤ ਜਾਂਚ ਸਕੋਪ ਛੱਤ ਦੇ ਆਕਾਰ, ਜਟਿਲਤਾ, ਪਹੁੰਚ ਅਤੇ ਕਿੰਨਾ ਦਸਤਾਵੇਜ਼ੀਕਰਨ/ਛੋਟੀ ਰੱਖ-ਰਖਾਅ ਸ਼ਾਮਲ ਹੈ ਉੱਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਛੱਤ ਸਿਹਤ ਜਾਂਚ + ਰੱਖ-ਰਖਾਅ ਕੀ ਹੈ?",
        answer:
          "ਛੱਤ ਸਿਹਤ ਜਾਂਚ ਢੱਕਣ, ਫਲੈਸ਼ਿੰਗ, ਡਰੇਨੇਜ ਅਤੇ ਪਹੁੰਚਯੋਗ ਸੰਬੰਧਿਤ ਕੰਪੋਨੈਂਟਾਂ ਦਾ ਸੰਰਚਿਤ ਦ੍ਰਿਸ਼ਟੀਗਤ ਮੁਲਾਂਕਣ ਹੈ, ਆਮ ਤੌਰ 'ਤੇ ਫੋਟੋ ਦਸਤਾਵੇਜ਼ੀਕਰਨ ਅਤੇ ਪਹਿਲਾਂ ਸਹਿਮਤ ਸੀਮਤ ਰੱਖ-ਰਖਾਅ ਨਾਲ।",
      },
      {
        question: "ਛੱਤ ਦੀ ਕਿੰਨੀ ਵਾਰ ਜਾਂਚ ਕਰਵਾਉਣੀ ਚਾਹੀਦੀ ਹੈ?",
        answer:
          "ਇੱਕ ਉਪਯੋਗੀ ਖੇਤਰੀ ਲੈ ਪਤਝੜ ਦੇ ਮੀਂਹ ਤੋਂ ਪਹਿਲਾਂ ਜਾਂਚ, ਅਤੇ ਕਿਸੇ ਵੱਡੇ ਤੂਫਾਨ ਤੋਂ ਬਾਅਦ। ਭਾਰੀ ਰੁੱਖਾਂ ਹੇਠਲੇ ਘਰ ਜਾਂ ਉਮਰ ਦੇ ਦੂਜੇ ਅੱਧ ਵਿੱਚ ਛੱਤਾਂ ਨੂੰ ਵਧੇਰੇ ਨਿਯਮਿਤ ਧਿਆਨ ਫਾਇਦਾ ਦਿੰਦਾ ਹੈ।",
      },
      {
        question: "ਸਿਹਤ ਜਾਂਚ ਤੋਂ ਬਾਅਦ ਮੈਨੂੰ ਕੀ ਮਿਲਦਾ ਹੈ?",
        answer:
          "ਢੱਕਣ, ਫਲੈਸ਼ਿੰਗ, ਡਰੇਨੇਜ ਅਤੇ ਹਵਾਦਾਰੀ ਦੀ ਫੋਟੋ-ਦਸਤਾਵੇਜ਼ੀ ਸਾਰ, ਤੁਰੰਤ ਮੁਰੰਮਤ, ਨਿਗਰਾਨੀ ਅਤੇ ਸਧਾਰਨ ਘਿਸਾਈ ਵਿੱਚ ਵੰਡੀ - ਇੱਕ ਯੋਜਨਾ ਦਸਤਾਵੇਜ਼।",
      },
      {
        question: "ਕੀ ਘਰ ਖਰੀਦ/ਵਿਕਰੀ ਤੋਂ ਪਹਿਲਾਂ ਛੱਤ ਜਾਂਚ ਕਰਵਾਉਣਾ ਫਾਇਦੇਮੰਦ ਹੈ?",
        answer:
          "ਹਾਂ - ਛੱਤ ਨਵੀਨੀਕਰਨ ਦੇ ਸਭ ਤੋਂ ਮਹਿੰਗੇ ਹਿੱਸਿਆਂ ਵਿੱਚੋਂ ਇੱਕ ਹੈ। ਇਹ ਰੂਫਿੰਗ ਸਥਿਤੀ ਸਮੀਖਿਆ ਹੈ, ਰਸਮੀ ਘਰ ਖਰੀਦ/ਵਿਕਰੀ ਤੋਂ ਪਹਿਲਾਂ ਰਸਮੀ ਨਿਰੀਖਣ ਨਹੀਂ।",
      },
      {
        question: "ਕੀ ਤੁਸੀਂ ਨਿਰੀਖਣ ਦੌਰਾਨ ਮਿਲੀਆਂ ਸਮੱਸਿਆਵਾਂ ਠੀਕ ਕਰਦੇ ਹੋ?",
        answer:
          "ਛੋਟੀਆਂ ਸਹਿਮਤ ਰੱਖ-ਰਖਾਅ - ਜਿਵੇਂ ਪ੍ਰਵੇਸ਼ਾਂ 'ਤੇ ਛੋਟਾ ਸੀਲੈਂਟ - ਉਸੇ ਵਿਜ਼ਿਟ ਵਿੱਚ ਹੋ ਸਕਦੀ ਹੈ। ਵੱਡੇ ਨਤੀਜੇ ਦਸਤਾਵੇਜ਼ ਅਤੇ ਅਲੱਗ ਸਕੋਪ ਹੁੰਦੇ ਹਨ।",
      },
    ],
  },
  "flashing-roof-penetration-repair": {
    title: "ਫਲੈਸ਼ਿੰਗ / ਛੱਤ ਪ੍ਰਵੇਸ਼ ਮੁਰੰਮਤ",
    shortTitle: "ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਪ੍ਰਵੇਸ਼",
    eyebrow: "ਟ੍ਰਾਂਜ਼ੀਸ਼ਨ ਅਤੇ ਇੰਟਰਫੇਸ",
    description:
      "ਚਿਮਨੀ, ਕੰਧ, ਵੈਂਟ, ਪਾਈਪ ਬੂਟ ਅਤੇ ਹੋਰ ਛੱਤ ਪ੍ਰਵੇਸ਼ਾਂ 'ਤੇ ਫਲੈਸ਼ਿੰਗ ਮੁਰੰਮਤ ਜਿੱਥੇ ਪਾਣੀ ਅਕਸਰ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਛੱਤਾਂ ਵਿੱਚ ਦਾਖਲ ਹੁੰਦਾ ਹੈ।",
    definition:
      "ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਪ੍ਰਵੇਸ਼ ਮੁਰੰਮਤ ਉਹਨਾਂ ਪਾਣੀ-ਡrerਨੇਜ ਇੰਟਰਫੇਸ ਨੂੰ ਠੀਕ ਕਰਦੀ ਹੈ ਜਿੱਥੇ ਛੱਤ ਢੱਕਣ ਕੰਧ, ਚਿਮਨੀ, ਵੈਂਟ, ਪਾਈਪ ਅਤੇ ਹੋਰ ਪ੍ਰਵੇਸ਼ਾਂ ਨੂੰ ਮਿਲਦਾ ਹੈ। step flashing, counter flashing, ਬੂਟ ਜਾਂ ਸੀਲੈਂਟ ਫੇਲ੍ਹ ਹੋਣ 'ਤੇ ਇਹ ਵੇਰਵੇ ਆਮ ਲੀਕ ਸਰੋਤ ਹਨ।",
    forWhom:
      "ਚਿਮਨੀ, ਸਾਈਡ ਵਾਲ, sewer stack, ਮਕੈਨੀਕਲ ਵੈਂਟ, ਸਕਾਈਲਾਈਟ ਜਾਂ ਹੋਰ ਛੱਤ ਖੁੱਲ੍ਹਾਂ ਦੇ ਨੇੜੇ ਲੀਕ, ਜਾਂ ਪੁਰਾਣੀ ਫਲੈਸ਼ਿੰਗ ਜੋ ਪਾਣੀ ਸਹੀ ਡrerਨੇਜ ਨਹੀਂ ਕਰਦੀ।",
    warningSigns: [
      "ਚਿਮਨੀ chase ਜਾਂ ਬਾਹਰੀ ਕੰਧ ਦੇ ਨੇੜੇ ਧੱਬੇ",
      "ਪ੍ਰਵੇਸ਼ਾਂ 'ਤੇ ਟੁੱਟਿਆ ਜਾਂ ਸਖ਼ਤ ਸੀਲੈਂਟ",
      "step flashing ਜਾਂ counter flashing ਉੱਚੀ, ਜੰਗ ਲੱਗੀ ਜਾਂ ਵੱਖ",
      "ਪੁਰਾਣੇ ਰਬੜ ਪਾਈਪ ਬੂਟ",
      "ਹਵਾ-ਸਹਿਤ ਮੀਂਹ ਵਿੱਚ ਕੰਧ-ਛੱਤ ਜੋੜ 'ਤੇ ਪਾਣੀ",
    ],
    evaluates: [
      "ਫਲੈਸ਼ਿੰਗ ਜਿਓਮੈਟਰੀ ਅਤੇ ਸਮੱਗਰੀ ਦੀ ਸਥਿਤੀ",
      "ਆਲੇ-ਦੁਆਲੇ ਢੱਕਣ ਨਾਲ ਅਨੁਕੂਲਤਾ",
      "counter flashing ਅਤੇ ਕੰਧ ਇੰਟਰਫੇਸ ਦੀ ਇਕਤਾ",
      "ਬੂਟ ਅਤੇ ਪ੍ਰਵੇਸ਼ collar ਦੀ ਸਥਿਤੀ",
      "ਕੀ ਸੀਲੈਂਟ ਫੇਲ੍ਹ ਧਾਤ ਲੁਕਾ ਰਿਹਾ ਹੈ",
    ],
    causes: [
      "ਥਰਮਲ ਮੂਵਮੈਂਟ ਜੋ ਜੋੜ ਖੋਲ੍ਹਦੀ ਹੈ",
      "ਬੂਟ ਅਤੇ ਸੀਲੈਂਟ 'ਤੇ UV/ਮੌਸਮ ਬੁਢਾਪਾ",
      "step/counter flashing ਦੀ ਗਲਤ ਏਕੀਕਰਣ",
      "ਧਾਤ ਖਰਾਬੀ ਜਾਂ ਮਕੈਨੀਕਲ ਨੁਕਸਾਨ",
      "ਪ੍ਰਵੇਸ਼ਾਂ ਨੂੰ ਦੁਬਾਰਾ ਵੇਰਵੇ ਕੀਤੇ ਬਿਨਾਂ ਢੱਕਣ ਬਦਲਣਾ",
    ],
    methodology: [
      "ਖਰਾਬੀ ਜ਼ੋਨ ਵਿੱਚ ਹਰ ਪ੍ਰਵੇਸ਼ ਅਤੇ ਕੰਧ ਇੰਟਰਫੇਸ ਪਛਾਣੋ",
      "ਪਾਣੀ ਦਾ ਮਾਰਗ ਪੱਕਾ ਕਰਨ ਲਈ ਸਿਰਫ ਜ਼ਰੂਰੀ ਖੋਲ੍ਹੋ",
      "ਫੇਲ੍ਹ ਬੂਟ, collar ਜਾਂ ਧਾਤ ਅਨੁਕੂਲ ਵੇਰਵਿਆਂ ਨਾਲ ਬਦਲੋ",
      "ਫਲੈਸ਼ਿੰਗ ਨੂੰ ਢੱਕਣ ਨਾਲ ਸਹੀ ਦੁਬਾਰਾ ਜੋੜੋ",
      "ਸਤਹੀ ਸੀਲੈਂਟ 'ਤੇ ਸਥਾਈ ਵਾਟਰਪ੍ਰੂਫਿੰਗ ਵਜੋਂ ਭਰੋਸਾ ਨਾ ਕਰੋ",
    ],
    materials: [
      "step flashing, counter flashing ਅਤੇ apron",
      "ਪਾਈਪ ਬੂਟ ਅਤੇ ਵੈਂਟ collars",
      "ਗੰਭੀਰ ਇੰਟਰਫੇਸ 'ਤੇ ਅਨੁਕੂਲ underlayment/ice-water membrane",
      "ਸਾਹਿਲੀ ਐਕਸਪੋਜ਼ਰ ਅਤੇ ਨਾਲ ਦੀ ਸਮੱਗਰੀ ਲਈ ਢੁਕਵੀਂ ਧਾਤ",
      "ਸਿਰਫ਼ ਦੂਜੀ ਸੁਰੱਖਿਆ ਵਜੋਂ manufacturer-ਅਨੁਕੂਲ ਸੀਲੈਂਟ",
    ],
    bcClimate:
      "ਹਵਾ-ਸਹਿਤ ਮੀਂਹ ਅਤੇ ਲੰਬਾ ਗੀਲਾ ਮੌਸਮ ਫਲੈਸ਼ਿੰਗ ਅਤੇ elastomeric ਬੂਟਾਂ 'ਤੇ ਦਬਾਅ ਪਾਉਂਦਾ ਹੈ। ਸੁੱਕੀਆਂ ਮੌਸਮਾਂ ਵਿੱਚ ਕੰਮ ਕਰਨ ਵਾਲੇ ਵੇਰਵੇ BC ਤਟ 'ਤੇ ਸਹੀ ਧਾਤ ਏਕੀਕਰਣ ਬਿਨਾਂ ਜਲਦੀ ਫੇਲ੍ਹ ਹੁੰਦੇ ਹਨ।",
    whenAppropriate: "ਜਦੋਂ ਫੀਲਡ ਢੱਕਣ ਸੇਵਾਯੋਗ ਹੈ ਅਤੇ ਲੀਕ ਅਲੱਗ ਫਲੈਸ਼ਿੰਗ/ਪ੍ਰਵੇਸ਼ ਫੇਲ੍ਹ ਤੋਂ ਹੈ।",
    whenOtherService:
      "ਵਿਆਪਕ ਢੱਕਣ ਘਿਸਾਈ, ਜਾਂ ਚਿਮਨੀ/ਸਕਾਈਲਾਈਟ/ਘੱਟ-ਢਲਾਨ ਅਸੈਂਬਲੀ ਨੂੰ ਵੱਖਰਾ ਸਕੋਪ ਚਾਹੀਦਾ ਹੋਵੇ।",
    solutionCategories: [
      { title: "ਪ੍ਰਵੇਸ਼ ਬੂਟ ਬਦਲਣਾ", body: "pipe ਅਤੇ ਵੈਂਟ ਬੂਟ ਫਟਣ ਤੋਂ ਪਹਿਲਾਂ ਪੁਰਾਣੇ ਬੂਟ ਬਦਲੋ।" },
      {
        title: "ਕੰਧ ਅਤੇ step flashing ਮੁਰੰਮਤ",
        body: "ਕੰਧ-ਛੱਤ ਜੋੜ ਜਿੱਥੇ step/counter flashing ਪਾਣੀ ਸਹੀ ਡrerਨੇਜ ਨਹੀਂ ਕਰਦੀ।",
      },
      {
        title: "ਗੁੰਝਲਦਾਰ ਚਿਮਨੀ/ਇੰਟਰਫੇਸ",
        body: "ਬਹੁ-ਪੱਧਰੀ ਫਲੈਸ਼ਿੰਗ ਜਿਨ੍ਹਾਂ ਨੂੰ ਢੱਕਣ ਨਾਲ ਸਹੀ ਕ੍ਰਮ ਚਾਹੀਦਾ ਹੈ।",
      },
    ],
    repairVsReplace: {
      repair: "ਫੀਲਡ ਸਿਹਤਮੰਦ ਹੋਵੇ ਅਤੇ ਫੇਲ੍ਹ ਇੰਟਰਫੇਸ 'ਤੇ ਕੇਂਦਰਿਤ ਹੋਵੇ।",
      replace: "ਜਦੋਂ ਫਲੈਸ਼ਿੰਗ end-of-life ਢੱਕਣ ਵਿੱਚ ਪੂਰੀ ਤਰ੍ਹਾਂ ਦੁਬਾਰਾ ਜੋੜੀ ਜਾਣੀ ਚਾਹੀਦੀ ਹੋਵੇ।",
    },
    scopeFactors: [
      "ਪ੍ਰਵੇਸ਼ ਗਿਣਤੀ/ਕਿਸਮ",
      "ਕੰਧ cladding ਇੰਟਰਫੇਸ",
      "ਧਾਤ ਅਨੁਕੂਲਤਾ",
      "ਚਿਮਨੀ/ਡormer ਪਹੁੰਚ",
      "ਮੌਜੂਦਾ ਢੱਕਣ",
      "ਨਾਲ ਦੀ ਅਸੈਂਬਲੀ ਖੋਲ੍ਹਣ",
    ],
    process: [
      "ਲੀਕ ਸਥਾਨ ਅਤੇ ਦਿਖਾਈ ਵੇਰਵੇ ਦੱਸੋ",
      "ਖਰਾਬੀ ਜ਼ੋਨ ਵਿੱਚ ਛੱਤ 'ਤੇ ਫਲੈਸ਼ਿੰਗ/ਪ੍ਰਵੇਸ਼ ਨਿਰੀਖਣ",
      "ਹਰ ਠੀਕ ਵੇਰਵੇ ਨਾਲ ਲਿਖਤ ਮੁਰੰਮਤ ਸਕੋਪ",
      "ਅਨੁਕੂਲ ਧਾਤ, ਬੂਟ, membrane ਨਾਲ ਦੁਬਾਰਾ ਵੇਰਵਾ",
      "ਠੀਕ ਕੀਤੇ ਇੰਟਰਫੇਸ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਢੱਕਣ ਦੀ ਸਮੀਖਿਆ",
    ],
    publicPriceHint:
      "ਕੀਮਤ ਪ੍ਰਵੇਸ਼ ਗਿਣਤੀ/ਕਿਸਮ, ਕੰਧ ਇੰਟਰਫੇਸ ਜਟਿਲਤਾ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਢੱਕਣ ਖੋਲ੍ਹ/ਦੁਬਾਰਾ ਜੋੜ 'ਤੇ ਨਿਰਭਰ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਫਲੈਸ਼ਿੰਗ / ਛੱਤ ਪ੍ਰਵੇਸ਼ ਮੁਰੰਮਤ ਕੀ ਹੈ?",
        answer:
          "ਢੱਕਣ ਦੇ ਕੰਧ, ਚਿਮਨੀ, ਵੈਂਟ, ਪਾਈਪ ਅਤੇ ਹੋਰ ਪ੍ਰਵੇਸ਼ਾਂ 'ਤੇ ਪਾਣੀ-ਡrerਨੇਜ ਇੰਟਰਫੇਸ ਠੀਕ ਕਰਨਾ। step flashing, counter flashing, ਬੂਟ ਜਾਂ ਸੀਲੈਂਟ ਫੇਲ੍ਹ ਹੋਣ 'ਤੇ ਆਮ ਲੀਕ ਸਰੋਤ।",
      },
      {
        question: "ਕਿਵੇਂ ਪਤਾ ਲਗਾਵਾਂ ਲੀਕ ਫਲੈਸ਼ਿੰਗ ਦੀ ਹੈ?",
        answer:
          "ਚਿਮਨੀ, ਸਾਈਡ ਵਾਲ, ਸਕਾਈਲਾਈਟ, stack ਜਾਂ ਵੈਂਟ ਨੇੜੇ ਲੀਕ - ਖਾਸ ਕਰਕੇ ਹਵਾ-ਸਹਿਤ ਮੀਂਹ - ਅਕਸਰ ਫਲੈਸ਼ਿੰਗ। ਉੱਪਰਲੇ ਪ੍ਰਵੇਸ਼ ਨਾਲ ਸਿੱਧੀ ਲਾਈਨ ਧੱਬੇ ਮਜ਼ਬੂਤ ਸੰਕੇਤ; ਛੱਤ ਨਿਰੀਖਣ ਤੋਂ ਬਿ�ਨਾਂ ਪੱਕਾ ਨਹੀਂ।",
      },
      {
        question: "ਛੱਤ ਬਦਲੇ ਬਿਨਾਂ ਫਲੈਸ਼ਿੰਗ ਮੁਰੰਮਤ?",
        answer:
          "ਆਮ ਤੌਰ 'ਤੇ ਹਾਂ ਜਦੋਂ ਆਲੇ-ਦੁਆਲੇ ਢੱਕਣ ਸੇਵਾਯੋਗ। ਵੱਖ-ਵੱਖ ਫਲੈਸ਼ਿੰਗ, ਬੂਟ, collars ਬਦਲੇ ਜਾ ਸਕਦੇ। ਫੀਲਡ end-of-life → ਬਦਲੀ ਯੋਜਨਾ ਨਾਲ ਦੁਬਾਰਾ ਵੇਰਵਾ।",
      },
      {
        question: "ਫਲੈਸ਼ਿੰਗ 'ਤੇ ਸੀਲੈਂਟ ਨੇ ਲੀਕ ਕਿਉਂ ਨਹੀਂ ਰੋਕੀ?",
        answer:
          "ਸੀਲੈਂਟ ਧਾਤ ਨਾਲੋਂ ਤੇਜ਼ੀ ਨਾਲ ਪੁਰਾਣਾ; ਗਲਤ ਜਿਓਮੈਟਰੀ ਨਹੀਂ ਠੀਕ ਕਰਦਾ। ਸਤਹੀ ਸੀਲੈਂਟ ਫੇਲ੍ਹ ਲੁਕਾਉਂਦਾ। ਟਿਕਾਊ ਮੁਰੰਮਤ = ਧਾਤ ਵੇਰਵਾ; ਸੀਲੈਂਟ ਦੂਜੀ।",
      },
      {
        question: "BC ਤਟ 'ਤੇ ਬੂਟ/ਫਲੈਸ਼ਿੰਗ ਕਿੰਨਾ ਚਲਦੀ?",
        answer:
          "ਸਮੱਗਰੀ, ਐਕਸਪੋਜ਼ਰ, ਇੰਸਟਾਲੇਸ਼ਨ 'ਤੇ - ਇੱਕ ਅੰਕ ਗੁਮਰਾਹ ਕਰਨ ਵਾਲਾ। ਰਬੜ ਬੂਟ ਧਾਤ ਨਾਲੋਂ ਤੇਜ਼; ਹਵਾ-ਸਹਿਤ ਤਟੀ ਮੀਂਹ ਕਮਜ਼ੋਰ ਵੇਰਵੇ ਜਲਦੀ ਉਜਾਗਰ।",
      },
    ],
  },
  "shingle-spot-repair": {
    title: "ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਸਥਾਨਕ ਮੁਰੰਮਤ",
    shortTitle: "ਸ਼ਿੰਗਲ ਸਥਾਨਕ ਮੁਰੰਮਤ",
    eyebrow: "ਸਥਾਨਕ ਢੱਕਣ ਮੁਰੰਮਤ",
    description:
      "ਜਦੋਂ ਆਲੇ-ਦੁਆਲੇ ਦਾ ਫੀਲਡ ਅਜੇ ਵੀ ਵਰਤੋਂਯੋਗ ਹੋਵੇ ਤਾਂ ਗੁੰਮ, ਹਵਾ-ਨੁਕਸਾਨ, ਕਰੈਕ ਜਾਂ ਹੋਰ ਖਰਾਬ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਜ਼ੋਨਾਂ ਦੀ ਮੁਰੰਮਤ।",
    definition:
      "ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਸਥਾਨਕ ਮੁਰੰਮਤ ਮੈਚਿੰਗ ਸ਼ਰਤਾਂ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਦੀ ਸਥਿਤੀ ਦੀ ਇਜਾਜ਼ਤ ਹੋਣ 'ਤੇ ਸੀਮਤ ਖੇਤਰਾਂ ਵਿੱਚ ਖਰਾਬ ਸ਼ਿੰਗਲਜ਼ ਬਦਲਦੀ ਜਾਂ ਦੁਬਾਰਾ ਫਿਕਸ ਕਰਦੀ ਹੈ, ਪੂਰੀ ਰੀਰੂਫ ਬਿਨਾਂ।",
    forWhom: "ਢਲਾਣ ਵਾਲੀ ਛੱਤ 'ਤੇ ਇਕੱਲੇ ਸ਼ਿੰਗਲ ਨੁਕਸਾਨ ਵਾਲੇ ਘਰ ਦੇ ਮਾਲਕ ਜਦੋਂ ਬਾਕੀ ਫੀਲਡ ਅਜੇ ਵੀ ਠੀਕ ਹੈ।",
    warningSigns: [
      "ਤੂਫਾਨ ਤੋਂ ਬਾਅਦ ਗੁੰਮ ਸ਼ਿੰਗਲਜ਼",
      "ਸ਼ਿੰਗਲ ਕਰੈਕ",
      "ਸਥਾਨਕ ਐਕਸਪੋਜ਼ਡ ਫਾਸਟਨਰ ਜਾਂ ਅੰਡਰਲੇਮੈਂਟ",
      "ਇੱਕ ਜ਼ੋਨ ਵਿੱਚ ਗ੍ਰੈਨਿਊਲ ਇਕੱਠ",
      "ਪੁਰਾਣੇ ਪੈਚ ਉੱਚੇ ਹੋ ਰਹੇ",
    ],
    evaluates: [
      "ਸ਼ਿੰਗਲ ਮੈਚਿੰਗ",
      "ਆਲੇ-ਦੁਆਲੇ ਫੀਲਡ ਦੀ ਲਚਕੀਲਾਪਨ",
      "ਸਥਾਨਕ ਅੰਡਰਲੇਮੈਂਟ",
      "ਖਰਾਬ ਛੱਤ ਦੀ ਐਕਸਪੋਜ਼ਰ",
      "ਕੀ ਨੁਕਸਾਨ ਵਾਸਤਵ ਵਿੱਚ ਇਕੱਲਾ ਹੈ",
    ],
    causes: ["ਹਵਾ ਉੱਠ", "ਟਕਰਾਅ ਨੁਕਸਾਨ", "ਗਰਮੀ ਕਰੈਕ", "ਪੈਰਾਂ ਦਾ ਨੁਕਸਾਨ", "ਸੀਲ ਸਟ੍ਰਿਪ ਬੁਢਾਪਾ"],
    methodology: [
      "ਮੈਚਿੰਗ ਦੀ ਪੁਸ਼ਟੀ",
      "ਖਰਾਬ ਸ਼ਿੰਗਲ ਸਾਵਧਾਨੀ ਨਾਲ ਹਟਾਓ",
      "ਲੋੜ 'ਤੇ ਸਥਾਨਕ ਅੰਡਰਲੇਮੈਂਟ",
      "ਮੈਚਿੰਗ ਸ਼ਿੰਗਲ ਸਹੀ ਫਾਸਟਨਿੰਗ ਨਾਲ",
      "ਸਿਰਫ ਵੇਰਵੇ ਮੁਤਾਬਕ ਸੀਲ",
    ],
    materials: [
      "ਮੈਚਿੰਗ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲਜ਼",
      "ਸਥਾਨਕ ਅੰਡਰਲੇਮੈਂਟ",
      "ਅਨੁਕੂਲ ਫਾਸਟਨਰ",
      "ਸਿਰਫ ਨਿਰਧਾਰਿਤ ਵੇਰਵਿਆਂ 'ਤੇ ਸੀਲੈਂਟ",
    ],
    bcClimate:
      "ਤਟੀ ਹਵਾ ਅਤੇ ਗੀਲੀਆਂ ਸਰਦੀਆਂ - ਸਮੇਂ ਸਿਰ ਸਥਾਨਕ ਮੁਰੰਮਤ ਪਾਣੀ ਦੇ ਡੈੱਕ ਤੱਕ ਪਹੁੰਚਣ ਤੋਂ ਪਹਿਲਾਂ ਮਹੱਤਵਪੂਰਨ।",
    whenAppropriate: "ਜਦੋਂ ਨੁਕਸਾਨ ਸੀਮਤ ਹੋਵੇ ਅਤੇ ਫੀਲਡ ਅਨੁਕੂਲ ਸ਼ਿੰਗਲ ਸਵੀਕਾਰ ਕਰੇ।",
    whenOtherService: "ਵਿਆਪਕ ਭੁਰਭੁਰਾਪਣ ਜਾਂ ਕਈ ਛੱਤ ਫੇਲ੍ਹ → ਪੂਰੀ ਅਸਫਾਲਟ ਬਦਲੀ।",
    process: [
      "ਸੁਰੱਖਿਅਤ ਹੋਣ 'ਤੇ ਖਰਾਬ ਜ਼ੋਨ ਦੀ ਫੋਟੋ ਭੇਜੋ",
      "ਛੱਤ 'ਤੇ ਨੁਕਸਾਨ ਸੀਮਤ ਪੁਸ਼ਟੀ",
      "ਪ੍ਰੋਫਾਈਲ ਅਤੇ ਰੰਗ ਮੈਚ ਚੈੱਕ",
      "ਪ੍ਰਭਾਵਿਤ ਸ਼ਿੰਗਲ ਸਾਵਧਾਨੀ ਨਾਲ ਬਦਲੋ",
      "ਮੁਰੰਮਤ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਫੀਲਡ ਦੀ ਸਮੀਖਿਆ",
    ],
    solutionCategories: [
      { title: "ਸਥਾਨਕ ਸ਼ਿੰਗਲ ਬਦਲਣਾ", body: "ਅਨੁਕੂਲ ਸਮੱਗਰੀ ਨਾਲ ਸੀਮਤ ਖਰਾਬ ਜ਼ੋਨ ਬਹਾਲ।" },
      { title: "ਕਿਨਾਰਾ ਅਤੇ ਰਿੱਜ ਪੈਚ", body: "ਉੱਚ-ਤਣਾਅ ਕਿਨਾਰਿਆਂ 'ਤੇ ਵੱਖਰੀਆਂ ਫੇਲ੍ਹਾਂ ਦਾ ਸੁਧਾਰ।" },
      { title: "ਲੀਕ ਮਾਰਗ ਜਾਂਚ", body: "ਸਥਾਨਕ ਨੁਕਸਾਨ ਫਲੈਸ਼ਿੰਗ ਫੇਲ੍ਹ ਨੂੰ ਛੁਪਾ ਰਿਹਾ ਹੈ ਕਿ ਨਹੀਂ।" },
    ],
    repairVsReplace: {
      repair: "ਫੀਲਡ ਅਜੇ ਲਚਕੀਲਾ ਅਤੇ ਮੈਚਿੰਗ ਮਿਲੇ।",
      replace: "ਘਿਸਾਈ ਸਿਸਟਮਿਕ ਹੋਵੇ ਤਾਂ ਪੂਰੀ ਬਦਲੀ।",
    },
    scopeFactors: ["ਨੁਕਸਾਨ ਦਾ ਖੇਤਰ", "ਢਲਾਨ/ਪਹੁੰਚ", "ਸਮੱਗਰੀ ਮੈਚ", "ਅੰਡਰਲੇਮੈਂਟ", "ਮੌਸਮੀ ਵਿੰਡੋ"],
    publicPriceHint:
      "ਸਥਾਨਕ ਮੁਰੰਮਤ ਸਕੋਪ ਨੁਕਸਾਨ ਦੇ ਖੇਤਰ, ਢਲਾਨ, ਪਹੁੰਚ ਅਤੇ ਸ਼ਿੰਗਲ ਮੈਚ 'ਤੇ ਨਿਰਭਰ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਸਥਾਨਕ ਮੁਰੰਮਤ ਕੀ ਹੈ?",
        answer:
          "ਮੈਚਿੰਗ ਸ਼ਰਤਾਂ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਦੀ ਸਥਿਤੀ ਦੀ ਇਜਾਜ਼ਤ ਹੋਣ 'ਤੇ ਸੀਮਤ ਖੇਤਰਾਂ ਵਿੱਚ ਖਰਾਬ ਸ਼ਿੰਗਲਜ਼ ਬਦਲਣਾ ਜਾਂ ਦੁਬਾਰਾ ਫਿਕਸ ਕਰਨਾ, ਪੂਰੀ ਰੀਰੂਫ ਬਿਨਾਂ।",
      },
      {
        question: "ਤੂਫਾਨ ਨੇ ਕੁਝ ਸ਼ਿੰਗਲ ਉਡਾਏ: ਕੀ ਇਹ ਐਮਰਜੈਂਸੀ ਹੈ?",
        answer:
          "ਜਿੰਨੀ ਜਲਦੀ ਹੋ ਸਕੇ ਠੀਕ ਕਰਵਾਓ। ਗੁੰਮ ਸ਼ਿੰਗਲ ਲੰਬੇ ਸਮੇਂ ਲਈ ਡਿਜ਼ਾਈਨ ਨਹੀਂ ਕੀਤੇ ਅੰਡਰਲੇਮੈਂਟ ਨੂੰ ਐਕਸਪੋਜ਼ ਕਰਦੇ ਹਨ; ਤੇਜ਼ ਸਥਾਨਕ ਮੁਰੰਮਤ ਅਕਸਰ ਵੱਡੀ ਸਮੱਸਿਆ ਰੋਕਦੀ ਹੈ।",
      },
      {
        question: "ਕੀ ਨਵੀਆਂ ਸ਼ਿੰਗਲਜ਼ ਮੌਜੂਦਾ ਛੱਤ ਨਾਲ ਰੰਗ ਮਿਲਾ ਸਕਦੀਆਂ ਹਨ?",
        answer:
          "ਨਵੀਆਂ ਸ਼ਿੰਗਲਜ਼ ਮੌਸਮੀ ਸ਼ਿੰਗਲਜ਼ ਨਾਲ ਸੰਪੂਰਨ ਮੈਚ ਨਹੀਂ ਕਰਦੀਆਂ। ਨਜ਼ਦੀਕੀ ਰੰਗ ਘੱਟ ਕੰਟ੍ਰਾਸਟ; ਸ਼ੁਰੂ ਤੋਂ ਮੈਚ ਉਮੀਦਾਂ ਈਮਾਨਦਾਰੀ ਨਾਲ।",
      },
      {
        question: "ਕਿੰਨੀਆਂ ਖਰਾਬ ਸ਼ਿੰਗਲਜ਼ 'ਤੇ ਸਥਾਨਕ ਮੁਰੰਮਤ ਠੀਕ ਨਹੀਂ?",
        answer:
          "ਕੋਈ ਫਿਕਸਡ ਗਿਣਤੀ ਨਹੀਂ - ਮੁੱਖ: ਕੀ ਨੁਕਸਾਨ ਸੀਮਤ ਹੈ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਫੀਲਡ ਕੰਮ ਸਵੀਕਾਰ ਕਰਦਾ ਹੈ। ਕਈ ਛੱਤਾਂ 'ਤੇ ਵਾਰ-ਵਾਰ ਫੇਲ੍ਹ → ਬਦਲੀ ਯੋਜਨਾ ਵਧੇਰੇ ਆਰਥਿਕ।",
      },
      {
        question: "ਕੀ ਕਰੈਕ ਸ਼ਿੰਗਲ ਸਿਰਫ ਸੀਲ ਕੀਤੀ ਜਾ ਸਕਦੀ ਹੈ?",
        answer:
          "ਕਰੈਕ 'ਤੇ ਸਤਹੀ ਸੀਲ ਛੋਟੀ ਉਮਰ। ਖਰਾਬ ਸ਼ਿੰਗਲ ਬਦਲਣਾ ਅਨੁਮਾਨਿਤ ਵਾਟਰਸ਼ੈਡਿੰਗ ਬਹਾਲ - ਆਮ ਤੌਰ 'ਤੇ ਵਧੇਰੇ ਟਿਕਾਊ।",
      },
    ],
  },
  "gutter-cleaning-downspout-flush": {
    title: "ਗਟਰ ਸਫਾਈ + ਡਾਊਨਸਪਾਊਟ ਫਲੱਸ",
    shortTitle: "ਗਟਰ ਸਫਾਈ",
    eyebrow: "ਡrerਨੇਜ ਰੱਖ-ਰਖਾਅ",
    description:
      "ਗਟਰ ਸਾਫ਼ ਕਰੋ ਅਤੇ ਡਾਊਨਸਪਾਊਟ ਫਲੱਸ ਕਰੋ ਤਾਂ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਬਾਰਿਸ਼ ਵਿੱਚ ਈਵ ਡrerਨੇਜ ਠੀਕ ਕੰਮ ਕਰੇ।",
    definition:
      "ਗਟਰ ਸਫਾਈ ਗਟਰ ਅਤੇ ਡਾਊਨਸਪਾਊਟ ਵਿੱਚੋਂ ਮਲਬਾ ਹਟਾਉਂਦੀ ਹੈ ਤਾਂ ਛੱਤ ਦਾ ਪਾਣੀ ਈਵ ਰਾਹੀਂ ਜਾਵੇ, fascia, ਨੀਂਹ ਜਾਂ ਲੈਂਡਸਕੇਪ ਵਿੱਚ ਨਾ ਫੁੱਟੇ।",
    forWhom:
      "ਓਵਰਫਲੋ, ਗਟਰ ਵਿੱਚ ਪੌਦੇ, ਜਾਂ ਆਮ ਬਾਰਿਸ਼ ਤੋਂ ਬਾਅਦ fascia 'ਤੇ ਪਾਣੀ ਦੇ ਨਿਸ਼ਾਨ ਵਾਲੇ ਘਰ ਦੇ ਮਾਲਕ।",
    warningSigns: [
      "ਪਾਣੀ ਗਟਰ ਦੀ ਬਾਹਰੀ ਦੀਵਾਰ ਤੋਂ",
      "ਟਰਫ ਵਿੱਚ ਪੌਦੇ",
      "ਨੀਂਹ 'ਤੇ ਛਿੜਕਾਅ",
      "fascia 'ਤੇ ਪਾਣੀ ਦੇ ਨਿਸ਼ਾਨ",
      "ਟੈਸਟ 'ਤੇ ਡਾਊਨਸਪਾਊਟ ਨਹੀਂ ਡrerਨ",
    ],
    evaluates: [
      "ਮਲਬੇ ਦੀ ਮਾਤਰਾ",
      "ਟਰਫ ਦਾ ਢਲਾਨ",
      "ਆਊਟਲੈੱਟ/ਐਕਸਟੈਂਸ਼ਨ",
      "fascia ਫਿਕਸੇਸ਼ਨ",
      "ਕੀ ਮੈਟਲ ਫੇਲ੍ਹ ਹੋ ਚੁੱਕਾ",
    ],
    causes: [
      "ਪੱਤੇ ਅਤੇ ਮੌਸ ਮਲਬਾ",
      "pine needles ਦਾ ਮਲਬਾ",
      "ਢਲਾਨ ਦਾ ਬੈਠਣਾ",
      "ਸਕ੍ਰੀਨ ਬਲਾਕ",
      "ਮੌਸਮੀ ਸਫਾਈ ਛੁੱਟ ਜਾਣਾ",
    ],
    methodology: [
      "ਟਰਫ ਸਾਫ਼",
      "ਡਾਊਨਸਪਾਊਟ ਫਲੱਸ",
      "ਆਊਟਲੈੱਟ/ਐਕਸਟੈਂਸ਼ਨ ਚੈੱਕ",
      "ਮੈਟਲ ਸਥਿਤੀ ਦਰਜ",
      "ਸਿਰਫ ਜਾਇਜ਼ ਹੋਣ 'ਤੇ ਗਾਰਡ/ਬਦਲੀ",
    ],
    materials: ["ਸਫਾਈ ਟੂਲ", "ਫਲੱਸ ਈਕੁਇਪਮੈਂਟ", "ਸਿਰਫ ਸਕੋਪ ਵਿੱਚ ਬੁਨਿਆਦੀ ਫਾਸਟਨਰ"],
    bcClimate:
      "ਲਗਾਤਾਰ ਬਾਰਿਸ਼ ਦਾ ਮਤਲਬ ਬਲਾਕ ਗਟਰ ਤੇਜ਼ੀ ਨਾਲ ਮੈਟਰੋ ਵੈਨਕੂਵਰ fascia ਅਤੇ ਨੀਂਹ ਗੀਲਾ ਕਰਦੇ ਹਨ।",
    whenAppropriate: "ਜਦੋਂ ਮੈਟਲ ਅਜੇ ਠੀਕ ਹੋਵੇ ਅਤੇ ਮਲਬਾ ਮੁੱਖ ਸਮੱਸਿਆ।",
    whenOtherService: "ਜੰਗ, ਵੱਖ ਹੋਏ ਜਾਂ ਲੰਬੇ ਸਮੇਂ ਤੋਂ ਛੋਟੇ ਗਟਰ → ਬਦਲੀ।",
    process: [
      "ਘਰ ਦੀ ਉਚਾਈ, ਗਟਰ ਲੰਬਾਈ, ਪਹੁੰਚ ਦੱਸੋ",
      "ਪੱਤੇ, needles, ਮਲਬਾ ਹਟਾਓ",
      "ਹਰ ਡਾਊਨਸਪਾਊਟ ਫਲੱਸ ਅਤੇ ਡrerਨ ਪੁਸ਼ਟੀ",
      "ਕੰਮ ਦੌਰਾਨ ਮੈਟਲ, ਢਲਾਨ, fascia ਦਰਜ",
      "ਸਿਰਫ ਸਫਾਈ ਨਾਲ ਨਹੀਂ ਹੱਲ ਹੋਣ ਵਾਲੀਆਂ ਸਮੱਸਿਆਵਾਂ ਰਿਪੋਰਟ",
    ],
    solutionCategories: [
      { title: "ਟਰਫ ਸਫਾਈ", body: "ਗਟਰ ਵਿੱਚੋਂ ਜੈਵਿਕ ਅਤੇ ਕਣ ਮਲਬਾ।" },
      { title: "ਡਾਊਨਸਪਾਊਟ ਫਲੱਸ", body: "ਲਗਾਤਾਰ ਡrerਨੇਜ ਮਾਰਗ ਬਹਾਲ।" },
      { title: "ਸਥਿਤੀ ਦਰਜ", body: "ਸਫਾਈ ਦੌਰਾਨ ਫੇਲ੍ਹ ਮੈਟਲ ਜਾਂ fascia।" },
    ],
    repairVsReplace: {
      repair: "ਟਰਫ ਸੰਰਚਨਾ ਠੀਕ ਹੋਵੇ ਤਾਂ ਸਫਾਈ।",
      replace: "ਸਫਾਈ ਤੋਂ ਬਾਅਦ ਵੀ ਮੈਟਲ/ਢਲਾਨ ਡrerਨ ਨਹੀਂ ਕਰਦਾ।",
    },
    scopeFactors: ["ਲੀਨੀਅਰ ਲੰਬਾਈ", "ਮੰਜ਼ਿਲਾਂ/ਪਹੁੰਚ", "ਮਲਬੇ ਦੀ ਕਿਸਮ", "ਡਾਊਨਸਪਾਊਟ ਗਿਣਤੀ", "ਸੁਰੱਖਿਆ"],
    publicPriceHint:
      "ਕੀਮਤ ਆਮ ਤੌਰ 'ਤੇ ਲੀਨੀਅਰ ਲੰਬਾਈ, ਮੰਜ਼ਿਲਾਂ, ਮਲਬੇ ਅਤੇ ਸੁਰੱਖਿਆ/ਪਹੁੰਚ 'ਤੇ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਗਟਰ ਸਫਾਈ + ਡਾਊਨਸਪਾਊਟ ਫਲੱਸ ਕੀ ਹੈ?",
        answer:
          "ਗਟਰ ਅਤੇ ਡਾਊਨਸਪਾਊਟ ਵਿੱਚੋਂ ਮਲਬਾ ਹਟਾਉਣਾ ਤਾਂ ਛੱਤ ਦਾ ਪਾਣੀ ਈਵ ਰਾਹੀਂ ਜਾਵੇ, fascia ਜਾਂ ਨੀਂਹ ਵਿੱਚ ਨਾ ਫੁੱਟੇ।",
      },
      {
        question: "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਗਟਰ ਕਿੰਨੀ ਵਾਰ ਸਾਫ਼?",
        answer:
          "ਜ਼ਿਆਦਾਤਰ ਘਰਾਂ ਨੂੰ ਪਤਝੜ ਬਾਅਦ ਘੱਟੋ-ਘੱਟ ਇੱਕ ਵਾਰ; needles ਵਾਲੇ ਘਰਾਂ ਨੂੰ ਅਕਸਰ ਦੂਜੀ। ਆਮ ਬਾਰਿਸ਼ 'ਤੇ ਓਵਰਫਲੋ = ਬਹੁਤ ਦੇਰ।",
      },
      {
        question: "ਗਟਰ ਸਫਾਈ ਛੱਡਣ ਦਾ ਕੀ?",
        answer:
          "ਬਲਾਕ ਗਟਰ fascia/ਕੰਧ 'ਤੇ ਫੁੱਟ, ਨੀਂਹ 'ਤੇ ਪਾਣੀ, ਛੱਤ ਕਿਨਾਰੇ ਤੱਕ ਵਾਪਸ। ਇੱਥੇ ਛੋਟੀ ਰੱਖ-ਰਖਾਅ часто fascia ਸੜਨ ਜਾਂ ਡrerਨੇਜ ਮੁਰੰਮਤ ਬਣ ਜਾਂਦੀ ਹੈ।",
      },
      {
        question: "ਕੀ ਸਿਰਫ ਗਟਰ ਜਾਂ ਡਾਊਨਸਪਾਊਟ ਵੀ?",
        answer: "ਦੋਵੇਂ। ਸਾਫ਼ ਟਰਫ + ਬਲਾਕ ਡਾਊਨਸਪਾਊਟ = ਓਵਰਫਲੋ। ਹਰ ਡਾਊਨਸਪਾਊਟ ਫਲੱਸ ਅਤੇ ਡrerਨ ਪੁਸ਼ਟੀ।",
      },
      {
        question: "ਸਾਫ਼ ਹੋਣ 'ਤੇ ਵੀ ਓਵਰਫਲੋ?",
        answer:
          "ਢਲਾਨ, ਸਾਈਜ਼ ਜਾਂ ਆਊਟਲੈੱਟ - ਮਲਬਾ ਨਹੀਂ। ਸਫਾਈ ਵਿਜ਼ਿਟ ਵਿੱਚ ਸਥਿਤੀ ਦਰਜ; ਮੁਰੰਮਤ/ਬਦਲੀ ਸਿਫ਼ਾਰਸ਼।",
      },
    ],
  },
  "storm-tarping-emergency-dry-in": {
    title: "ਤੂਫਾਨ ਤਰਪਾਲ / ਐਮਰਜੈਂਸੀ ਡ੍ਰਾਈ-ਇਨ",
    shortTitle: "ਤੂਫਾਨ ਤਰਪਾਲ",
    eyebrow: "ਅਸਥਾਈ ਵਾਟਰਪ੍ਰੂਫ",
    description: "ਹਵਾ, ਰੁੱਖ ਜਾਂ ਤੂਫਾਨ ਨੁਕਸਾਨ ਤੋਂ ਬਾਅਦ, ਸਥਾਈ ਛੱਤ ਕੰਮ ਤੋਂ ਪਹਿਲਾਂ ਅਸਥਾਈ ਵਾਟਰਪ੍ਰੂਫਿੰਗ।",
    definition:
      "ਤੂਫਾਨ ਤਰਪਾਲ ਅਤੇ ਐਮਰਜੈਂਸੀ ਡ੍ਰਾਈ-ਇਨ ਸਥਾਈ ਮੁਰੰਮਤ ਯੋਜਨਾ ਦੌਰਾਨ ਖੁੱਲ੍ਹੀਆਂ ਜਾਂ ਖਰਾਬ ਛੱਤ ਜ਼ੋਨਾਂ ਨੂੰ ਅਸਥਾਈ ਮੌਸਮ ਤੋਂ ਬਚਾਉਂਦੀ ਹੈ, ਅੰਦਰੂਨੀ ਨੁਕਸਾਨ ਸੀਮਤ।",
    forWhom: "ਤੂਫਾਨ ਤੋਂ ਬਾਅਦ ਐਕਸਪੋਜ਼ਡ ਡੈੱਕ, ਰੁੱਖ ਟਕਰਾਅ, ਜਾਂ ਵੱਡੇ ਗੁੰਮ ਫੀਲਡ ਵਾਲੇ ਘਰ ਦੇ ਮਾਲਕ।",
    warningSigns: [
      "ਰੁੱਖ ਟਕਰਾਅ 'ਤੇ ਐਕਸਪੋਜ਼ਡ ਡੈੱਕ",
      "ਵੱਡਾ ਫੀਲਡ ਗੁੰਮ",
      "ਨਵੇਂ ਖੁੱਲ੍ਹ 'ਤੇ ਅੰਦਰੂਨੀ ਲੀਕ",
      "ਛੱਤ 'ਤੇ ਅਸਥਿਰ ਮਲਬਾ",
      "ਸਥਾਈ ਸਮੱਗਰੀ ਤੋਂ ਪਹਿਲਾਂ ਸੁਰੱਖਿਆ",
    ],
    evaluates: [
      "ਸੁਰੱਖਿਆ/ਪਹੁੰਚ",
      "ਖੁੱਲ੍ਹ ਦਾ ਆਕਾਰ/ਸਥਾਨ",
      "ਅੰਦਰੂਨੀ ਜੋਖਮ",
      "ਮੌਸਮੀ ਵਿੰਡੋ",
      "ਸਥਾਈ ਮੁਰੰਮਤ ਮਾਰਗ",
    ],
    causes: ["ਤੂਫਾਨ", "ਰੁੱਖ ਡਿੱਗਣਾ", "ਅਚਾਨਕ ਢੱਕਣ ਗੁੰਮ", "ਟਕਰਾਅ", "ਅੰਸ਼ਿਕ ਬੁਢਾਪਾ"],
    methodology: [
      "ਸੁਰੱਖਿਆ ਪਹਿਲਾਂ",
      "ਸਿਰਫ ਸੁਰੱਖਿਅਤ ਡ੍ਰਾਈ-ਇਨ ਲਈ ਮਲਬਾ",
      "ਅਸਥਾਈ ਵਾਟਰਪ੍ਰੂਫ",
      "ਸਥਿਤੀ ਦਰਜ",
      "ਸਥਾਈ ਮੁਰੰਮਤ ਯੋਜਨਾ",
    ],
    materials: ["ਤਰਪਾਲ/ਅਸਥਾਈ membrane", "ਅਸਥਾਈ ਕੰਮ ਲਈ ਭਰੋਸੇਮੰਦ ਫਿਕਸੇਸ਼ਨ", "ਖੁੱਲ੍ਹ/ਕਿਨਾਰਾ ਸੁਰੱਖਿਆ"],
    bcClimate:
      "ਪੈਸਿਫਿਕ ਤੂਫਾਨ ਤੇਜ਼ੀ ਨਾਲ ਛੱਤ ਖੋਲ੍ਹਦੇ ਹਨ; ਅਸਥਾਈ ਡ੍ਰਾਈ-ਇਨ ਸਥਾਈ ਸਕੋਪ ਤੋਂ ਪਹਿਲਾਂ ਦੂਜਾ ਅੰਦਰੂਨੀ ਨੁਕਸਾਨ ਸੀਮਤ।",
    whenAppropriate: "ਸਥਾਈ ਕੰਮ ਤੋਂ ਪਹਿਲਾਂ ਖੁੱਲ੍ਹ/ਅਸਥਿਰ ਜ਼ੋਨ ਨੂੰ ਮੌਸਮ ਤੋਂ ਬਚਾਉਣਾ ਲਾਜ਼ਮੀ।",
    whenOtherService: "ਅਸਥਾਈ ਡ੍ਰਾਈ-ਇਨ ਖਰਾਬ ਕੰਪੋਨੈਂਟ ਦੀ ਸਥਾਈ ਮੁਰੰਮਤ/ਬਦਲੀ ਨਹੀਂ।",
    process: [
      "ਫੋਟੋ ਅਤੇ ਸੁਰੱਖਿਆ ਵੇਰਵੇ ਨਾਲ ਸੰਪਰਕ",
      "ਖਤਰਾ/ਪਹੁੰਚ ਮੁਲਾਂਕਣ",
      "ਸਿਰਫ ਸੁਰੱਖਿਅਤ ਕਵਰ ਲਈ ਮਲਬਾ ਸਥਿਰ",
      "ਖੁੱਲ੍ਹ 'ਤੇ ਅਸਥਾਈ ਵਾਟਰਪ੍ਰੂਫ",
      "ਸਥਿਤੀ ਦਰਜ ਅਤੇ ਸਥਾਈ ਯੋਜਨਾ",
    ],
    solutionCategories: [
      { title: "ਅਸਥਾਈ ਵਾਟਰਪ੍ਰੂਫ", body: "ਤੂਫਾਨ ਖੁੱਲ੍ਹ 'ਤੇ ਮੌਸਮੀ ਪਾਣੀ ਸੀਮਤ।" },
      { title: "ਸਥਿਰਤਾ", body: "ਢਿੱਲੀ ਸਮੱਗਰੀ ਜੋ ਹੋਰ ਨੁਕਸਾਨ ਕਰ ਸਕਦੀ।" },
      { title: "ਸਥਿਤੀ ਦਰਜ", body: "ਸਥਾਈ ਮੁਰੰਮਤ ਯੋਜਨਾ ਲਈ।" },
    ],
    repairVsReplace: {
      repair: "ਸਥਾਈ ਕੰਮ ਤੁਰੰਤ ਨਹੀਂ ਹੋ ਸਕਦਾ ਤਾਂ ਪਹਿਲਾਂ ਡ੍ਰਾਈ-ਇਨ।",
      replace: "ਕੰਪੋਨੈਂਟ ਠੀਕ ਹੋਣ 'ਤੇ ਸਥਾਈ ਮੁਰੰਮਤ/ਬਦਲੀ।",
    },
    scopeFactors: ["ਖੁੱਲ੍ਹ ਆਕਾਰ", "ਪਹੁੰਚ/ਉਚਾਈ", "ਮੌਸਮ", "ਅੰਦਰੂਨੀ ਐਕਸਪੋਜ਼ਰ", "ਮਲਬਾ ਖਤਰਾ"],
    publicPriceHint:
      "ਅਸਥਾਈ ਡ੍ਰਾਈ-ਇਨ ਖੁੱਲ੍ਹ ਆਕਾਰ, ਛੱਤ ਉਚਾਈ, ਮੌਸਮ ਅਤੇ ਮਲਬਾ ਖਤਰੇ 'ਤੇ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਤੂਫਾਨ ਤਰਪਾਲ / ਐਮਰਜੈਂਸੀ ਡ੍ਰਾਈ-ਇਨ ਕੀ ਹੈ?",
        answer:
          "ਸਥਾਈ ਮੁਰੰਮਤ ਯੋਜਨਾ ਦੌਰਾਨ ਖੁੱਲ੍ਹੀਆਂ/ਖਰਾਬ ਛੱਤ ਜ਼ੋਨਾਂ ਨੂੰ ਅਸਥਾਈ ਮੌਸਮ ਤੋਂ ਬਚਾਉਣਾ, ਅੰਦਰੂਨੀ ਨੁਕਸਾਨ ਸੀਮਤ।",
      },
      {
        question: "ਰੁੱਖ ਛੱਤ 'ਤੇ: ਪਹਿਲਾਂ ਕੀ?",
        answer:
          "ਨੁਕਸਾਨ ਹੇਠਲੇ ਕਮਰੇ ਤੋਂ ਦੂਰ, ਛੱਤ 'ਤੇ ਨਾ ਚੜ੍ਹੋ, ਜ਼ਮੀਨ/ਅੰਦਰੋਂ ਫੋਟੋ। ਫਿਰ ਪੇਸ਼ੇਵਰ ਡ੍ਰਾਈ-ਇਨ - ਅਸਥਿਰ ਟਹਿਣੀਆਂ ਅਤੇ ਛੁਪੀ ਸੰਰਚਨਾ ਖਤਰਨਾਕ।",
      },
      {
        question: "ਤਰਪਾਲ ਕਿੰਨਾ ਚਲਦੀ?",
        answer:
          "ਅਸਥਾਈ - ਹਫ਼ਤੇ ਤੋਂ ਮਹੀਨੇ, ਐਕਸਪੋਜ਼ਰ/ਫਿਕਸੇਸ਼ਨ/ਸਰਦੀ ਤੂਫਾਨ 'ਤੇ। ਜਿੰਨੀ ਜਲਦੀ ਸਥਾਈ ਮੁਰੰਮਤ।",
      },
      {
        question: "ਕੀ ਬੀਮਾ ਐਮਰਜੈਂਸੀ ਤਰਪਾਲ ਕਵਰ?",
        answer:
          "ਕਈ ਪਾਲਿਸੀਆਂ ਅਚਾਨਕ ਨੁਕਸਾਨ ਤੋਂ ਬਾਅਦ ਉਚਿਤ ਅਸਥਾਈ ਸੁਰੱਖਿਆ - ਪਾਲਿਸੀ ਵੱਖ-ਵੱਖ। ਰੇਵੋਲਿਨ ਸਥਿਤੀ/ਕੰਮ ਦਰਜ; ਪਾਲਿਸੀ ਸਲਾਹ ਨਹੀਂ।",
      },
      {
        question: "ਕੀ ਤਰਪਾਲ ਛੱਤ ਮੁਰੰਮਤ ਦੀ ਥਾਂ?",
        answer:
          "ਨਹੀਂ। ਸਥਾਈ ਯੋਜਨਾ ਦੌਰਾਨ ਅੰਦਰੂਨੀ ਨੁਕਸਾਨ ਸੀਮਤ। ਲੰਬੇ ਸਮੇਂ ਤੱਕ = ਫਿਕਸੇਸ਼ਨ/ਸਮੱਗਰੀ degrade।",
      },
    ],
  },
  "skylight-leak-flashing-repair": {
    title: "ਸਕਾਈਲਾਈਟ ਲੀਕ / ਫਲੈਸ਼ਿੰਗ ਮੁਰੰਮਤ",
    shortTitle: "ਸਕਾਈਲਾਈਟ ਮੁਰੰਮਤ",
    eyebrow: "ਸਕਾਈਲਾਈਟ ਇੰਟਰਫੇਸ",
    description: "ਲੀਕ ਕਰਦੇ ਸਕਾਈਲਾਈਟ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਛੱਤ 'ਤੇ ਮੁਰੰਮਤ ਜਾਂ ਦੁਬਾਰਾ ਫਲੈਸ਼ਿੰਗ।",
    definition:
      "ਸਕਾਈਲਾਈਟ ਲੀਕ ਅਤੇ ਫਲੈਸ਼ਿੰਗ ਮੁਰੰਮਤ ਸਕਾਈਲਾਈਟ ਕਰਬ, ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਛੱਤ 'ਤੇ ਪਾਣੀ ਦਾ ਪ੍ਰਵੇਸ਼ ਠੀਕ ਕਰਦੀ ਹੈ - ਗਲASS ਹੀ ਕਾਰਨ ਮੰਨੇ ਬਿਨਾਂ।",
    forWhom: "ਸਕਾਈਲਾਈਟ ਹੇਠ ਧੱਬੇ, ਕਰਬ ਫਲੈਸ਼ਿੰਗ ਫੇਲ੍ਹ, ਜਾਂ ਕondensation vs ਲੀਕ ਅਨਿਸ਼ਚਿਤ ਘਰ ਦੇ ਮਾਲਕ।",
    warningSigns: [
      "ਸਕਾਈਲਾਈਟ ਵੈਲ ਹੇਠ ਧੱਬੇ",
      "ਲਾਈਟ ਵੈਲ ਪੇਂਟ ਛਲਕਣ",
      "ਕਰਬ ਕੋਣਾਂ 'ਤੇ ਰੋਸ਼ਨੀ",
      "ਯੂਨਿਟ ਕੋਲ step flashing ਫੇਲ੍ਹ",
      "ਘੱਟ-ਢਲਾਨ 'ਤੇ ਕਰਬ ਕੋਲ ਪਾਣੀ",
    ],
    evaluates: [
      "ਸਕਾਈਲਾਈਟ ਕਿਸਮ/ਉਮਰ",
      "ਕਰਬ/ਫਲੈਸ਼ਿੰਗ",
      "ਆਲੇ-ਦੁਆਲੇ ਢੱਕਣ ਏਕੀਕਰਣ",
      "ਅੰਦਰੂਨੀ condensation ਪੈਟਰਨ",
      "ਕੀ ਯੂਨਿਟ ਬਦਲਣਾ",
    ],
    causes: [
      "ਕਰਬ ਫਲੈਸ਼ਿੰਗ ਫੇਲ੍ਹ",
      "ਸ਼ਿੰਗਲ/membrane ਗਲਤ ਏਕੀਕਰਣ",
      "ਸੀਲ ਬੁਢਾਪਾ",
      "condensation ਨੂੰ ਲੀਕ ਸਮਝਣਾ",
      "ਫਰੇਮ ਖੁੱਲ੍ਹ ਖਿਸਕਣਾ",
    ],
    methodology: [
      "ਜੋ ਸੰਭਵ ਹੋਵੇ ਲੀਕ vs condensation ਵੱਖ",
      "ਕਰਬ ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਛੱਤ ਜਾਂਚ",
      "ਅਨੁਕੂਲ ਵੇਰਵਿਆਂ ਨਾਲ ਦੁਬਾਰਾ ਫਲੈਸ਼/ਮੁਰੰਮਤ",
      "ਲੋੜ 'ਤੇ ਆਲੇ-ਦੁਆਲੇ ਢੱਕਣ",
      "ਸਿਰਫ ਜਾਇਜ਼ ਹੋਣ 'ਤੇ ਯੂਨਿਟ ਬਦਲੀ",
    ],
    materials: [
      "ਕਰਬ ਫਲੈਸ਼ਿੰਗ",
      "ਅਨੁਕੂਲ underlayment/membrane ਵੇਰਵੇ",
      "ਆਲੇ-ਦੁਆਲੇ ਸ਼ਿੰਗਲ/membrane ਪੈਚ",
      "ਸੀਲੈਂਟ ਸਿਰਫ ਦੂਜੀ ਪੱਧਰ",
    ],
    bcClimate:
      "ਹਵਾ-ਸਹਿਤ ਮੀਂਹ ਵਿੱਚ ਤਟੀ BC ਦਾ ਕਮਜ਼ੋਰ ਸਕਾਈਲਾਈਟ ਕਰਬ ਤੇਜ਼ੀ ਨਾਲ ਫੇਲ੍ਹ - ਸਿਰਫ ਗਲASS ਸਥਿਤੀ ਸਭ ਲੀਕ ਨਹੀਂ ਸਮਝਾਉਂਦੀ।",
    whenAppropriate: "ਜਦੋਂ ਯੂਨਿਟ ਵਰਤੋਂਯੋਗ ਅਤੇ ਫੇਲ੍ਹ ਫਲੈਸ਼ਿੰਗ/ਆਲੇ-ਦੁਆਲੇ ਛੱਤ 'ਤੇ।",
    whenOtherService:
      "ਫਰੇਮ ਫੇਲ੍ਹ, ਲੰਬੇ ਸਮੇਂ ਤੋਂ ਲੀਕ ਵਾਲਾ sealed unit, ਜਾਂ ਵੱਡੀ ਛੱਤ ਫੇਲ੍ਹ → ਵੱਖਰਾ ਸਕੋਪ।",
    process: [
      "ਪਾਣੀ ਧੱਬੇ ਪੈਟਰਨ ਅਤੇ ਸਕਾਈਲਾਈਟ ਉਮਰ ਦੱਸੋ",
      "ਕਰਬ, ਫਲੈਸ਼ਿੰਗ, ਆਲੇ-ਦੁਆਲੇ ਛੱਤ ਜਾਂਚ",
      "ਲੀਕ vs condensation",
      "ਦੁਬਾਰਾ ਫਲੈਸ਼/ਫੇਲ੍ਹ ਵੇਰਵੇ",
      "ਇੰਟਰਫੇਸ ਸਮੀਖਿਆ ਅਤੇ ਦਰਜ",
    ],
    solutionCategories: [
      { title: "ਕਰਬ ਦੁਬਾਰਾ ਫਲੈਸ਼ਿੰਗ", body: "ਸਕਾਈਲਾਈਟ ਕਰਬ 'ਤੇ ਧਾਤ/membrane।" },
      { title: "ਆਲੇ-ਦੁਆਲੇ ਢੱਕਣ", body: "ਯੂਨਿਟ ਨਾਲ ਨਾ ਮਿਲਦੀ ਸ਼ਿੰਗਲ/membrane।" },
      { title: "ਲੀਕ/condensation ਜਾਂਚ", body: "ਯੂਨਿਟ ਲੀਕ vs ਅੰਦਰੂਨੀ ਨਮੀ।" },
    ],
    repairVsReplace: {
      repair: "ਯੂਨਿਟ/ਕਰਬ ਟਿਕਾਊ ਦੁਬਾਰਾ ਵੇਰਵਾ ਸਵੀਕਾਰ ਕਰੇ।",
      replace: "ਕੰਪੋਨੈਂਟ ਭਰੋਸੇਮੰਦ ਬਹਾਲ ਨਹੀਂ।",
    },
    scopeFactors: [
      "ਸਕਾਈਲਾਈਟ ਗਿਣਤੀ/ਆਕਾਰ",
      "ਛੱਤ ਸਿਸਟਮ",
      "ਕਰਬ ਉਚਾਈ/ਸਥਿਤੀ",
      "ਪਹੁੰਚ",
      "ਅੰਦਰੂਨੀ ਫਿਨਿਸ਼ ਜੋਖਮ",
    ],
    publicPriceHint:
      "ਸਕਾਈਲਾਈਟ ਕੰਮ ਪ੍ਰਤੀ ਯੂਨਿਟ: ਕਰਬ, ਛੱਤ ਸਿਸਟਮ, ਫਲੈਸ਼ਿੰਗ, ਪਹੁੰਚ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਸਕਾਈਲਾਈਟ ਲੀਕ / ਫਲੈਸ਼ਿੰਗ ਮੁਰੰਮਤ ਕੀ ਹੈ?",
        answer: "ਸਕਾਈਲਾਈਟ ਕਰਬ, ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਛੱਤ 'ਤੇ ਪਾਣੀ - ਗਲASS ਹੀ ਕਾਰਨ ਮੰਨੇ ਬਿਨਾਂ।",
      },
      {
        question: "ਲੀਕ ਜਾਂ condensation?",
        answer:
          "condensation = ਠੰਡੇ/ਨਮੇ ਮੌਸਮ ਵਿੱਚ ਬੂੰਦ/ਧੁੰਦਲapan; ਲੀਕ = ਕਰਬ/ਉੱਪਰਲੇ ਕਿਨਾਰੇ ਤੋਂ ਧੱਬੇ, light well drywall। ਛੱਤ ਨਿਦਾਨ ਪੁਸ਼ਟੀ।",
      },
      {
        question: "ਲੀਕ = ਨਵਾਂ ਸਕਾਈਲਾਈਟ?",
        answer:
          "ਜ਼ਰੂਰੀ ਨਹੀਂ। ਬਹੁਤ ਲੀਕ ਫਲੈਸ਼ਿੰਗ/ਆਲੇ-ਦੁਆਲੇ ਛੱਤ - sealed unit fogging ਜਾਂ ਫਰੇਮ degrade 'ਤੇ ਬਦਲੀ ਚਰਚਾ।",
      },
      {
        question: "ਰੀਰੂਫ 'ਤੇ ਸਕਾਈਲਾਈਟ ਬਦਲੋ?",
        answer:
          "ਅਕਸਰ ਢੁਕਵਾਂ: ਫਲੈਸ਼ਿੰਗ ਵੈਸੇ ਵੀ, ਪਹੁੰਚ ਮੌਜੂਦ, ਬੁਢੇ ਯੂਨਿਟ ਨਵੀਂ ਛੱਤ ਨਾਲੋਂ ਘੱਟ ਚਲਣਗੇ। ਠੀਕ ਯੂਨਿਟ ਰੱਖ + ਸਹੀ ਦੁਬਾਰਾ ਫਲੈਸ਼।",
      },
      {
        question: "ਸਿਰਫ ਹਵਾ-ਮੀਂਹ 'ਤੇ ਕਿਉਂ?",
        answer:
          "ਹਵਾ-ਮੀਂਹ vertical rain ਨਾਲੋਂ ਵੱਖ load - overlap ਚੜ੍ਹ ਸਕਦੀ। ਫਲੈਸ਼ਿੰਗ ਜਿਓਮੈਟਰੀ; glass seal ਨਹੀਂ।",
      },
    ],
  },
  "chimney-flashing-repair": {
    title: "ਚਿਮਨੀ ਫਲੈਸ਼ਿੰਗ ਮੁਰੰਮਤ",
    shortTitle: "ਚਿਮਨੀ ਫਲੈਸ਼ਿੰਗ",
    eyebrow: "ਚਿਮਨੀ ਇੰਟਰਫੇਸ",
    description:
      "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਛੱਤਾਂ 'ਤੇ step flashing, counter-flashing ਅਤੇ ਚਿਮਨੀ-ਸੰਬੰਧਿਤ ਲੀਕ ਸੁਧਾਰ।",
    definition:
      "ਚਿਮਨੀ ਫਲੈਸ਼ਿੰਗ ਮurmੰਮਤ ਈਂਟ/ਫਰੇਮ ਚਿਮਨੀ ਅਤੇ ਛੱਤ ਜੋੜ 'ਤੇ ਪਾਣੀ ਡrerਨ ਕਰਨ ਵਾਲੇ ਧਾਤ ਇੰਟਰਫੇਸ ਬਹਾਲ।",
    forWhom:
      "ਚਿਮਨੀ ਕੋਣਾਂ 'ਤੇ ਲੀਕ, counter-flashing ਜੰਗ, ਜਾਂ cricket // NEEDS HUMAN REVIEW: cricket ਵੇਰਵੇ ਬੁਢਾਪਾ।",
    warningSigns: [
      "ਚਿਮਨੀ ਕੋਣ ਧੱਬੇ",
      "counter-flashing ਜੰਗ",
      "ਈਂਟ joint + ਛੱਤ ਹੇਠ ਲੀਕ",
      "ਚੌੜੀ ਚਿਮਨੀ 'ਤੇ upslope cricket ਗਾਇਬ",
      "ਚਿਮਨੀ ਬੇਸ 'ਤੇ ਤਾਰ",
    ],
    evaluates: [
      "ਚਿਮਨੀ ਆਕਾਰ/ਜਿਓਮੈਟਰੀ",
      "step/counter-flashing",
      "upslope cricket ਲੋੜ",
      "masonry interface",
      "ਆਲੇ-ਦੁਆਲੇ ਢੱਕਣ",
    ],
    causes: [
      "step flashing ਗਲਤ weave",
      "counter-flashing masonry ਤੋਂ ਵੱਖ",
      "ਥਰਮਲ ਮੂਵਮੈਂਟ",
      "upslope cricket ਗਾਇਬ",
      "ਬੁਢਾਪਾ/ਜੰਗ",
    ],
    methodology: [
      "ਚਿਮਨੀ ਚਿਹਰੇ ਅਤੇ ਛੱਤ ਜੋੜ ਜਾਂਚ",
      "ਲੋੜ 'ਤੇ ਧਾਤ layers ਖੋਲ੍ਹ",
      "step/counter ਸਹੀ ਇੰਸਟਾਲ",
      "cricket ਵੇਰਵਾ ਜੋੜ/ਬਹਾਲ",
      "ਆਲੇ-ਦੁਆਲੇ ਢੱਕਣ ਦੁਬਾਰਾ ਏਕੀਕ੍ਰਿਤ",
    ],
    materials: [
      "step/counter flashing",
      "cricket framing/covering",
      "ਅਨੁਕੂਲ underlayment",
      "mortar/ਸੀਲੈਂਟ ਸਿਰਫ ਉਚਿਤ ਦੂਜੀ ਵੇਰਵੇ",
    ],
    bcClimate:
      "ਚਿਮਨੀ ਕੋਣ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਹਵਾ-ਮੀਂਹ ਵਿੱਚ ਉੱਚ-ਤਣਾਅ ਗੀਲੇ ਜ਼ੋਨ; ਸਤਹੀ ਤਾਰ ਧਾਤ layers ਦੀ ਥਾਂ ਨਹੀਂ।",
    whenAppropriate: "ਚਿਮਨੀ/ਆਲੇ-ਦੁਆਲੇ ਫੀਲਡ ਸਹੀ ਦੁਬਾਰਾ ਫਲੈਸ਼ ਸਹਾਰਾ ਦੇਵੇ।",
    whenOtherService: "ਢੱਕਣ end-of-life → ਦੁਬਾਰਾ ਫਲੈਸ਼ਿੰਗ ਬਦਲੀ ਯੋਜਨਾ ਨਾਲ।",
    process: [
      "ਚਿਮਨੀ ਫੋਟੋ/ਅੰਦਰੂਨੀ ਧੱਬੇ",
      "ਚਿਹਰੇ/ਛੱਤ ਜੋੜ ਜਾਂਚ",
      "ਦੁਬਾਰਾ ਬਣਾਉਣ ਵਾਲੀਆਂ ਧਾਤ layers ਲਿਖਤ",
      "step/counter/cricket",
      "ਢੱਕਣ ਏਕੀਕ੍ਰਿਤ + ਨਤੀਜਾ",
    ],
    solutionCategories: [
      { title: "step flashing ਬਹਾਲ", body: "ਢੱਕਣ ਨਾਲ woven metal।" },
      { title: "counter-flashing ਸੁਧਾਰ", body: "masonry/ cladding ਵਿੱਚ upper metal।" },
      { title: "cricket ਵਾਟਰਸ਼ੈਡ", body: "ਚੌੜੀ ਚਿਮਨੀ upslope ਡrerਨ।" },
    ],
    repairVsReplace: {
      repair: "ਫੀਲਡ ਵਰਤੋਂਯੋਗ → ਚਿਮਨੀ ਦੁਬਾਰਾ ਫਲੈਸ਼।",
      replace: "ਫੀਲਡ ਟਿਕਾਊ ਏਕੀਕਰਣ ਨਹੀਂ → ਰੀਰੂਫ ਨਾਲ।",
    },
    scopeFactors: ["ਚਿਮਨੀ ਚੌੜਾਈ", "ਛੱਤ ਢਲਾਨ", "masonry", "ਪਹੁੰਚ", "ਆਲੇ-ਦੁਆਲੇ ਢੱਕਣ ਉਮਰ"],
    publicPriceHint:
      "ਚਿਮਨੀ ਕੰਮ ਚਿਮਨੀ ਚੌੜਾਈ, ਢਲਾਨ, masonry, ਆਲੇ-ਦੁਆਲੇ ਢੱਕਣ ਖੋਲ੍ਹ/ਏਕੀਕ੍ਰਿਤ 'ਤੇ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਚਿਮਨੀ ਫਲੈਸ਼ਿੰਗ ਮੁਰੰਮਤ ਕੀ ਹੈ?",
        answer: "ਈਂਟ/ਫਰੇਮ ਚਿਮਨੀ ਅਤੇ ਛੱਤ ਜੋੜ 'ਤੇ ਧਾਤ ਡrerਨ ਇੰਟਰਫੇਸ ਬਹਾਲ।",
      },
      {
        question: "ਨਵੀਂ ਛੱਤ: ਚਿਮਨੀ ਅਜੇ ਲੀਕ?",
        answer:
          "ਰੀਰੂਫ ਬਾਅਦ ਕਮਜ਼ੋਰ ਬਿੰਦੂ: counter-flashing reuse/step weave ਗਲਤ → ਨਵੀਂ ਢੱਕਣ ਪਾਣੀ ਸਿੱਧਾ। ਚਿਮਨੀ ਵੱਖਰਾ ਵੇਰਵਾ।",
      },
      {
        question: "counter-flashing ਕੀ?",
        answer:
          "step flashing ਸ਼ਿੰਗਲ ਉੱਤੇ; counter-flashing masonry ਵਿੱਚ, step vertical leg cover। ਬਿਨਾਂ counter, ਪਾਣੀ step ਪਿੱਛੇ।",
      },
      {
        question: "cricket ਲੋੜ?",
        answer:
          "ਚੌੜੀ ਚਿਮਨੀ upslope 'ਤੇ ਪਾਣੀ/ਮਲਬਾ। cricket = ਛੋਟਾ watershed ridge। ਚਿਮਨੀ ਚੌੜਾਈ, ਢਲਾਨ, ਸਥਿਤੀ 'ਤੇ।",
      },
      {
        question: "ਤਾਰ ਚਿਮਨੀ ਫਲੈਸ਼ਿੰਗ?",
        answer:
          "ਐਮਰਜੈਂਸੀ ਠੰਡਕ - ਟਿਕਾਊ ਮੁਰੰਮਤ ਨਹੀਂ। ਸikrinks, ਪਾਣੀ ਫਸਾਉਂਦਾ, metal ਛੁਪਾਉਂਦਾ। ਟਿਕਾਊ = metal layers ਦੁਬਾਰਾ।",
      },
    ],
  },
  "gutter-replacement": {
    title: "ਗਟਰ ਬਦਲਣਾ",
    shortTitle: "ਗਟਰ ਬਦਲਣਾ",
    eyebrow: "ਈਵ ਡrerਨੇਜ ਸਿਸਟਮ",
    description: "ਨਿਰਵਿਘਨ ਐਲੂਮੀਨੀਅਮ ਗਟਰ ਅਤੇ ਡਾਊਨਸਪਾਊਟ ਬਦਲੀ - ਈਵ ਡrerਨੇਜ ਭਰੋਸੇਮੰਦ।",
    definition:
      "ਗਟਰ ਬਦਲਣਾ ਨਵੇਂ ਗਟਰ/ਡਾਊਨਸਪਾਊਟ - ਸਾਈਜ਼ ਅਤੇ ਢਲਾਨ ਨਾਲ ਛੱਤ ਦਾ ਪਾਣੀ building envelope ਤੋਂ ਦੂਰ।",
    forWhom: "ਸਫਾਈ ਤੋਂ ਬਾਅਦ ਵੀ ਓਵਰਫਲੋ, ਜੰਗ/ਵੱਖ ਗਟਰ, fascia ਨੁਕਸਾਨ ਵਾਲੇ ਘਰ ਦੇ ਮਾਲਕ।",
    warningSigns: [
      "ਸੀਮ ਫਟ",
      "fascia ਤੋਂ ਗਟਰ ਵੱਖ",
      "ਸਫਾਈ ਤੋਂ ਬਾਅਦ ਓਵਰਫਲੋ",
      "ਜੰਗ ਛेद",
      "ਢਲਾਨ ਸਥਾਨ 'ਤੇ ਠੀਕ ਨਹੀਂ",
    ],
    evaluates: ["ਲੀਨੀਅਰ ਲੰਬਾਈ/ਮੰਜ਼ਿਲ", "ਆਊਟਲੈੱਟ ਡਿਜ਼ਾਈਨ", "fascia", "ਰੰਗ/ਪ੍ਰੋਫਾਈਲ", "ਡਾਊਨਸਪਾਊਟ ਰਨ"],
    causes: ["ਮੈਟਲ end-of-life", "ਛੋਟਾ ਸਾਈਜ਼", "fascia shift", "ਮਲਬਾ load", "ਗਲਤ ਇੰਸਟਾਲ"],
    methodology: [
      "fascia ready ਪੁਸ਼ਟੀ",
      "ਢਲਾਨ/ਆਊਟਲੈੱਟ ਯੋਜਨਾ",
      "seamless install",
      "ਵਾਟਰ ਪਾਥ ਟੈਸਟ",
      "splash/ਡrerਨ",
    ],
    materials: ["seamless ਐਲੂਮੀਨੀਅਮ ਗਟਰ", "ਡਾਊਨਸਪਾਊਟ/elbows", "hangers", "end caps/outlets"],
    bcClimate: "ਭਾਰੀ ਬਾਰਿਸ਼ - ਸਹੀ ਗਟਰ ਸਾਈਜ਼/ਢਲਾਨ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਘਰਾਂ ਲਈ ਜ਼ਰੂਰੀ।",
    whenAppropriate: "ਮੌਜੂਦਾ ਗਟਰ ਸਫਾਈ/ਛੋਟੀ ਮੁਰੰਮਤ ਤੋਂ ਬਾਅਦ ਵੀ ਡrerਨ ਨਹੀਂ।",
    whenOtherService: "ਟਰਫ ਠੀਕ → ਸਫਾਈ/ਗਾਰਡ ਕਾਫ਼ੀ।",
    process: [
      "ਲੰਬਾਈ, ਆਊਟਲੈੱਟ, ਰਨ ਮਾਪ",
      "fascia ਨਵੇਂ hangers ਲਈ",
      "ਲਿਖਤ ਸਕੋਪ: ਪ੍ਰੋਫਾਈਲ/ਰੰਗ",
      "on-site seamless",
      "ਵਾਟਰ ਟੈਸਟ",
    ],
    solutionCategories: [
      { title: "seamless ਈਵ", body: "ਢਲਾਨ → ਆਊਟਲੈੱਟ।" },
      { title: "ਡਾਊਨਸਪਾਊਟ ਡਿਜ਼ਾਈਨ", body: "ਨੀਂਹ/ਸਿਡਵੌਕ ਤੋਂ ਦੂਰ।" },
      { title: "fascia ਤਾਲਮੇਲ", body: "ਨਰਮ fascia ਪਹਿਲਾਂ।" },
    ],
    repairVsReplace: {
      repair: "ਮੈਟਲ/ਜਿਓਮੈਟਰੀ ਫੇਲ੍ਹ → ਬਦਲੀ।",
      replace: "ਸਿਸਟਮ ਠੀਕ → ਸਫਾਈ/ਮੁਰੰਮਤ।",
    },
    scopeFactors: ["ਲੀਨੀਅਰ ਲੰਬਾਈ", "ਉਚਾਈ/ਪਹੁੰਚ", "ਆਊਟਲੈੱਟ", "ਰੰਗ", "fascia ਮੁਰੰਮਤ"],
    publicPriceHint: "ਬਦਲੀ ਲੀਨੀਅਰ ਲੰਬਾਈ, ਮੰਜ਼ਿਲ, ਆਊਟਲੈੱਟ, fascia prep 'ਤੇ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਗਟਰ ਬਦਲਣਾ ਕੀ ਹੈ?",
        answer: "ਨਵੇਂ ਗਟਰ/ਡਾਊਨਸਪਾਊਟ - ਸਾਈਜ਼/ਢਲਾਨ ਨਾਲ ਛੱਤ ਪਾਣੀ envelope ਤੋਂ ਦੂਰ।",
      },
      {
        question: "seamless?",
        answer: "site 'ਤੇ continuous length; seams ਸਿਰਫ corners/outlets - ਘੱਟ ਭਵਿੱਖ ਲੀਕ।",
      },
      {
        question: "ਰੀਰੂਫ ਨਾਲ ਗਟਰ?",
        answer:
          "ਦੋਵੇਂ end-of-life → ਇਕੱਠੇ; ਨਵੀਂ ਛੱਤ ਦੌਰਾਨ ਨਵੇਂ ਗਟਰ ਨੁਕਸਾਨ। ਠੀਕ ਗਟਰ ਸਿਰਫ ਛੱਤ ਲਈ ਨਹੀਂ।",
      },
      {
        question: "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਗਟਰ ਸਾਈਜ਼?",
        answer: "roof area, slope, outlets - ਇੱਕ ਜਵਾਬ ਨਹੀਂ। local intensity ਛੋਟੇ ਗਟਰ ਜਲਦੀ expose।",
      },
      {
        question: "ਡਾਊਨਸਪਾਊਟ ਨੀਂਹ ਤੋਂ?",
        answer: "extensions, splash, ਮੌਜੂਦਾ grade drain - basement旁 avoid।",
      },
    ],
  },
  "gutter-guard-installation": {
    title: "ਗਟਰ ਗਾਰਡ ਇੰਸਟਾਲੇਸ਼ਨ",
    shortTitle: "ਗਟਰ ਗਾਰਡ",
    eyebrow: "ਮਲਬਾ ਸੁਰੱਖਿਆ",
    description: "ਰੁੱਖ-ਭਾਰੀ ਜਾਇਦਾਦਾਂ ਲਈ ਪੱਤੇ, ਮੌਸ ਅਤੇ ਮਲਬਾ ਬਲਾਕ ਘੱਟ।",
    definition: "ਗਟਰ ਗਾਰਡ ਗਟਰ ਉੱਪਰ ਸੁਰੱਖਿਆ - ਪੱਤੇ/ਮਲਬਾ ਘੱਟ, ਪਾਣੀ ਟਰਫ ਵਿੱਚ।",
    forWhom: "ਵਾਰ-ਵਾਰ ਸਫਾਈ, ਮulti-storey ਪਹੁੰਚ ਮੁਸ਼ਕਲ, ਭਾਰੀ ਰੁੱਖ ਹੇਠ।",
    warningSigns: [
      "ਸਾਲ ਵਿੱਚ ਕਈ ਸਫਾਈ",
      "ਮulti-storey ਪਹੁੰਚ",
      "needle ਮਲਬਾ",
      "ਸਫਾਈ ਤੋਂ ਛੋਟੀ der ਵਿੱਚ ਡਾਊਨਸਪਾਊਟ ਬਲਾਕ",
      "ਰੱਖ-ਰਖਾਅ ਪਹੁੰਚ ਸੀਮਤ",
    ],
    evaluates: [
      "ਪਹਿਲਾਂ ਗਟਰ ਸੰਰਚਨਾ",
      "ਮਲਬਾ character",
      "product fit",
      "roof edge ਜਿਓਮੈਟਰੀ",
      "ਰੱਖ-ਰਖਾਅ ਉਮੀਦ",
    ],
    causes: ["ਘਣਾ ਹਰਾ", "ਛੱਤ ਜਿਓਮੈਟਰੀ → ਟਰਫ", "fine debris simple screens", "ਅਸੰਗਤ intervals"],
    methodology: [
      "ਗਟਰ ਠੀਕ ਪੁਸ਼ਟੀ",
      "ਢੁਕਵਾਂ guard",
      "install + edge/inflow",
      "ਵਾਟਰ ਟੈਸਟ",
      "ਬਾਕੀ ਰੱਖ-ਰਖਾਅ ਸਮਝਾਓ",
    ],
    materials: ["guard components", "compatible fasteners", "edge accessories"],
    bcClimate: "ਤਟੀ ਰੁੱਖ needles/moss debris - guards ਘੱਟ ਕਰਦੇ, eliminate ਨਹੀਂ।",
    whenAppropriate: "ਗਟਰ ਠੀਕ + ਮਲਬਾ load ਮੁੱਖ।",
    whenOtherService: "ਫੇਲ੍ਹ ਗਟਰ - guard ਤੋਂ ਪਹਿਲਾਂ ਬਦਲੀ।",
    process: [
      "ਗਟਰ + debris character",
      "ਰੁੱਖਾਂ ਲਈ guard type",
      "pre-clean ਸਕੋਪ",
      "install + edge",
      "ਬਾਕੀ rhythm ਈਮਾਨਦਾਰ",
    ],
    solutionCategories: [
      { title: "debris system", body: "ਪੱਤੇ/needles ਘੱਟ।" },
      { title: "compatibility", body: "ਸਿਰਫ ਡrerਨ ਕਰਦੇ ਗਟਰ।" },
      { title: "expectations", body: "guard ਕੀ ਘੱਟ/ਕੀ periodic।" },
    ],
    repairVsReplace: {
      repair: "ਠੀਕ ਗਟਰ + high debris → guard।",
      replace: "ਫੇਲ੍ਹ ਮੈਟਲ → ਪਹਿਲਾਂ ਗਟਰ।",
    },
    scopeFactors: ["linear length", "product", "debris", "access", "existing gutter"],
    publicPriceHint:
      "guard product, length, edge geometry, gutter condition 'ਤੇ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਗਟਰ ਗਾਰਡ ਇੰਸਟਾਲੇਸ਼ਨ?",
        answer: "ਗਟਰ ਉੱਪਰ ਸੁਰੱਖਿਆ - ਮਲਬਾ ਘੱਟ, ਪਾਣੀ ਟਰਫ ਵਿੱਚ।",
      },
      {
        question: "guard = ਕੋਈ ਸਫਾਈ ਨਹੀਂ?",
        answer: "ਨਹੀਂ - frequency ਘੱਟ, zero ਨਹੀਂ। debris guard ਉੱਪਰ; outlets periodic।",
      },
      {
        question: "pine needles?",
        answer:
          "simple perforated → through। micro-mesh better; film occasionally brush। product = actual drop।",
      },
      {
        question: "existing gutter 'ਤੇ?",
        answer:
          "ਹਾਂ ਜੇ structurally sound, slope, secure। failed gutter 'ਤੇ lock-in - condition first।",
      },
      {
        question: "heavy rain?",
        answer:
          "correct product/install OK। mismatch → overflow steep eaves; slope/eave velocity matters।",
      },
    ],
  },
  "roof-ventilation-upgrade": {
    title: "ਛੱਤ ਹਵਾਦਾਰੀ ਅਪਗ੍ਰੇਡ",
    shortTitle: "ਹਵਾਦਾਰੀ ਅਪਗ੍ਰੇਡ",
    eyebrow: "ਐਟਿਕ ਏਅਰਫਲੋ",
    description:
      "box vents, ridge vent, soffit intake ਅਤੇ ਐਟਿਕ ਏਅਰਫਲੋ ਸੁਧਾਰ - ਛੱਤ ਅਤੇ ਐਟਿਕ prformance ਲਈ।",
    definition:
      "ਛੱਤ ਹਵਾਦਾਰੀ ਅਪਗ੍ਰੇਡ intake ਅਤੇ exhaust ਮਾਰਗ ਸੁਧਾਰਦਾ ਹੈ ਤਾਂ ਐਟਿਕ ਮੌਜੂਦਾ imbalance 'ਤੇ ਨਮੀ ਅਤੇ ਗarmੀ ਬਿਹਤਰ ਸੰਭਾਲੇ।",
    forWhom:
      "ਐਟਿਕ condensation, ਸ਼ਿੰਗਲ ਦੀ ਅਸਮਾਨ aging, soffit intake blocked, ਜਾਂ exhaust ਘੱਟ ਵਾਲੇ ਘਰ ਦੇ ਮਾਲਕ।",
    warningSigns: [
      "ਐਟਿਕ condensation ਜਾਂ frost",
      "ਐਟਿਕ ਵਿੱਚ ਬਦਬੂ",
      "ਸ਼ਿੰਗਲ ਦੀ ਅਸਮਾਨ ਘਿਸਾਈ",
      "soffit intake blocked ਜਾਂ sealed",
      "ਐਟਿਕ overheating ਨਾਲ ਨਮੀ ਵਧਣਾ",
    ],
    evaluates: [
      "ਐਟਿਕ construction",
      "ਮੌਜੂਦਾ exhaust vents",
      "intake continuity",
      "soffit insulation layout",
      "ਛੱਤ geometry ਸੀਮਾਵਾਂ",
    ],
    causes: [
      "exhaust ਘੱਟ",
      "intake blocked",
      "insulation soffit 'ਤੇ",
      "bath/kitchen fans ਐਟਿਕ ਵਿੱਚ",
      "re-roof ਬਿਨਾਂ vent design",
    ],
    methodology: [
      "intake/exhaust balance ਮੁਲਾਂਕਣ",
      "soffit intake clear/restore",
      "exhaust add/fix",
      "intake ਬਿਨਾਂ over-exhaust ਨਹੀਂ",
      "insulation/air-seal coordinate",
    ],
    materials: [
      "spec ਮutਾਬਕ ridge/box/other vents",
      "soffit intake components",
      "baffles",
      "ਨਵੇਂ penetration flashing",
    ],
    bcClimate: "ਠੰਡਾ ਗੀਲਾ BC - ਐਟਿਕ ਨਮੀ prabandhan; ਹਵਾਦਾਰੀ ਸਿਸਟਮ ਦਾ ਹਿੱਸਾ, ਸਭ ਲੀਕਾਂ ਦਾ ਇਲਾਜ ਨਹੀਂ।",
    whenAppropriate: "airflow imbalance → ਐਟਿਕ ਨਮੀ/ਢੱਕਣ ਘਿਸਾਈ ਤੇਜ਼।",
    whenOtherService: "vent upgrade ≠ ਲੀਕ ਮੁਰੰਮਤ ਜਾਂ ਸਾਰੇ condensation ਸਰੋਤ।",
    process: [
      "ਐਟਿਕ + ਬਾਹਰੀ vents review",
      "volume balance",
      "ਲਿਖਤ ਸਕੋਪ vents/intake/baffles",
      "install + flash",
      "paths clear confirm",
    ],
    solutionCategories: [
      { title: "exhaust ਅਪਗ੍ਰੇਡ", body: "ridge/box/other ਜਿੱਥੇ fit।" },
      { title: "intake ਬਹਾਲ", body: "blocked soffit paths।" },
      { title: "balance review", body: "volume ਲਈ coherent strategy।" },
    ],
    repairVsReplace: {
      repair: "documented imbalance → upgrade।",
      replace: "vents waterproofing substitute ਨਹੀਂ।",
    },
    scopeFactors: [
      "ਐਟਿਕ volume",
      "existing vent types",
      "intake availability",
      "cover type",
      "ਪਹੁੰਚ",
    ],
    publicPriceHint: "volume, vent types, intake, cover work 'ਤੇ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਛੱਤ ਹਵਾਦਾਰੀ ਅਪਗ੍ਰੇਡ ਕੀ ਹੈ?",
        answer: "intake ਅਤੇ exhaust ਮਾਰਗ ਸੁਧਾਰ - imbalance 'ਤੇ ਐਟਿਕ ਨਮੀ/ਗarmੀ ਬਿਹਤਰ ਸੰਭਾਲ।",
      },
      {
        question: "ਖਰਾਬ ਐਟਿਕ ਹਵਾਦਾਰੀ ਦੇ ਕੀ signs?",
        answer:
          "ਸਰਦੀ deck-side condensation/frost, ਬਦਬੂ, mold spots, nail rust, ਸ਼ਿੰਗਲ aging uneven - coastal BC ਵਿੱਚ ਅਕਸਰ ਨਮੀ, ਗarmੀ ਨਹੀਂ।",
      },
      {
        question: "ਹੋਰ roof vents condensation ਠੀਕ?",
        answer:
          "ਸਿਰਫ exhaust ਕਾਫ਼ੀ ਨਹੀਂ - soffit intake ਬਿਨਾਂ interior air ਖਿੱਚ ਸਕਦਾ, ਨਮੀ ਵਧੇ। bath fans ਐਟਿਕ, air leaks ਅਕਸਰ ਅਸਲ ਕਾਰਨ - ਪੂਰਾ path।",
      },
      {
        question: "ridge vent vs box vent?",
        answer:
          "ridge vent ridge ਦੇ ਨਾਲ continuous; box vent ridge ਨੇੜੇ discrete - length, geometry, intake distribution 'ਤੇ।",
      },
      {
        question: "ਬਿਹਤਰ ਹਵਾਦਾਰੀ → ਲੰਬੀ ਸ਼ਿੰਗਲ life?",
        answer:
          "balanced vent ਐਟਿਕ heat/moisture load ਘਟਾਉਂਦਾ - exposure, quality, install ਨਾਲ ਇੱਕ factor; ਮਦਦ, guarantee ਨਹੀਂ।",
      },
    ],
  },
  "fascia-soffit-repair-replacement": {
    title: "fascia + soffit ਮੁਰੰਮਤ / ਬਦਲੀ",
    shortTitle: "fascia/soffit",
    eyebrow: "ਈਵ ਕੰਪੋਨੈਂਟ",
    description:
      "ਸੜੀ/ਖਰਾਬ fascia, soffit ਅਤੇ eave assemblies - ਗਟਰ/edge support। // NEEDS HUMAN REVIEW: fascia/soffit Gurmukhi loanwords",
    definition:
      "fascia/soffit ਮੁਰੰਮਤ/ਬਦਲੀ eave components ਬਹਾਲ - finished edge, gutter support, intake ventilation।",
    forWhom: "soft fascia, failed soffit, gutters pulling away, pest gaps at eaves।",
    warningSigns: [
      "soft/rotten fascia",
      "sagging soffit",
      "gutter brackets pulled",
      "paint fail + rot",
      "pest openings",
    ],
    evaluates: [
      "damage linear extent",
      "material choice",
      "soffit vent needs",
      "gutter re-fasten plan",
      "paint/finish scope",
    ],
    causes: [
      "gutter overflow wet wood",
      "edge metal fail",
      "material end-of-life",
      "vent moisture",
      "impact/remodel",
    ],
    methodology: [
      "probe + map length",
      "remove failed",
      "new fascia/soffit",
      "restore vent openings",
      "gutter reinstall coordinate",
    ],
    materials: [
      "fascia or wrap system",
      "soffit panels",
      "fasteners/trim",
      "paint/finish if in scope",
    ],
    bcClimate: "wet months gutter overflow → common Metro Vancouver fascia rot।",
    whenAppropriate: "eave damage but cover field may still be OK।",
    whenOtherService: "gutter/roof edge causing damage → coordinate with gutter/edge work।",
    process: [
      "probe/map eave length",
      "gutter off/on plan",
      "written scope materials/finish",
      "remove rot + install",
      "restore intake + re-hang gutters",
    ],
    solutionCategories: [
      { title: "fascia restore", body: "rotten boards supporting gutter/edge metal।" },
      { title: "soffit repair", body: "soffit panels + intake openings।" },
      { title: "eave coordination", body: "gutter/edge sequence with new components।" },
    ],
    repairVsReplace: {
      repair: "localized damage।",
      replace: "continuous rot along eave।",
    },
    scopeFactors: ["linear length", "material", "height/access", "finish", "gutter coordination"],
    publicPriceHint:
      "length, height/access, material/finish, gutter coordination 'ਤੇ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "fascia + soffit ਮੁਰੰਮਤ/ਬਦਲੀ?",
        answer: "eave components - finished edge, gutter support, intake ventilation restore।",
      },
      {
        question: "fascia why rot?",
        answer:
          "common sequence: gutter overflow/drip edge fail → repeated wet seasons → paint fail → wood stays wet → rot accelerates - fix water source + replace boards।",
      },
      {
        question: "fascia without removing gutters?",
        answer:
          "rarely done well - gutters through fascia; proper replace = remove/re-hang + slope/attachment to sound board।",
      },
      {
        question: "soffit part of attic vent?",
        answer:
          "most homes yes - soffit panels with intake vents; must preserve/restore on replace; cosmetic block → hidden attic moisture।",
      },
      {
        question: "wood vs aluminum vs composite fascia?",
        answer:
          "wood traditional maintainable; aluminum wrap durable detail traps moisture if wrong; composite low rot maintenance - exposure/budget/form guide choice।",
      },
    ],
  },
  "cedar-shake-repair-restoration": {
    title: "cedar shake ਮੁਰੰਮਤ / ਬਹਾਲੀ",
    shortTitle: "cedar ਮੁਰੰਮਤ",
    eyebrow: "premium wood roof",
    description:
      "damaged cedar shakes replace + localized clean/restore premium wood roofs। // NEEDS HUMAN REVIEW: cedar shake terminology",
    definition:
      "cedar shake repair restores discrete failed shakes/details while broader cedar roof still worth maintaining।",
    forWhom: "cedar roof with cracked/missing/cupped shakes in limited areas।",
    warningSigns: [
      "single shake crack/missing",
      "localized cupping",
      "moss trapping moisture on wood",
      "fastener rust + discrete fail",
      "low-slope cedar debris",
    ],
    evaluates: [
      "matching shake availability",
      "remaining field condition",
      "cleaning needs",
      "flashing interfaces",
      "closer to systemic replace?",
    ],
    causes: [
      "UV wet/dry cycles",
      "biological growth",
      "impact",
      "prior poor repair",
      "premium wood aging still maintainable",
    ],
    methodology: [
      "source matching shakes",
      "careful replace failed units",
      "debris/growth trapping moisture",
      "review flashing in work zone",
      "document remaining life indicators",
    ],
    materials: [
      "appropriate grade cedar shakes",
      "underlayment patch if needed",
      "compatible fasteners",
      "wood-roof-appropriate cleaning",
    ],
    bcClimate:
      "BC damp climate demands on wood - maintainable field → maintenance extends service life।",
    whenAppropriate: "failures localized + broader cedar field still maintainable।",
    whenOtherService: "systemic cupping, leaks, underlayment fail → full cedar replace।",
    process: [
      "assess field, growth, failure locations",
      "source matching grade",
      "written scope repair/clean areas",
      "replace shakes + moisture debris",
      "document remaining life for planning",
    ],
    solutionCategories: [
      {
        title: "selective shake replace",
        body: "restore failed units without abandoning maintainable field।",
      },
      {
        title: "localized cleaning",
        body: "reduce debris/growth trapping moisture in repair zone।",
      },
      { title: "condition triage", body: "maintainable cedar vs full replace discussion।" },
    ],
    repairVsReplace: {
      repair: "field still worth maintaining।",
      replace: "wood wear systemic।",
    },
    scopeFactors: [
      "repair area",
      "shake matching",
      "access",
      "cleaning scope",
      "adjacent flashing",
    ],
    publicPriceHint:
      "repair area, shake match, access, cleaning, adjacent flashing 'ਤੇ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "cedar shake ਮੁਰੰਮਤ/ਬਹਾਲੀ?",
        answer: "discrete failed shakes/details while broader cedar still worth maintaining।",
      },
      {
        question: "repair or replace cedar?",
        answer:
          "whole field + underlayment below - not worst few shakes; localized crack on sound field → repair; widespread cupping/soft shakes/repeat leaks → replace planning।",
      },
      {
        question: "why shakes cup/crack?",
        answer:
          "cedar moves wet/dry; sunny slopes dry/crack; shady damp cup/moss; age/grade/fastening timing।",
      },
      {
        question: "treatment extend life?",
        answer:
          "keeping cedar moss/debris-free highest-value maintenance here - trapped moisture drives decay; surface treatments exist case-by-case - supplement drainage/drying not replace।",
      },
      {
        question: "match existing cedar color?",
        answer:
          "new golden → weathers grey - visible at first, blends; discuss location/expectations if appearance-sensitive।",
      },
    ],
  },
  "flat-low-slope-roof-repair": {
    title: "ਫਲੈਟ / ਘੱਟ-ਢਲਾਨ ਛੱਤ ਮੁਰੰਮਤ",
    shortTitle: "ਫਲੈਟ ਮੁਰੰਮਤ",
    eyebrow: "low-slope membrane",
    description: "flat/low-slope roofs - SBS, torch, TPO/EPDM patches, flashing, penetrations।",
    definition:
      "flat/low-slope repair handles membrane seams, flashing, penetrations, localized membrane fail without full low-slope replace।",
    forWhom: "ponding leaks, seam fail, curb leaks, membrane openings on low-slope roofs।",
    warningSigns: [
      "seams open",
      "puncture marks",
      "pitch pan/penetration pocket fail",
      "blistering with moisture",
      "drains/scuppers not controlling water",
    ],
    evaluates: [
      "membrane type",
      "patch compatibility",
      "drainage pattern",
      "penetration condition",
      "insulation wet beyond local repair?",
    ],
    causes: [
      "membrane aging",
      "foot traffic",
      "ponding stress",
      "parapet flashing shift",
      "incompatible prior patches",
    ],
    methodology: [
      "identify membrane system",
      "compatible patch method",
      "repair flashing/penetrations",
      "improve local drainage detail if feasible",
      "recommend replace if system exhausted",
    ],
    materials: [
      "compatible membrane patches",
      "flashing metal/accessories",
      "penetration pockets/prefab details",
      "adhesive/torch per system",
    ],
    bcClimate:
      "long wet season + ponding risk → seams/drainage critical on Metro Vancouver low-slope।",
    whenAppropriate: "localized fail + membrane field accepts durable patch।",
    whenOtherService: "insulation saturated or systemic seam fail → replace planning।",
    process: [
      "identify membrane + failure points",
      "moisture/drainage around damage",
      "written compatible patch/details",
      "install per system",
      "review drainage + document",
    ],
    solutionCategories: [
      { title: "membrane patch", body: "seams/punctures/local damage compatible method।" },
      { title: "penetration/curb detail", body: "restore waterproofing at openings।" },
      { title: "drainage correction", body: "details trapping water at weak points।" },
    ],
    repairVsReplace: {
      repair: "membrane largely serviceable।",
      replace: "system saturated or repeat fail।",
    },
    scopeFactors: ["membrane type", "repair area", "access", "penetration count", "drainage"],
    publicPriceHint:
      "membrane type, area, penetrations, drainage, access 'ਤੇ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਫਲੈਟ/ਘੱਟ-ਢਲਾਨ ਮੁਰੰਮਤ?",
        answer:
          "membrane seams, flashing, penetrations, localized fail - not necessarily full replace।",
      },
      {
        question: "why patch depends on membrane?",
        answer:
          "SBS torch/adhesive mod-bit; TPO heat-weld; EPDM adhesive/tape - wrong material/method won't bond - misidentified patch common repeat leak cause।",
      },
      {
        question: "ponding problem?",
        answer:
          "water standing after rain stresses seams, ages membrane, magnifies small defects - some fixable (blocked drain, local low) - structural slope → replace-level discussion।",
      },
      {
        question: "repair flat roof in winter?",
        answer:
          "often yes with method adjustments - some adhesives temperature limits, surfaces dry; emergency stabilize almost always; some permanent details wait weather window।",
      },
      {
        question: "wet insulation below?",
        answer:
          "symptoms: persistent interior damp, blistering, soft underfoot; confirm moisture scan/test cut - wet insulation matters because patch traps moisture and continues degrade।",
      },
    ],
  },
  "metal-roof-repair-maintenance": {
    title: "metal ਛੱਤ ਮੁਰੰਮਤ / ਰੱਖ-ਰਖਾਅ",
    shortTitle: "metal ਮੁਰੰਮਤ",
    eyebrow: "metal system",
    description: "metal roof - fasteners, flashing, sealants, panels, penetrations।",
    definition:
      "metal roof repair/maintenance fixes fasteners, flashing, sealants, panel damage, penetrations while keeping serviceable panels।",
    forWhom:
      "loose fasteners, failed closures, penetration leaks, discrete panel damage on metal roofs।",
    warningSigns: [
      "exposed-fastener screws backing out",
      "foam closures failed",
      "penetration boots leaking",
      "detail sealant cracking",
      "cut edge corrosion at flashing",
    ],
    evaluates: [
      "panel profile",
      "coating condition",
      "fastener type",
      "closure/flashing details",
      "damage systemic?",
    ],
    causes: [
      "thermal movement",
      "wrong fastener type",
      "sealant aging",
      "impact dents",
      "coastal exposure",
    ],
    methodology: [
      "identify system type",
      "correct fasteners/closures",
      "repair flashing/penetrations",
      "discrete panel damage",
      "avoid surface caulk where metal detail needed",
    ],
    materials: [
      "compatible fasteners/washers",
      "closure strips",
      "flashing metal",
      "touch-up paint where appropriate",
    ],
    bcClimate:
      "coastal exposure + thermal movement → fasteners/flashing recurring maintenance on metal।",
    whenAppropriate: "panels sound + issues at component level।",
    whenOtherService: "systemic coating fail or obsolete profile → replace discussion।",
    process: [
      "identify profile + attachment",
      "inspect fasteners/closures/flashing/penetrations",
      "written scope maintenance vs repair",
      "correct with compatible components",
      "review roof as working system",
    ],
    solutionCategories: [
      { title: "fastener/closure maintenance", body: "restore weather-tight mechanical details।" },
      { title: "flashing/penetration repair", body: "fix interfaces admitting water।" },
      { title: "panel-level correction", body: "discrete damage without abandoning sound field।" },
    ],
    repairVsReplace: {
      repair: "metal field still serviceable - maintain/repair।",
      replace: "system no longer maintainable economically/technically।",
    },
    scopeFactors: ["system type", "access", "detail count", "coating", "penetration density"],
    publicPriceHint: "system type, details to correct, coating, access 'ਤੇ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "metal ਛੱਤ ਮੁਰੰਮਤ/ਰੱਖ-ਰਖਾਅ?",
        answer:
          "fasteners, flashing, sealants, panel damage, penetrations while keeping serviceable panels।",
      },
      {
        question: "why screws back out?",
        answer:
          "exposed-fastener relies on washer screws moving with thermal cycles; years → loosen/harden washers - correct fix sometimes oversized screws - normal maintenance not roof failure।",
      },
      {
        question: "vent pipe leaks common?",
        answer:
          "penetrations most common metal leak points - boots/collars age faster than panels, must accommodate movement - compatible boot replace usually fixes without touching field।",
      },
      {
        question: "dented panels repair?",
        answer:
          "cosmetic dents not harming coating/seams often leave; damage opening coating/seams or ponding → panel-level repair/replace affected length - most profiles feasible।",
      },
      {
        question: "standing seam vs exposed fastener maintenance?",
        answer:
          "standing seam hidden clips - little routine washer maintenance; focus flashing/penetrations/closure sealants; exposed fastener needs periodic fastener checks।",
      },
    ],
  },
  "cedar-shake-roof-replacement": {
    title: "cedar shake ਛੱਤ ਬਦਲਣਾ",
    shortTitle: "cedar ਬਦਲਣਾ",
    eyebrow: "premium wood re-roof",
    description:
      "full premium cedar shake re-roof for homes keeping wood roof character। // NEEDS HUMAN REVIEW: cedar terminology",
    definition:
      "cedar shake roof replacement full re-roof with cedar shakes or specified wood components - deck prep + correct premium wood details।",
    forWhom: "systemic cedar wear makes repair unreasonable but wood roof character still desired।",
    warningSigns: [
      "systemic cupping/cracking",
      "repeat leaks across slopes",
      "failed underlayment below cedar",
      "buy/sell/planning life concerns",
      "architectural intent keeps wood",
    ],
    evaluates: [
      "shake grade/profile",
      "underlayment strategy",
      "ventilation/drying",
      "fire/project context",
      "geometry complexity",
    ],
    causes: [
      "full service life end",
      "long-term moisture",
      "multi-slope storm loss",
      "deck issues discovered over time",
    ],
    methodology: [
      "assess deck/component needs",
      "shake system + underlayment plan",
      "protect property during tear-off",
      "install field/details as complete wood assembly",
      "explain cedar maintenance expectations",
    ],
    materials: [
      "specified grade cedar shakes",
      "underlayment system",
      "wood-roof-compatible flashing",
      "fasteners/ridge details",
    ],
    bcClimate:
      "BC premium wood roofs need honest maintenance expectations; replace resets assembly when repair can't keep pace with systemic wear।",
    whenAppropriate:
      "owner wants complete cedar system + existing wood at reasonable end of service।",
    whenOtherService: "field still strong localized fail → cedar repair may fit।",
    process: [
      "assess existing wood + deck",
      "grade/underlayment/details",
      "written scope + property protection",
      "tear-off/deck prep/install",
      "completion review + maintenance guidance",
    ],
    solutionCategories: [
      { title: "full cedar field", body: "new shakes as coherent system।" },
      { title: "deck/underlayment prep", body: "sheathing/drainage below wood।" },
      { title: "wood roof details", body: "flashing/edges for cedar performance।" },
    ],
    repairVsReplace: {
      repair: "localized only।",
      replace: "wear systemic + still choosing wood → full cedar re-roof।",
    },
    scopeFactors: ["roof area", "shake spec", "deck repair", "access", "project complexity"],
    publicPriceHint:
      "area/geometry, shake spec, deck repair, access - written scope via assessment।",
    faqs: [
      {
        question: "cedar shake ਛੱਤ ਬਦਲਣਾ?",
        answer: "full re-roof cedar/specified wood - deck prep + correct premium details।",
      },
      {
        question: "how long BC cedar roofs?",
        answer:
          "life varies grade/exposure/details especially maintenance - single number misleading; well-built/maintained decades here; neglected much sooner - discuss slope/shade expectations at assessment।",
      },
      {
        question: "shake vs shingle?",
        answer:
          "shake split thicker textured premium look; shingle sawn thinner uniform - affects appearance/details/cost at spec stage।",
      },
      {
        question: "special underlayment?",
        answer:
          "wood needs strategy shedding water + letting cedar dry - cedar performs poorly without breathing; interlayment + eave protection typical correct build।",
      },
      {
        question: "cedar still reasonable Metro Vancouver?",
        answer:
          "deliberate premium choice - architecture, neighborhood character, owner maintenance commitment; damp climate needs honest care expectations; minimal maintenance owners often better other premium systems।",
      },
    ],
  },
  "moss-removal-roof-gutter": {
    title: "ਮੌਸ ਹਟਾਉਣਾ + ਛੱਤ/ਗਟਰ",
    shortTitle: "ਮੌਸ/ਗਟਰ",
    eyebrow: "ਰੱਖ-ਰਖਾਅ ਪੈਕੇਜ",
    description:
      "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਘਰਾਂ ਲਈ ਮੌਸ ਹਟਾਉਣਾ, ਮਲਬਾ ਸਫਾਈ, ਗਟਰ ਸਫਾਈ ਅਤੇ ਛੱਤ ਦੀ visual ਜਾਂਚ - organic growth ਅਤੇ blocked drainage ਘਿਸਾਈ ਤੇਜ਼ ਕਰਦੇ ਹਨ।",
    definition:
      "ਮੌਸ + ਛੱਤ/ਗਟਰ ਰੱਖ-ਰਖਾਅ - ਢੱਕਣ 'ਤੇ organic growth, ਗਟਰ/ਡਾਊਨਸਪਾਊਟ ਸਫਾਈ, ਯੋਜਨਾ ਲਈ ਦਿਖਾਈ ਛੱਤ ਦਰਜ।",
    forWhom: "ਢੱਕਣ ਜਾਂ ਗਟਰ 'ਤੇ ਮੌਸ, lichen ਜਾਂ ਮਲਬਾ, ਖਾਸ ਕਰਕੇ ਰੁੱਖ ਹੇਠ, ਵਾਲੇ ਘਰ ਦੇ ਮਾਲਕ।",
    warningSigns: [
      "ਸ਼ਿੰਗਲਜ਼ 'ਤੇ ਮੌਸ ਪਾਣੀ ਰੋਕਦੀ",
      "ਆਮ ਬਾਰਿਸ਼ 'ਤੇ ਗਟਰ ਓਵਰਫਲੋ",
      "ਉੱਤਰੀ ਢਲਾਨ 'ਤੇ organic growth",
      "ਗਟਰ ਵਿੱਚ ਮਲਬਾ",
      "ਡਾਊਨਸਪਾਊਟ ਡrerਨ ਨਹੀਂ",
    ],
    evaluates: [
      "moss/organic extent",
      "cover below growth",
      "gutter/downspout drainage",
      "edge debris",
      "existing damage needing repair",
    ],
    causes: [
      "shady damp coastal",
      "tree debris",
      "gutter neglect",
      "surface texture holds organics",
      "cool months insufficient drying",
    ],
    methodology: [
      "protect landscape/access",
      "remove moss/debris roof-appropriate method",
      "clean gutters flush downspouts",
      "visual condition review",
      "document repair priorities found during clean",
    ],
    materials: [
      "gentle cleaning tools for roof type",
      "approved care products when used",
      "gutter clean/flush equipment",
    ],
    bcClimate:
      "Lower Mainland shade/rain ideal moss - growth traps water on cover, accelerates granule loss if ignored।",
    whenAppropriate: "cover largely intact + growth/debris/drainage main issues।",
    whenOtherService: "missing shingles, active leak, flashing fail → repair not clean-only।",
    process: [
      "roof type, shade exposure, access",
      "site review growth/drainage/cover",
      "written scope clean/care/gutter",
      "careful remove/treat/flush",
      "photo document repair items",
    ],
    solutionCategories: [
      { title: "moss/organic removal", body: "reduce growth trapping water where appropriate।" },
      { title: "gutter/downspout clean", body: "restore eave drainage to discharge。" },
      { title: "visual roof review", body: "document cover damage revealed after debris gone।" },
    ],
    repairVsReplace: {
      repair: "roof still serviceable - clean fits growth/debris focus।",
      replace: "clean reveals widespread brittle - honest replace planning may beat repeat clean।",
    },
    scopeFactors: [
      "roof area",
      "slope/access",
      "tree cover density",
      "gutter length",
      "cover fragility",
      "debris haul-off",
    ],
    publicPriceHint:
      "area, slope, growth extent, gutter length, access - assessment for project quote।",
    faqs: [
      {
        question: "ਮੌਸ + ਛੱਤ/ਗਟਰ ਪੈਕੇਜ?",
        answer: "organic growth, clean gutters/downspouts, document visible roof for planning।",
      },
      {
        question: "pressure wash moss?",
        answer:
          "pressure wash usually not for asphalt - strips granules, may drive water under cover; moss better gentle mechanical + approved care products for roof material।",
      },
      {
        question: "moss really damage roof?",
        answer:
          "established moss traps water, lifts shingle edges, accelerates granule loss; on cedar keeps wood wet faster decay - early removal cheaper than fixing wear caused।",
      },
      {
        question: "how often moss Metro Vancouver?",
        answer:
          "depends shade/trees/aspect - north/heavy shade regrow fastest; many homes annual look when starting to mat not fixed calendar।",
      },
      {
        question: "moss removal stop gutter overflow?",
        answer:
          "often related - moss debris/roof debris common gutter/downspout clogs; package cleans both to judge drainage separately; still overflow after clean → metal/slope issue।",
      },
    ],
  },
  "roof-health-check-maintenance": {
    title: "ਛੱਤ ਸਿਹਤ ਜਾਂਚ + ਰੱਖ-ਰਖਾਅ",
    shortTitle: "ਸਿਹਤ ਜਾਂਚ",
    eyebrow: "ਪਹਿਲਾਂ ਸਥਿਤੀ",
    description: "ਨਿਰੀਖਣ, ਫੋਟੋ, ਛੋਟਾ ਸੀਲੈਂਟ ਜਾਂ ਰੱਖ-ਰਖਾਅ ਕੰਮ ਅਤੇ ਸੂਚਿਤ ਯੋਜਨਾ ਲਈ ਛੱਤ ਸਥਿਤੀ ਰਿਪੋਰਟ।",
    definition:
      "ਛੱਤ ਸਿਹਤ ਜਾਂਚ ਢੱਕਣ, ਫਲੈਸ਼ਿੰਗ, ਡਰੇਨੇਜ ਅਤੇ ਪਹੁੰਚਯੋਗ ਸੰਬੰਧਿਤ ਕੰਪੋਨੈਂਟਾਂ ਦਾ ਸੰਰਚਿਤ ਦ੍ਰਿਸ਼ਟੀਗਤ ਮੁਲਾਂਕਣ ਹੈ, ਆਮ ਤੌਰ 'ਤੇ ਫੋਟੋ ਦਸਤਾਵੇਜ਼ੀਕਰਨ ਅਤੇ ਪਹਿਲਾਂ ਸਹਿਮਤ ਸੀਮਤ ਰੱਖ-ਰਖਾਅ ਨਾਲ।",
    forWhom:
      "ਖਰੀਦ/ਵਿਕਰੀ, ਨਵੀਨੀਕਰਨ, ਛੇਤੀ ਚੇਤਾਵਨੀ ਦੇ ਨਿਸ਼ਾਨ, ਜਾਂ ਮੀਂਹ ਦੇ ਮੌਸਮ ਤੋਂ ਪਹਿਲਾਂ ਦਸਤਾਵੇਜ਼ੀ baseline ਚਾਹੁਣ ਵਾਲੇ ਮਾਲਕ।",
    warningSigns: [
      "ਛੱਤ ਦੀ ਉਮਰ ਜਾਂ ਬਾਕੀ ਸਥਿਤੀ ਬਾਰੇ ਅਨਿਸ਼ਚਿਤਤਾ",
      "ਸਪਸ਼ਟ ਸਰੋਤ ਬਿਨਾਂ ਛੋਟੇ ਧੱਬੇ",
      "ਮੌਸਮੀ ਮਲਬਾ ਅਤੇ ਕਾਈ ਜਮ੍ਹਾ",
      "ਪ੍ਰਵੇਸ਼ਾਂ 'ਤੇ ਬੁਢਾਪੇ ਵਾਲਾ ਸੀਲੈਂਟ",
      "ਲਿਖਤ ਯੋਜਨਾ baseline ਦੀ ਲੋੜ",
    ],
    evaluates: [
      "ਸਤ੍ਹਾ ਅਨੁਸਾਰ ਢੱਕਣ ਦੀ ਸਥਿਤੀ",
      "ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਪ੍ਰਵੇਸ਼",
      "ਡਰੇਨੇਜ ਅਤੇ ਗਟਰ ਇੰਟਰਫੇਸ",
      "ਦਿਖਾਈ ਦੇਣ ਵਾਲੇ ਹਵਾਦਾਰੀ ਕੰਪੋਨੈਂਟ",
      "ਰੱਖ-ਰਖਾਅ ਬਨਾਮ ਮੁਰੰਮਤ ਤਰਜੀਹ",
    ],
    causes: [
      "ਦਸਤਾਵੇਜ਼ੀਕਰਨ ਬਿਨਾਂ ਸਧਾਰਨ ਬੁਢਾਪਾ",
      "ਮੁਲਤਵੀ ਰੱਖ-ਰਖਾਅ",
      "ਸਾਈਟ-ਵਿਸ਼ੇਸ਼ ਮੌਸਮੀ ਐਕਸਪੋਜ਼ਰ",
      "ਅਗਿਆਤ ਗੁਣਵੱਤਾ ਵਾਲਾ ਪਿਛਲਾ ਕੰਮ",
      "ਖਰੀਦਦਾਰ ਜਾਂ ਨਵੀਨੀਕਰਨ ਫੈਸਲੇ ਦੀ ਲੋੜ",
    ],
    methodology: [
      "ਚਿੰਤਾਵਾਂ ਅਤੇ ਉਪਲਬਧ ਇਤਿਹਾਸ ਦੀ ਸਮੀਖਿਆ",
      "ਬਾਹਰੀ ਛੱਤ ਜ਼ੋਨਾਂ ਦਾ ਸਿਸਟਮੈਟਿਕ ਨਿਰੀਖਣ",
      "ਨਮੂਨਾਤਮਕ ਸਥਿਤੀਆਂ ਦੀਆਂ ਫੋਟੋ",
      "ਸਿਰਫ ਸਹਿਮਤ ਛੋਟੀ ਰੱਖ-ਰਖਾਅ ਪੂਰੀ ਕਰੋ",
      "ਸਪਸ਼ਟ ਸਥਿਤੀ ਸਾਰ ਅਤੇ ਵਿਕਲਪ ਭੇਜੋ",
    ],
    materials: [
      "ਫੋਟੋ ਦਸਤਾਵੇਜ਼ੀਕਰਨ",
      "ਸ਼ਾਮਲ ਹੋਣ 'ਤੇ ਛੋਟਾ ਸੀਲੈਂਟ ਜਾਂ ਫਾਸਟਨਰ",
      "ਸਕੋਪ ਵਿੱਚ ਸੀਮਤ ਮਲਬਾ ਸਫਾਈ",
      "ਲਿਖਤ ਸਥਿਤੀ ਨੋਟ",
    ],
    bcClimate:
      "ਮੌਸਮੀ ਮੀਂਹ ਸਰਦੀਆਂ ਤੋਂ ਪਹਿਲਾਂ ਅਤੇ ਤੂਫਾਨਾਂ ਤੋਂ ਬਾਅਦ ਸਿਹਤ ਜਾਂਚਾਂ ਨੂੰ ਲਾਭਦਾਇਕ ਬਣਾਉਂਦਾ ਹੈ - ਰੁਕੀ ਡrerਨੇਜ, ਉੱਠੀ ਸਮੱਗਰੀ ਅਤੇ ਛੇਤੀ ਫਲੈਸ਼ਿੰਗ ਅਸਫਲਤਾ।",
    whenAppropriate: "ਜਦੋਂ ਮੁਰੰਮਤ, ਬਦਲਣ ਜਾਂ ਹੋਰ ਜਾਂਚ ਤੋਂ ਪਹਿਲਾਂ ਸਪਸ਼ਟਤਾ ਚਾਹੀਦੀ ਹੈ।",
    whenOtherService:
      "ਸਰਗਰਮ ਵੱਡੇ ਲੀਕ ਜਾਂ ਤੂਫਾਨ ਖੁੱਲ੍ਹਣ ਐਮਰਜੈਂਸੀ ਜਾਂ ਮੁਰੰਮਤ ਮਾਰਗਾਂ ਵੱਲ ਜਾਣੇ ਚਾਹੀਦੇ ਹਨ।",
    process: [
      "ਸਿਹਤ ਜਾਂਚ ਬੁੱਕ ਕਰੋ ਅਤੇ ਚਿੰਤਾਵਾਂ ਦੱਸੋ",
      "ਫੋਟੋ ਦਸਤਾਵੇਜ਼ੀਕਰਨ ਨਾਲ ਸਿਸਟਮੈਟਿਕ ਬਾਹਰੀ ਨਿਰੀਖਣ",
      "ਵਿਜ਼ਿਟ ਦੌਰਾਨ ਸਹਿਮਤ ਛੋਟੀ ਰੱਖ-ਰਖਾਅ",
      "ਤਰਜੀਹਾਂ ਨਾਲ ਲਿਖਤ ਸਥਿਤੀ ਸਾਰ",
      "ਸਿਫ਼ਾਰਸ਼ੀ ਮੁਰੰਮਤਾਂ 'ਤੇ ਫਾਲੋ-ਅੱਪ",
    ],
    solutionCategories: [
      {
        title: "ਦਸਤਾਵੇਜ਼ੀ ਨਿਰੀਖਣ",
        body: "ਛੱਤ ਅਸੈਂਬਲੀ 'ਤੇ ਦਿਖਾਈ ਅਤੇ ਪਹੁੰਚਯੋਗ ਕੀ ਹੈ ਉਸਦੀ ਸੰਰਚਿਤ ਸਮੀਖਿਆ।",
      },
      {
        title: "ਛੋਟੀ ਰੱਖ-ਰਖਾਅ",
        body: "ਸਿਰਫ ਜਦੋਂ ਸ਼ਾਮਲ ਅਤੇ ਢੁਕਵਾਂ ਹੋਵੇ - ਸੀਮਤ ਸੀਲੈਂਟ ਜਾਂ ਮਲਬਾ ਕੰਮ।",
      },
      {
        title: "ਯੋਜਨਾ ਸਾਰ",
        body: "ਤੁਰੰਤ ਚਿੰਤਾਵਾਂ ਨੂੰ ਮੱਧਮ-ਮਿਆਦੀ ਨਿਗਰਾਨੀ ਤੋਂ ਅਲੱਗ ਕਰੋ।",
      },
    ],
    repairVsReplace: {
      repair: "ਕਈ ਨਤੀਜੇ ਰੱਖ-ਰਖਾਅ ਜਾਂ ਸਥਾਨਕ ਮੁਰੰਮਤ ਹਨ, ਪੂਰੀ ਬਦਲੀ ਟrigger ਨਹੀਂ।",
      replace: "ਬਦਲੀ ਸਿਰਫ ਤਾਂ ਚਰਚਾ ਹੁੰਦੀ ਹੈ ਜਦੋਂ ਦੇਖੀ ਸਥਿਤੀ ਵਿਆਪਕ ਮਾਰਗ ਦਾ ਸਮਰਥਨ ਕਰੇ।",
    },
    scopeFactors: [
      "ਛੱਤ ਦਾ ਆਕਾਰ ਅਤੇ ਜਟਿਲਤਾ",
      "ਪਹੁੰਚ",
      "ਫੋਟੋ ਦਸਤਾਵੇਜ਼ੀ ਡੂੰਘਾਈ",
      "ਸ਼ਾਮਲ ਰੱਖ-ਰਖਾਅ ਆਈਟਮ",
      "ਜਾਇਦਾਦ 'ਤੇ ਛੱਤ ਪ੍ਰਣਾਲੀਆਂ ਦੀ ਗਿਣਤੀ",
    ],
    publicPriceHint:
      "ਸਿਹਤ ਜਾਂਚ ਸਕੋਪ ਛੱਤ ਦੇ ਆਕਾਰ, ਜਟਿਲਤਾ, ਪਹੁੰਚ ਅਤੇ ਕਿੰਨਾ ਦਸਤਾਵੇਜ਼ੀਕਰਨ/ਛੋਟੀ ਰੱਖ-ਰਖਾਅ ਸ਼ਾਮਲ ਹੈ ਉੱਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ। ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ।",
    faqs: [
      {
        question: "ਛੱਤ ਸਿਹਤ ਜਾਂਚ + ਰੱਖ-ਰਖਾਅ ਕੀ ਹੈ?",
        answer:
          "ਛੱਤ ਸਿਹਤ ਜਾਂਚ ਢੱਕਣ, ਫਲੈਸ਼ਿੰਗ, ਡਰੇਨੇਜ ਅਤੇ ਪਹੁੰਚਯੋਗ ਸੰਬੰਧਿਤ ਕੰਪੋਨੈਂਟਾਂ ਦਾ ਸੰਰਚਿਤ ਦ੍ਰਿਸ਼ਟੀਗਤ ਮੁਲਾਂਕਣ ਹੈ, ਆਮ ਤੌਰ 'ਤੇ ਫੋਟੋ ਦਸਤਾਵੇਜ਼ੀਕਰਨ ਅਤੇ ਪਹਿਲਾਂ ਸਹਿਮਤ ਸੀਮਤ ਰੱਖ-ਰਖਾਅ ਨਾਲ।",
      },
      {
        question: "ਛੱਤ ਦੀ ਕਿੰਨੀ ਵਾਰ ਜਾਂਚ ਕਰਵਾਉਣੀ ਚਾਹੀਦੀ ਹੈ?",
        answer:
          "ਇੱਕ ਉਪਯੋਗੀ ਖੇਤਰੀ ਲੈ ਪਤਝੜ ਦੇ ਮੀਂਹ ਤੋਂ ਪਹਿਲਾਂ ਜਾਂਚ, ਅਤੇ ਕਿਸੇ ਵੱਡੇ ਤੂਫਾਨ ਤੋਂ ਬਾਅਦ। ਭਾਰੀ ਰੁੱਖਾਂ ਹੇਠਲੇ ਘਰ ਜਾਂ ਉਮਰ ਦੇ ਦੂਜੇ ਅੱਧ ਵਿੱਚ ਛੱਤਾਂ ਨੂੰ ਵਧੇਰੇ ਨਿਯਮਿਤ ਧਿਆਨ ਫਾਇਦਾ ਦਿੰਦਾ ਹੈ।",
      },
      {
        question: "ਸਿਹਤ ਜਾਂਚ ਤੋਂ ਬਾਅਦ ਮੈਨੂੰ ਕੀ ਮਿਲਦਾ ਹੈ?",
        answer:
          "ਢੱਕਣ, ਫਲੈਸ਼ਿੰਗ, ਡਰੇਨੇਜ ਅਤੇ ਹਵਾਦਾਰੀ ਦੀ ਫੋਟੋ-ਦਸਤਾਵੇਜ਼ੀ ਸਾਰ, ਤੁਰੰਤ ਮੁਰੰਮਤ, ਨਿਗਰਾਨੀ ਅਤੇ ਸਧਾਰਨ ਘਿਸਾਈ ਵਿੱਚ ਵੰਡੀ - ਇੱਕ ਯੋਜਨਾ ਦਸਤਾਵੇਜ਼।",
      },
      {
        question: "ਕੀ ਘਰ ਖਰੀਦ/ਵਿਕਰੀ ਤੋਂ ਪਹਿਲਾਂ ਛੱਤ ਜਾਂਚ ਕਰਵਾਉਣਾ ਫਾਇਦੇਮੰਦ ਹੈ?",
        answer:
          "ਹਾਂ - ਛੱਤ ਨਵੀਨੀਕਰਨ ਦੇ ਸਭ ਤੋਂ ਮਹਿੰਗੇ ਹਿੱਸਿਆਂ ਵਿੱਚੋਂ ਇੱਕ ਹੈ। ਇਹ ਰੂਫਿੰਗ ਸਥਿਤੀ ਸਮੀਖਿਆ ਹੈ, ਰਸਮੀ ਘਰ ਖਰੀਦ/ਵਿਕਰੀ ਤੋਂ ਪਹਿਲਾਂ ਰਸਮੀ ਨਿਰੀਖਣ ਨਹੀਂ।",
      },
      {
        question: "ਕੀ ਤੁਸੀਂ ਨਿਰੀਖਣ ਦੌਰਾਨ ਮਿਲੀਆਂ ਸਮੱਸਿਆਵਾਂ ਠੀਕ ਕਰਦੇ ਹੋ?",
        answer:
          "ਛੋਟੀਆਂ ਸਹਿਮਤ ਰੱਖ-ਰਖਾਅ - ਜਿਵੇਂ ਪ੍ਰਵੇਸ਼ਾਂ 'ਤੇ ਛੋਟਾ ਸੀਲੈਂਟ - ਉਸੇ ਵਿਜ਼ਿਟ ਵਿੱਚ ਹੋ ਸਕਦੀ ਹੈ। ਵੱਡੇ ਨਤੀਜੇ ਦਸਤਾਵੇਜ਼ ਅਤੇ ਅਲੱਗ ਸਕੋਪ ਹੁੰਦੇ ਹਨ।",
      },
    ],
  },
} as const satisfies Record<ServiceSlug, ServiceContentTranslation>;

export const serviceAreas = {
  vancouver: {
    intro:
      "ਵੈਨਕੂਵਰ ਦੇ ਘਰਾਂ ਵਿੱਚ ਸੰਖੇਪ ਵੱਖਰੇ ਘਰਾਂ ਤੋਂ ਲੈ ਕੇ ਆਰਕੀਟੈਕਟ-ਡਿਜ਼ਾਈਨ ਕੀਤੇ ਨਿਵਾਸ ਸਥਾਨਾਂ ਤੱਕ ਐਡੀਸ਼ਨ, ਡੇਕ ਅਤੇ ਘੱਟ ਢਲਾਨ ਵਾਲੇ ਭਾਗ ਹੁੰਦੇ ਹਨ। ਇੱਕ ਉਪਯੋਗੀ ਛੱਤ ਦਾ ਮੁਲਾਂਕਣ ਇੱਕ-ਸਿਸਟਮ-ਫਿੱਟ-ਸਾਰੇ ਸਿਫ਼ਾਰਸ਼ਾਂ ਦੀ ਬਜਾਏ ਇਮਾਰਤ ਦੀ ਅਸਲ ਜਿਓਮੈਟਰੀ ਨਾਲ ਸ਼ੁਰੂ ਹੁੰਦਾ ਹੈ।",
    localContext:
      "ਸਿਟੀ ਆਫ ਵੈਨਕੂਵਰ ਦੇ ਅੰਦਰਲੇ ਪ੍ਰੋਜੈਕਟ ਉਹਨਾਂ ਲੋੜਾਂ ਦੇ ਅਧੀਨ ਹੋ ਸਕਦੇ ਹਨ ਜੋ ਬ੍ਰਿਟਿਸ਼ ਕੋਲੰਬੀਆ ਵਿੱਚ ਹੋਰ ਕਿਤੇ ਵਰਤੀਆਂ ਜਾਣ ਵਾਲੀਆਂ ਲੋੜਾਂ ਨਾਲੋਂ ਵੱਖਰੀਆਂ ਹਨ। ਰੇਵੋਲਿਨ ਕਿਸੇ ਦਾਇਰੇ ਨੂੰ ਅੰਤਿਮ ਰੂਪ ਦੇਣ ਤੋਂ ਪਹਿਲਾਂ ਜਾਇਦਾਦ ਦੇ ਅਧਿਕਾਰ ਖੇਤਰ ਅਤੇ ਸੰਬੰਧਿਤ ਪ੍ਰੋਜੈਕਟ ਲੋੜਾਂ ਦੀ ਪੁਸ਼ਟੀ ਕਰਦਾ ਹੈ।",
    assessmentFocus: [
      "ਮੂਲ ਛੱਤਾਂ, ਜੋੜਾਂ ਅਤੇ ਘੱਟ-ਢਲਾਨ ਵਾਲੇ ਭਾਗਾਂ ਵਿਚਕਾਰ ਪਰਿਵਰਤਨ",
      "ਘਾਟੀਆਂ, ਕੰਧ ਦੇ ਚੌਰਾਹੇ, ਘੁਸਪੈਠ ਅਤੇ ਘੇਰੇ ਦੀ ਫਲੈਸ਼ਿੰਗ",
      "ਡਰੇਨੇਜ ਪਾਥ ਜੋ ਸੰਖੇਪ ਸ਼ਹਿਰੀ ਸਥਾਨਾਂ ਦੇ ਅੰਦਰ ਕੰਮ ਕਰਨੇ ਚਾਹੀਦੇ ਹਨ",
    ],
    propertyContexts: ["ਅਲੱਗ ਘਰ", "ਮੁਰੰਮਤ ਕੀਤੇ ਅਤੇ ਵਿਸਤ੍ਰਿਤ ਘਰਾਂ", "ਮਿਸ਼ਰਤ-ਢਲਾਨ ਛੱਤ ਅਸੈਂਬਲੀਆਂ"],
    faqs: [
      {
        question: "ਕੀ ਵੈਨਕੂਵਰ ਰੂਫਿੰਗ ਪ੍ਰੋਜੈਕਟ ਬਾਕੀ BC ਵਾਂਗ ਹੀ ਨਿਯਮਾਂ ਦੀ ਪਾਲਣਾ ਕਰਦੇ ਹਨ?",
        answer:
          "ਹਮੇਸ਼ਾ ਨਹੀਂ। ਵੈਨਕੂਵਰ ਸਿਟੀ ਦਾ ਆਪਣਾ ਬਿਲਡਿੰਗ ਉਪ-ਨਿਯਮ ਫਰੇਮਵਰਕ ਹੈ। ਲਾਗੂ ਹੋਣ ਵਾਲੀਆਂ ਲੋੜਾਂ ਪਤੇ ਅਤੇ ਦਾਇਰੇ 'ਤੇ ਨਿਰਭਰ ਕਰਦੀਆਂ ਹਨ, ਇਸਲਈ ਉਹਨਾਂ ਨੂੰ ਖੇਤਰੀ ਚੈਕਲਿਸਟ ਤੋਂ ਮੰਨਣ ਦੀ ਬਜਾਏ ਯੋਜਨਾਬੰਦੀ ਦੌਰਾਨ ਪੁਸ਼ਟੀ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
      },
      {
        question: "ਕੀ ਇੱਕ ਘਰ ਨੂੰ ਇੱਕ ਤੋਂ ਵੱਧ ਛੱਤਾਂ ਦੀ ਪਹੁੰਚ ਦੀ ਲੋੜ ਹੈ?",
        answer:
          "ਹਾਂ। ਜੋੜਾਂ, ਪੋਰਚਾਂ ਅਤੇ ਛੱਤਾਂ ਦੇ ਡੇਕ ਢਲਾਣਾਂ ਅਤੇ ਤਬਦੀਲੀਆਂ ਨੂੰ ਪੇਸ਼ ਕਰ ਸਕਦੇ ਹਨ ਜੋ ਮੁੱਖ ਛੱਤ ਤੋਂ ਵੱਖਰੇ ਹਨ। ਮੁਲਾਂਕਣ ਨੂੰ ਉਹਨਾਂ ਕੁਨੈਕਸ਼ਨਾਂ ਨੂੰ ਇੱਕ ਪਾਣੀ-ਪ੍ਰਬੰਧਨ ਪ੍ਰਣਾਲੀ ਵਜੋਂ ਮੰਨਿਆ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।",
      },
    ],
  },
  burnaby: {
    intro:
      "ਬਰਨਬੀ ਦੇ ਰਿਹਾਇਸ਼ੀ ਆਂਢ-ਗੁਆਂਢ ਵਿੱਚ ਲੈਵਲ ਸਾਈਟਾਂ, ਪਹਾੜੀ ਗਲੀਆਂ ਅਤੇ ਘਰ ਸ਼ਾਮਲ ਹਨ ਜੋ ਜੋੜਾਂ ਦੁਆਰਾ ਵਿਕਸਤ ਹੋਏ ਹਨ। ਇਹ ਵੰਨ-ਸੁਵੰਨਤਾ ਡਰੇਨੇਜ, ਸੁਰੱਖਿਅਤ ਪਹੁੰਚ ਅਤੇ ਛੱਤ ਦੇ ਭਾਗਾਂ ਵਿਚਕਾਰ ਕੁਨੈਕਸ਼ਨਾਂ ਨੂੰ ਪਹਿਲੇ ਮੁਲਾਂਕਣ ਦੇ ਮਹੱਤਵਪੂਰਨ ਅੰਗ ਬਣਾਉਂਦੀ ਹੈ।",
    localContext:
      "ਬਰਨਬੀ ਦੀ ਛੱਤ ਸਿਰਫ਼ ਕੁਝ ਆਂਢ-ਗੁਆਂਢ ਦੀ ਦੂਰੀ 'ਤੇ ਕਿਸੇ ਹੋਰ ਛੱਤ ਤੋਂ ਵੱਖਰੇ ਢੰਗ ਨਾਲ ਪ੍ਰਦਰਸ਼ਨ ਕਰ ਸਕਦੀ ਹੈ ਕਿਉਂਕਿ ਐਕਸਪੋਜ਼ਰ, ਰੁੱਖਾਂ ਦਾ ਢੱਕਣ, ਢਲਾਣ ਅਤੇ ਇਮਾਰਤ ਦਾ ਰੂਪ ਸਾਈਟ ਅਨੁਸਾਰ ਵੱਖ-ਵੱਖ ਹੁੰਦਾ ਹੈ। ਸਿਫ਼ਾਰਿਸ਼ਾਂ ਜਾਇਦਾਦ 'ਤੇ ਦੇਖੀਆਂ ਗਈਆਂ ਹਾਲਤਾਂ 'ਤੇ ਆਧਾਰਿਤ ਹਨ।",
    assessmentFocus: [
      "ਘਰ ਦੇ ਆਲੇ-ਦੁਆਲੇ ਢਲਾਨ, ਪਹੁੰਚ ਅਤੇ ਸਮੱਗਰੀ ਨੂੰ ਸੰਭਾਲਣ ਦੀਆਂ ਰੁਕਾਵਟਾਂ",
      "ਵਾਦੀਆਂ, ਨਦੀਆਂ, ਗਟਰਾਂ ਅਤੇ ਛੱਤ ਦੇ ਹੇਠਲੇ ਹਿੱਸਿਆਂ 'ਤੇ ਡਰੇਨੇਜ",
      "ਕਨੈਕਸ਼ਨ ਜਿੱਥੇ ਜੋੜ ਅਸਲ ਇਮਾਰਤ ਨਾਲ ਮਿਲਦੇ ਹਨ",
    ],
    propertyContexts: ["ਪਹਾੜੀ ਸੰਪਤੀਆਂ", "ਜੋੜਾਂ ਵਾਲੇ ਘਰ", "ਪਰਿਪੱਕ ਰਿਹਾਇਸ਼ੀ ਲਾਟ"],
    faqs: [
      {
        question: "ਸਾਈਟ ਦੀ ਪਹੁੰਚ ਛੱਤ ਦੇ ਦਾਇਰੇ ਲਈ ਮਾਇਨੇ ਕਿਉਂ ਰੱਖਦੀ ਹੈ?",
        answer:
          "ਪਹੁੰਚ ਸੁਰੱਖਿਆ, ਸਮੱਗਰੀ ਦੀ ਗਤੀ ਅਤੇ ਕੰਮ ਨੂੰ ਕਿਵੇਂ ਕ੍ਰਮਬੱਧ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਕਰਦਾ ਹੈ। ਇੰਸਟਾਲੇਸ਼ਨ ਯੋਜਨਾ ਅਤੇ ਦਾਇਰੇ ਨੂੰ ਅੰਤਿਮ ਰੂਪ ਦੇਣ ਤੋਂ ਪਹਿਲਾਂ ਇਸਦੀ ਸਮੀਖਿਆ ਕੀਤੀ ਜਾਣੀ ਚਾਹੀਦੀ ਹੈ।",
      },
      {
        question: "ਕੀ ਛੱਤ ਦੇ ਨਾਲ ਗਟਰਾਂ ਦੀ ਸਮੀਖਿਆ ਕੀਤੀ ਜਾਣੀ ਚਾਹੀਦੀ ਹੈ?",
        answer:
          "ਡਰੇਨੇਜ ਨੂੰ ਛੱਤ ਦੀ ਸਤ੍ਹਾ ਤੋਂ ਇੱਕ ਢੁਕਵੇਂ ਡਿਸਚਾਰਜ ਪੁਆਇੰਟ ਤੱਕ ਇੱਕ ਜੁੜੇ ਮਾਰਗ ਵਜੋਂ ਮੰਨਿਆ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ। ਮੁਲਾਂਕਣ ਦਸਤਾਵੇਜ਼ਾਂ ਵਿੱਚ ਵਿਕਲਪਿਕ ਡਰੇਨੇਜ ਦੇ ਕੰਮ ਨੂੰ ਮੰਨੇ ਬਿਨਾਂ ਗਟਰ ਅਤੇ ਡਾਊਨਸਪਾਉਟ ਦੀਆਂ ਸਥਿਤੀਆਂ ਨੂੰ ਸ਼ਾਮਲ ਕੀਤਾ ਗਿਆ ਹੈ।",
      },
    ],
  },
  coquitlam: {
    intro:
      "ਕੋਕੁਇਟਲਮ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਢਲਾਣ ਵਾਲੀਆਂ ਸਾਈਟਾਂ, ਮਲਟੀ-ਪਲੇਨ ਘਰਾਂ ਅਤੇ ਨੇੜਲੇ ਬਨਸਪਤੀ ਨੂੰ ਜੋੜ ਸਕਦੀਆਂ ਹਨ। ਮੁਰੰਮਤ ਜਾਂ ਬਦਲਣ ਦੀ ਸਿਫ਼ਾਰਸ਼ ਕੀਤੇ ਜਾਣ ਤੋਂ ਪਹਿਲਾਂ ਛੱਤ ਦੀ ਸਥਿਤੀ, ਮਲਬੇ ਦੇ ਰਸਤੇ, ਡਰੇਨੇਜ ਅਤੇ ਹਵਾ ਨਾਲ ਚੱਲਣ ਵਾਲੇ ਮੀਂਹ ਦੇ ਐਕਸਪੋਜਰ ਦੀ ਸਮੀਖਿਆ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
    localContext:
      "ਆਂਢ-ਗੁਆਂਢ ਦੀ ਉਚਾਈ ਅਤੇ ਐਕਸਪੋਜ਼ਰ ਕੋਕੁਇਟਲਮ ਵਿੱਚ ਬਦਲ ਸਕਦੇ ਹਨ। ਇਸ ਲਈ ਢੁਕਵੀਂ ਛੱਤ ਪ੍ਰਣਾਲੀ ਅਤੇ ਵੇਰਵਾ ਵਿਅਕਤੀਗਤ ਇਮਾਰਤ 'ਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ, ਨਾ ਕਿ ਸ਼ਹਿਰ-ਵਿਆਪੀ ਸਮੱਗਰੀ ਦੇ ਨੁਸਖੇ 'ਤੇ।",
    assessmentFocus: [
      "ਬਹੁ-ਪੱਧਰੀ ਘਰਾਂ 'ਤੇ ਉੱਪਰ ਤੋਂ ਹੇਠਲੀ ਛੱਤ ਦੀ ਨਿਕਾਸੀ",
      "ਗੁੰਝਲਦਾਰ ਛੱਤ ਦੇ ਰੂਪਾਂ 'ਤੇ ਘਾਟੀਆਂ ਅਤੇ ਛੱਤ-ਤੋਂ-ਕੰਧ ਪਰਿਵਰਤਨ",
      "ਗਟਰਾਂ, ਪ੍ਰਵੇਸ਼ ਅਤੇ ਨਿਕਾਸੀ ਪੁਆਇੰਟਾਂ ਦੇ ਆਲੇ ਦੁਆਲੇ ਮਲਬਾ ਇਕੱਠਾ ਹੁੰਦਾ ਹੈ",
    ],
    propertyContexts: ["ਬਹੁ-ਪੱਧਰੀ ਘਰ", "ਢਲਾਣ ਵਾਲੀਆਂ ਰਿਹਾਇਸ਼ੀ ਸਾਈਟਾਂ", "ਪਰਿਪੱਕ ਬਨਸਪਤੀ ਦੇ ਨੇੜੇ ਘਰ"],
    faqs: [
      {
        question: "ਕੀ ਇੱਕ ਗੁੰਝਲਦਾਰ ਛੱਤ ਨੂੰ ਆਪਣੇ ਆਪ ਬਦਲਣ ਦੀ ਲੋੜ ਹੈ?",
        answer:
          "ਨਹੀਂ। ਜਟਿਲਤਾ ਨਿਦਾਨ ਅਤੇ ਵੇਰਵੇ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਕਰਦੀ ਹੈ, ਪਰ ਮੁਰੰਮਤ ਬਨਾਮ ਬਦਲਣਾ ਅਜੇ ਵੀ ਇਸ ਗੱਲ 'ਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ ਕਿ ਕੀ ਦੇਖਿਆ ਗਿਆ ਸਮੱਸਿਆ ਅਲੱਗ ਹੈ ਜਾਂ ਸਿਸਟਮ-ਵਿਆਪਕ ਹੈ।",
      },
      {
        question: "ਇੱਕ ਨਿਰੀਖਣ ਦੌਰਾਨ ਰੁੱਖ ਦੇ ਮਲਬੇ ਨੂੰ ਕਿਵੇਂ ਮੰਨਿਆ ਜਾਂਦਾ ਹੈ?",
        answer:
          "ਮੁਲਾਂਕਣ ਉਹਨਾਂ ਖੇਤਰਾਂ ਦਾ ਦਸਤਾਵੇਜ਼ ਬਣਾ ਸਕਦਾ ਹੈ ਜਿੱਥੇ ਮਲਬਾ ਇਕੱਠਾ ਹੁੰਦਾ ਹੈ ਜਾਂ ਡਰੇਨੇਜ ਨੂੰ ਹੌਲੀ ਕਰਦਾ ਹੈ। ਰੱਖ-ਰਖਾਅ ਦੀਆਂ ਸਿਫ਼ਾਰਿਸ਼ਾਂ ਫਿਰ ਜਾਇਦਾਦ 'ਤੇ ਦਿਖਾਈ ਦੇਣ ਵਾਲੀ ਚੀਜ਼ ਨਾਲ ਜੁੜੀਆਂ ਹੁੰਦੀਆਂ ਹਨ।",
      },
    ],
  },
  surrey: {
    intro:
      "ਸਰੀ ਵਿੱਚ ਸਥਾਪਤ ਆਂਢ-ਗੁਆਂਢ ਤੋਂ ਲੈ ਕੇ ਵੱਡੇ, ਸਪਸ਼ਟ ਛੱਤ ਦੇ ਰੂਪਾਂ ਵਾਲੇ ਨਵੇਂ ਘਰਾਂ ਤੱਕ, ਰਿਹਾਇਸ਼ੀ ਸੈਟਿੰਗਾਂ ਦੀ ਇੱਕ ਵਿਸ਼ਾਲ ਸ਼੍ਰੇਣੀ ਸ਼ਾਮਲ ਹੈ। ਛੱਤ ਦਾ ਖੇਤਰ, ਐਕਸਪੋਜ਼ਰ ਅਤੇ ਪਰਿਵਰਤਨ ਦੀ ਗਿਣਤੀ ਸਾਰੇ ਇੱਕ ਵਿਹਾਰਕ ਦਾਇਰੇ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਕਰਦੇ ਹਨ।",
    localContext:
      "ਕਿਉਂਕਿ ਸ਼ਹਿਰ ਭਰ ਵਿੱਚ ਹਾਲਾਤ ਵੱਖੋ-ਵੱਖਰੇ ਹੁੰਦੇ ਹਨ, ਇੱਕ ਸਰੀ ਜਾਇਦਾਦ ਦੀ ਸਿਫ਼ਾਰਸ਼ ਨੂੰ ਦੂਜੇ ਲਈ ਮਿਆਰੀ ਨਿਰਧਾਰਨ ਵਜੋਂ ਨਹੀਂ ਮੰਨਿਆ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ। ਰੇਵੋਲਿਨ ਸਾਡੇ ਸਾਹਮਣੇ ਛੱਤ ਦੇ ਦਸਤਾਵੇਜ਼ਾਂ ਨੂੰ ਦਰਸਾਉਂਦਾ ਹੈ ਅਤੇ ਵਪਾਰ-ਆਫਸ ਦੀ ਵਿਆਖਿਆ ਕਰਦਾ ਹੈ।",
    assessmentFocus: [
      "ਵੱਡੇ ਛੱਤ ਦੀਆਂ ਸਤ੍ਹਾਂ ਅਤੇ ਉਹਨਾਂ ਦੇ ਵਿਚਕਾਰ ਪਾਣੀ ਦਾ ਨਿਰਦੇਸ਼ਨ ਕਿਵੇਂ ਕੀਤਾ ਜਾਂਦਾ ਹੈ",
      "ਡੋਰਮਰਸ, ਕੰਧਾਂ, ਚਿਮਨੀ ਅਤੇ ਪ੍ਰਵੇਸ਼ 'ਤੇ ਫਲੈਸ਼ਿੰਗ",
      "ਕੀ ਨੁਕਸਾਨ ਨੂੰ ਵੱਖ ਕੀਤਾ ਗਿਆ ਹੈ ਜਾਂ ਛੱਤ ਪ੍ਰਣਾਲੀ ਵਿੱਚ ਦੁਹਰਾਇਆ ਗਿਆ ਹੈ",
    ],
    propertyContexts: ["ਵੱਡੇ ਵੱਖਰੇ ਘਰ", "ਨਵੀਆਂ ਮਲਟੀ-ਪਲੇਨ ਛੱਤਾਂ", "ਗੁਆਂਢੀ ਘਰਾਂ ਦੀ ਸਥਾਪਨਾ ਕੀਤੀ"],
    faqs: [
      {
        question: "ਇੱਕ ਵੱਡੀ ਛੱਤ 'ਤੇ ਮੁਰੰਮਤ ਬਨਾਮ ਬਦਲਣ ਦਾ ਕੀ ਨਿਰਧਾਰਨ ਕਰਦਾ ਹੈ?",
        answer:
          "ਇਕੱਲਾ ਆਕਾਰ ਇਸ ਦਾ ਫੈਸਲਾ ਨਹੀਂ ਕਰਦਾ. ਫੈਸਲਾ ਕਵਰ ਕਰਨ ਦੀ ਸਥਿਤੀ, ਸੰਖਿਆ ਅਤੇ ਅਸਫਲਤਾਵਾਂ ਦੀ ਸਥਿਤੀ, ਪਰਿਵਰਤਨ ਵੇਰਵਿਆਂ ਅਤੇ ਕੀ ਇੱਕ ਟਿਕਾਊ ਸਥਾਨਿਕ ਮੁਰੰਮਤ ਸੰਭਵ ਹੈ 'ਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ।",
      },
      {
        question: "ਕੀ ਇੱਕ ਮੁਲਾਂਕਣ ਇੱਕ ਸਮੱਸਿਆ ਖੇਤਰ ਤੱਕ ਸੀਮਿਤ ਹੋ ਸਕਦਾ ਹੈ?",
        answer:
          "ਰਿਪੋਰਟ ਕੀਤੀ ਗਈ ਸਮੱਸਿਆ ਦੀ ਨੇੜਿਓਂ ਜਾਂਚ ਕੀਤੀ ਜਾਂਦੀ ਹੈ, ਪਰ ਨਾਲ ਲੱਗਦੇ ਛੱਤ ਦੇ ਜਹਾਜ਼ਾਂ ਅਤੇ ਡਰੇਨੇਜ ਮਾਰਗਾਂ ਦੀ ਵੀ ਸਮੀਖਿਆ ਕੀਤੀ ਜਾਣੀ ਚਾਹੀਦੀ ਹੈ ਕਿਉਂਕਿ ਪਾਣੀ ਘਰ ਦੇ ਅੰਦਰ ਦਿਖਾਈ ਦੇਣ ਤੋਂ ਪਹਿਲਾਂ ਯਾਤਰਾ ਕਰ ਸਕਦਾ ਹੈ।",
      },
    ],
  },
  richmond: {
    intro:
      "ਰਿਚਮੰਡ ਦੀ ਆਮ ਤੌਰ 'ਤੇ ਨੀਵੀਂ ਸਥਿਤੀ, ਛੱਤ ਦੇ ਨਿਯੰਤਰਿਤ ਨਿਕਾਸ ਨੂੰ ਖਾਸ ਤੌਰ 'ਤੇ ਲੰਬੇ ਮੀਂਹ ਦੌਰਾਨ ਦਿਖਾਈ ਦਿੰਦੀ ਹੈ। ਘੱਟ ਢਲਾਨ ਵਾਲੇ ਭਾਗ, ਘੇਰੇ ਦੇ ਕਿਨਾਰੇ ਅਤੇ ਡਿਸਚਾਰਜ ਮਾਰਗ ਮੁੱਖ ਛੱਤ ਦੇ ਢੱਕਣ ਵਾਂਗ ਹੀ ਧਿਆਨ ਦੇ ਹੱਕਦਾਰ ਹਨ।",
    localContext:
      "ਤੱਟਵਰਤੀ ਐਕਸਪੋਜਰ ਅਤੇ ਸਾਈਟ ਦੀ ਖੁੱਲ੍ਹੀਤਾ ਪ੍ਰਭਾਵਿਤ ਕਰ ਸਕਦੀ ਹੈ ਕਿ ਹਵਾ ਨਾਲ ਚੱਲਣ ਵਾਲੀ ਬਾਰਿਸ਼ ਛੱਤ ਦੇ ਕਿਨਾਰਿਆਂ ਅਤੇ ਤਬਦੀਲੀਆਂ ਤੱਕ ਕਿਵੇਂ ਪਹੁੰਚਦੀ ਹੈ। ਸਮੱਗਰੀ ਅਤੇ ਵੇਰਵੇ ਦੀਆਂ ਸਿਫ਼ਾਰਿਸ਼ਾਂ ਘਰ ਦੀ ਢਲਾਣ, ਫਾਰਮ ਅਤੇ ਐਕਸਪੋਜਰ ਦੀ ਸਮੀਖਿਆ ਕਰਨ ਤੋਂ ਬਾਅਦ ਹੀ ਕੀਤੀਆਂ ਜਾਂਦੀਆਂ ਹਨ।",
    assessmentFocus: [
      "ਘੱਟ ਢਲਾਨ ਵਾਲੇ ਭਾਗਾਂ 'ਤੇ ਸਕਾਰਾਤਮਕ ਨਿਕਾਸੀ ਅਤੇ ਦਿਖਣ ਵਾਲੇ ਨੀਵੇਂ ਬਿੰਦੂ",
      "ਛੱਤ ਦੇ ਕਿਨਾਰੇ, ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਪਰਿਵਰਤਨ ਸੰਚਾਲਿਤ ਮੀਂਹ ਦੇ ਸੰਪਰਕ ਵਿੱਚ ਹਨ",
      "ਗਟਰ ਅਤੇ ਡਾਊਨ ਸਪਾਊਟਸ ਛੱਤ ਦੇ ਜਹਾਜ਼ਾਂ ਤੋਂ ਪਾਣੀ ਕਿਵੇਂ ਪ੍ਰਾਪਤ ਕਰਦੇ ਹਨ",
    ],
    propertyContexts: ["ਘੱਟ ਢਲਾਨ ਵਾਲੇ ਛੱਤ ਵਾਲੇ ਭਾਗ", "ਰਿਹਾਇਸ਼ੀ ਸਾਈਟਾਂ ਖੋਲ੍ਹੋ", "ਸਮਕਾਲੀ ਨਿਰਲੇਪ ਘਰ"],
    faqs: [
      {
        question: "ਕੀ ਇੱਕ ਫਲੈਟ-ਦਿੱਖ ਵਾਲੀ ਛੱਤ ਅਸਲ ਵਿੱਚ ਫਲੈਟ ਹੈ?",
        answer:
          "ਘੱਟ ਢਲਾਣ ਵਾਲੀ ਛੱਤ ਨੂੰ ਅਜੇ ਵੀ ਪਾਣੀ ਨੂੰ ਨਿਕਾਸੀ ਵੱਲ ਸੇਧਿਤ ਕਰਨਾ ਚਾਹੀਦਾ ਹੈ। ਮੁਲਾਂਕਣ ਡਿਜ਼ਾਈਨ ਕੀਤੇ ਗਏ ਨਿਕਾਸੀ ਮਾਰਗ ਅਤੇ ਦਿਖਾਈ ਦੇਣ ਵਾਲੇ ਸੰਕੇਤਾਂ ਦੀ ਖੋਜ ਕਰਦਾ ਹੈ ਕਿ ਪਾਣੀ ਇਰਾਦੇ ਅਨੁਸਾਰ ਨਹੀਂ ਵਧ ਰਿਹਾ ਹੈ।",
      },
      {
        question: "ਕੀ ਤੱਟਵਰਤੀ ਐਕਸਪੋਜਰ ਦਾ ਮਤਲਬ ਹੈ ਕਿ ਧਾਤ ਹਮੇਸ਼ਾ ਸਹੀ ਚੋਣ ਹੁੰਦੀ ਹੈ?",
        answer:
          "ਨੰ. ਛੱਤ ਦੀ ਢਲਾਣ, ਅਸੈਂਬਲੀ ਡਿਜ਼ਾਈਨ, ਉਤਪਾਦ ਅਨੁਕੂਲਤਾ, ਵੇਰਵੇ ਅਤੇ ਘਰ ਦੇ ਮਾਲਕ ਦੀਆਂ ਤਰਜੀਹਾਂ ਸਭ ਮਾਇਨੇ ਰੱਖਦੀਆਂ ਹਨ। ਇਕੱਲੇ ਸਥਾਨ ਤੋਂ ਕੋਈ ਸਮੱਗਰੀ ਨਹੀਂ ਚੁਣੀ ਜਾਂਦੀ ਹੈ।",
      },
    ],
  },
  "north-vancouver": {
    intro:
      "ਉੱਤਰੀ ਵੈਨਕੂਵਰ ਦੇ ਘਰ ਅਕਸਰ ਖੜ੍ਹੀ, ਗਿੱਲੀ ਅਤੇ ਭਾਰੀ ਬਨਸਪਤੀ ਸੈਟਿੰਗਾਂ ਦੇ ਅੰਦਰ ਬੈਠਦੇ ਹਨ। ਛੱਤਾਂ ਦੇ ਕੰਮ ਦੇ ਘੇਰੇ ਵਿੱਚ ਆਉਣ ਤੋਂ ਪਹਿਲਾਂ ਸੁਰੱਖਿਅਤ ਪਹੁੰਚ, ਨਿਕਾਸੀ ਪੁਆਇੰਟਾਂ ਦੇ ਆਲੇ ਦੁਆਲੇ ਕੇਂਦਰਿਤ ਪਾਣੀ ਅਤੇ ਮਲਬਾ ਵਿਹਾਰਕ ਵਿਚਾਰ ਹਨ।",
    localContext:
      "ਹਾਲਾਤ ਪਹਾੜਾਂ ਦੇ ਨੇੜੇ ਹੇਠਲੇ ਆਂਢ-ਗੁਆਂਢ ਅਤੇ ਸੰਪਤੀਆਂ ਵਿਚਕਾਰ ਬਦਲ ਸਕਦੇ ਹਨ। ਮੁਲਾਂਕਣ ਇੱਕ ਆਮ ਉੱਤਰੀ ਕਿਨਾਰੇ ਨਿਰਧਾਰਨ 'ਤੇ ਭਰੋਸਾ ਕਰਨ ਦੀ ਬਜਾਏ ਸਾਈਟ-ਵਿਸ਼ੇਸ਼ ਐਕਸਪੋਜ਼ਰ ਅਤੇ ਛੱਤ ਦੀ ਪਹੁੰਚ ਨੂੰ ਰਿਕਾਰਡ ਕਰਦਾ ਹੈ।",
    assessmentFocus: [
      "ਖੜ੍ਹੀ ਜਾਂ ਉੱਚੀ ਛੱਤ ਵਾਲੇ ਭਾਗਾਂ ਤੱਕ ਸੁਰੱਖਿਅਤ ਪਹੁੰਚ",
      "ਛੱਤ ਦੇ ਪੱਧਰਾਂ ਵਿਚਕਾਰ ਉੱਚ-ਆਵਾਜ਼ ਵਾਲੇ ਡਰੇਨੇਜ ਮਾਰਗ",
      "ਛਾਂਦਾਰ ਛੱਤ ਵਾਲੇ ਖੇਤਰਾਂ ਦੇ ਆਲੇ ਦੁਆਲੇ ਮਲਬਾ ਅਤੇ ਨਮੀ ਦੀ ਧਾਰਨਾ",
    ],
    propertyContexts: ["ਖੜ੍ਹੀਆਂ ਸਾਈਟਾਂ", "ਸਪਲਿਟ-ਪੱਧਰ ਦੇ ਘਰ", "ਜੰਗਲੀ ਰਿਹਾਇਸ਼ੀ ਸੰਪਤੀਆਂ"],
    faqs: [
      {
        question: "ਕੀ ਇੱਕ ਛਾਂਦਾਰ ਛੱਤ ਨੂੰ ਇੱਕ ਵੱਖਰੀ ਰੱਖ-ਰਖਾਅ ਯੋਜਨਾ ਦੀ ਲੋੜ ਹੈ?",
        answer:
          "ਹੋ ਸਕਦਾ ਹੈ. ਸੁੱਕਣ ਦੀਆਂ ਸਥਿਤੀਆਂ ਅਤੇ ਮਲਬੇ ਦਾ ਇਕੱਠਾ ਹੋਣਾ ਸਥਿਤੀ ਅਤੇ ਰੁੱਖ ਦੇ ਢੱਕਣ ਦੁਆਰਾ ਵੱਖੋ-ਵੱਖ ਹੁੰਦਾ ਹੈ, ਇਸ ਲਈ ਰੱਖ-ਰਖਾਅ ਮਾਰਗਦਰਸ਼ਨ ਛੱਤ ਵਾਲੇ ਖੇਤਰਾਂ 'ਤੇ ਅਧਾਰਤ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ।",
      },
      {
        question: "ਇੱਕ ਖੜ੍ਹੀ ਸਾਈਟ ਪ੍ਰੋਜੈਕਟ ਨੂੰ ਕਿਵੇਂ ਪ੍ਰਭਾਵਿਤ ਕਰਦੀ ਹੈ?",
        answer:
          "ਇਹ ਪਹੁੰਚ, ਸੁਰੱਖਿਆ ਅਤੇ ਕੰਮ ਦੀ ਲੜੀ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਕਰ ਸਕਦਾ ਹੈ। ਉਹਨਾਂ ਰੁਕਾਵਟਾਂ ਨੂੰ ਕੰਮ ਦੇ ਦੌਰਾਨ ਇੱਕ ਹੈਰਾਨੀ ਦੇ ਰੂਪ ਵਿੱਚ ਵਰਤਣ ਦੀ ਬਜਾਏ ਸਕੋਪ ਨੂੰ ਅੰਤਿਮ ਰੂਪ ਦੇਣ ਤੋਂ ਪਹਿਲਾਂ ਦਸਤਾਵੇਜ਼ੀ ਰੂਪ ਵਿੱਚ ਦਰਜ ਕੀਤਾ ਜਾਂਦਾ ਹੈ.",
      },
    ],
  },
  "west-vancouver": {
    intro:
      "ਵੈਸਟ ਵੈਨਕੂਵਰ ਦੀਆਂ ਰਿਹਾਇਸ਼ਾਂ ਅਕਸਰ ਗੁੰਝਲਦਾਰ ਮਾਸਿੰਗ, ਚੌੜੀ ਗਲੇਜ਼ਿੰਗ, ਛੱਤਾਂ ਅਤੇ ਖੜ੍ਹੀਆਂ ਅਤੇ ਘੱਟ-ਢਲਾਣ ਵਾਲੀਆਂ ਛੱਤਾਂ ਦੇ ਮਿਸ਼ਰਣ ਦੀ ਵਰਤੋਂ ਕਰਦੀਆਂ ਹਨ। ਛੱਤ ਦਾ ਸਫਲ ਕੰਮ ਆਰਕੀਟੈਕਚਰ ਦੀ ਨਜ਼ਰ ਨੂੰ ਗੁਆਏ ਬਿਨਾਂ ਤਬਦੀਲੀਆਂ ਨੂੰ ਹੱਲ ਕਰਨ 'ਤੇ ਨਿਰਭਰ ਕਰਦਾ ਹੈ।",
    localContext:
      "ਸਮੁੰਦਰ ਦਾ ਸਾਹਮਣਾ ਕਰਨਾ, ਪਹਾੜੀ ਅਤੇ ਜੰਗਲੀ ਸੰਪਤੀਆਂ ਇੱਕੋ ਨਗਰਪਾਲਿਕਾ ਦੇ ਨਕਸ਼ੇ 'ਤੇ ਵੱਖ-ਵੱਖ ਐਕਸਪੋਜ਼ਰ ਦਾ ਅਨੁਭਵ ਕਰ ਸਕਦੀਆਂ ਹਨ। ਰੀਵੋਲਿਨ ਸਿਸਟਮ ਦੀ ਸਿਫ਼ਾਰਸ਼ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਵਿਅਕਤੀਗਤ ਛੱਤ ਦੀ ਜਿਓਮੈਟਰੀ, ਪਹੁੰਚ ਅਤੇ ਪਾਣੀ ਦੇ ਮਾਰਗਾਂ ਦਾ ਮੁਲਾਂਕਣ ਕਰਦਾ ਹੈ।",
    assessmentFocus: [
      "ਆਰਕੀਟੈਕਚਰਲ ਧਾਤ, ਝਿੱਲੀ ਅਤੇ ਢਲਾਣ ਵਾਲੇ ਛੱਤ ਵਾਲੇ ਖੇਤਰਾਂ ਵਿਚਕਾਰ ਕਨੈਕਸ਼ਨ",
      "ਪੈਰਾਪੈਟ, ਛੱਤ ਦੇ ਡੇਕ, ਕੰਧ ਇੰਟਰਫੇਸ ਅਤੇ ਛੁਪਿਆ ਡਰੇਨੇਜ",
      "ਮੁਕੰਮਲ ਬਾਹਰੀ ਥਾਂਵਾਂ ਦੇ ਆਲੇ-ਦੁਆਲੇ ਪਹੁੰਚ ਅਤੇ ਸੁਰੱਖਿਆ ਦੀ ਯੋਜਨਾਬੰਦੀ",
    ],
    propertyContexts: [
      "ਆਰਕੀਟੈਕਟ ਦੁਆਰਾ ਡਿਜ਼ਾਈਨ ਕੀਤੇ ਘਰ",
      "ਪਹਾੜੀ ਨਿਵਾਸ ਸਥਾਨ",
      "ਮਿਸ਼ਰਤ-ਸਮੱਗਰੀ ਛੱਤ ਅਸੈਂਬਲੀਆਂ",
    ],
    faqs: [
      {
        question: "ਕੀ ਛੱਤ ਬਦਲਣ ਨਾਲ ਘਰ ਦੇ ਆਰਕੀਟੈਕਚਰਲ ਚਰਿੱਤਰ ਨੂੰ ਸੁਰੱਖਿਅਤ ਰੱਖਿਆ ਜਾ ਸਕਦਾ ਹੈ?",
        answer:
          "ਇਹ ਸਿਫਾਰਸ਼ ਦਾ ਹਿੱਸਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ. ਪ੍ਰੋਫਾਈਲ, ਰੰਗ, ਕਿਨਾਰੇ ਦੇ ਵੇਰਵਿਆਂ ਅਤੇ ਦਿਖਣਯੋਗ ਪਰਿਵਰਤਨ ਦਾ ਮੁਲਾਂਕਣ ਤਕਨੀਕੀ ਅਨੁਕੂਲਤਾ ਦੇ ਨਾਲ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ।",
      },
      {
        question: "ਮਿਸ਼ਰਤ ਛੱਤ ਪ੍ਰਣਾਲੀਆਂ ਦਾ ਮੁਲਾਂਕਣ ਇਕੱਠੇ ਕਿਉਂ ਕੀਤਾ ਜਾਂਦਾ ਹੈ?",
        answer:
          "ਪਾਣੀ ਛੱਤ ਵਾਲੇ ਖੇਤਰਾਂ ਦੇ ਵਿਚਕਾਰ ਸੀਮਾਵਾਂ ਨੂੰ ਪਾਰ ਕਰਦਾ ਹੈ. ਇੱਕ ਵੇਰਵਿਆਂ ਜੋ ਇੱਕ ਸਤਹ ਲਈ ਸਹੀ ਹੈ ਨੂੰ ਅਜੇ ਵੀ ਅਗਲੀ ਅਸੈਂਬਲੀ ਨਾਲ ਭਰੋਸੇਯੋਗ ਢੰਗ ਨਾਲ ਜੁੜਨਾ ਹੋਵੇਗਾ।",
      },
    ],
  },
  "new-westminster": {
    intro:
      "ਨਿਊ ਵੈਸਟਮਿੰਸਟਰ ਵਿੱਚ ਪੁਰਾਣੇ ਘਰ, ਮੁਰੰਮਤ ਕੀਤੇ ਘਰ ਅਤੇ ਸੰਖੇਪ ਰਿਹਾਇਸ਼ੀ ਲਾਟ ਸ਼ਾਮਲ ਹਨ ਜਿੱਥੇ ਛੱਤਾਂ ਦੇ ਕੰਮ ਦੀਆਂ ਕਈ ਪੀੜ੍ਹੀਆਂ ਮਿਲ ਸਕਦੀਆਂ ਹਨ। ਪਹਿਲਾ ਕੰਮ ਮੌਜੂਦਾ ਅਸੈਂਬਲੀ ਨੂੰ ਸਮਝਣਾ ਹੈ ਅਤੇ ਬਾਅਦ ਵਿੱਚ ਤਬਦੀਲੀਆਂ ਇਸ ਨਾਲ ਕਿੱਥੇ ਜੁੜਦੀਆਂ ਹਨ।",
    localContext:
      "ਸਿਰਫ਼ ਉਮਰ ਹੀ ਛੱਤ ਦੀ ਸਥਿਤੀ ਨੂੰ ਨਿਰਧਾਰਤ ਨਹੀਂ ਕਰਦੀ। ਰੀਵੋਲਿਨ ਢੱਕਣ, ਫਲੈਸ਼ਿੰਗ, ਟ੍ਰਾਂਜਿਸ਼ਨ ਅਤੇ ਡਰੇਨੇਜ ਪੁਆਇੰਟਾਂ 'ਤੇ ਸਬੂਤ ਲੱਭਦਾ ਹੈ, ਫਿਰ ਮੁਰੰਮਤ ਯੋਗ ਵੇਰਵਿਆਂ ਨੂੰ ਵਿਆਪਕ ਸਿਸਟਮ ਚਿੰਤਾਵਾਂ ਤੋਂ ਵੱਖਰਾ ਕਰਦਾ ਹੈ।",
    assessmentFocus: [
      "ਪਿਛਲੀ ਮੁਰੰਮਤ ਜਾਂ ਤਬਦੀਲੀ ਦੀਆਂ ਪਰਤਾਂ ਛੱਤ ਦੀ ਸਤ੍ਹਾ 'ਤੇ ਦਿਖਾਈ ਦਿੰਦੀਆਂ ਹਨ",
      "ਜੋੜਾਂ, ਦਲਾਨਾਂ ਅਤੇ ਨੱਥੀ ਬਣਤਰਾਂ 'ਤੇ ਤਬਦੀਲੀਆਂ",
      "ਸੰਖੇਪ ਲਾਟ 'ਤੇ ਸਮੱਗਰੀ ਦੀ ਪਹੁੰਚ ਅਤੇ ਗੁਆਂਢੀ ਸੁਰੱਖਿਆ",
    ],
    propertyContexts: ["ਪੁਰਾਣੇ ਅਲੱਗ ਘਰ", "ਮੁਰੰਮਤ ਕੀਤੇ ਘਰ", "ਸੰਖੇਪ ਰਿਹਾਇਸ਼ੀ ਸਾਈਟਾਂ"],
    faqs: [
      {
        question: "ਕੀ ਇੱਕ ਪੁਰਾਣੇ ਘਰ ਨੂੰ ਹਮੇਸ਼ਾ ਪੂਰੀ ਛੱਤ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ?",
        answer:
          "ਨਹੀਂ। ਦਿਸਣ ਵਾਲੀ ਸਥਿਤੀ ਅਤੇ ਅਸੈਂਬਲੀ ਦੀ ਕਾਰਗੁਜ਼ਾਰੀ ਘਰ ਦੀ ਉਮਰ ਨਾਲੋਂ ਜ਼ਿਆਦਾ ਮਾਇਨੇ ਰੱਖਦੀ ਹੈ। ਉਸ ਫੈਸਲੇ ਤੋਂ ਪਹਿਲਾਂ ਇੱਕ ਦਸਤਾਵੇਜ਼ੀ ਮੁਲਾਂਕਣ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ।",
      },
      {
        question: "ਜੇ ਛੱਤ ਦੇ ਪਿਛਲੇ ਕਈ ਪੈਚ ਹਨ ਤਾਂ ਕੀ ਹੋਵੇਗਾ?",
        answer:
          "ਪਿਛਲੇ ਕੰਮ ਨੂੰ ਨਿਦਾਨ ਦੇ ਹਿੱਸੇ ਵਜੋਂ ਦਸਤਾਵੇਜ਼ੀ ਰੂਪ ਵਿੱਚ ਦਰਜ ਕੀਤਾ ਗਿਆ ਹੈ। ਇੱਕ ਖੇਤਰ ਵਿੱਚ ਵਾਰ-ਵਾਰ ਮੁਰੰਮਤ ਇੱਕ ਅਣਸੁਲਝੇ ਪਰਿਵਰਤਨ ਵੱਲ ਇਸ਼ਾਰਾ ਕਰ ਸਕਦੀ ਹੈ, ਜਦੋਂ ਕਿ ਗੈਰ-ਸੰਬੰਧਿਤ ਪੈਚਾਂ ਦੇ ਵੱਖ-ਵੱਖ ਕਾਰਨ ਹੋ ਸਕਦੇ ਹਨ।",
      },
    ],
  },
  "port-coquitlam": {
    intro:
      "ਪੋਰਟ ਕੋਕੁਇਟਲਮ ਘਰਾਂ ਵਿੱਚ ਅਕਸਰ ਗੈਰਾਜ, ਜੋੜਾਂ ਜਾਂ ਢੱਕੇ ਹੋਏ ਬਾਹਰੀ ਖੇਤਰਾਂ ਨੂੰ ਸਮੇਂ ਦੇ ਨਾਲ ਜੋੜ ਕੇ ਸਿੱਧੀਆਂ ਢਲਾਣ ਵਾਲੀਆਂ ਛੱਤਾਂ ਨੂੰ ਜੋੜਿਆ ਜਾਂਦਾ ਹੈ। ਉਹ ਸੈਕੰਡਰੀ ਛੱਤ ਵਾਲੇ ਖੇਤਰ ਬਦਲ ਸਕਦੇ ਹਨ ਕਿ ਪਾਣੀ ਵਾਦੀਆਂ, ਕੰਧਾਂ ਅਤੇ ਗਟਰਾਂ ਤੱਕ ਕਿਵੇਂ ਪਹੁੰਚਦਾ ਹੈ।",
    localContext:
      "ਇੱਕ ਲੀਕ ਜੋ ਇੱਕ ਜੋੜ ਦੇ ਨੇੜੇ ਦਿਖਾਈ ਦਿੰਦਾ ਹੈ ਜ਼ਰੂਰੀ ਤੌਰ 'ਤੇ ਇਸਦੇ ਉੱਪਰ ਸਿੱਧਾ ਸ਼ੁਰੂ ਨਹੀਂ ਹੁੰਦਾ। ਮੁਲਾਂਕਣ ਇੱਕ ਮੁਰੰਮਤ ਖੇਤਰ ਨੂੰ ਪਰਿਭਾਸ਼ਿਤ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਛੱਤ ਦੇ ਜਹਾਜ਼ਾਂ ਅਤੇ ਤਬਦੀਲੀਆਂ ਦੀ ਪਾਲਣਾ ਕਰਦਾ ਹੈ।",
    assessmentFocus: [
      "ਮੁੱਖ ਛੱਤ, ਗੈਰੇਜ ਅਤੇ ਬਾਅਦ ਵਿੱਚ ਜੋੜਾਂ ਵਿਚਕਾਰ ਟਾਈ-ਇਨ",
      "ਉਪਰਲੀ ਛੱਤ ਦੀਆਂ ਸਤ੍ਹਾਂਾਂ ਤੋਂ ਪਾਣੀ ਪ੍ਰਾਪਤ ਕਰਨ ਵਾਲੇ ਹੇਠਲੇ ਛੱਤ ਵਾਲੇ ਹਿੱਸੇ",
      "ਛੱਤ-ਤੋਂ-ਦੀਵਾਰ ਕਨੈਕਸ਼ਨਾਂ 'ਤੇ ਪ੍ਰਵੇਸ਼ ਅਤੇ ਫਲੈਸ਼ਿੰਗ",
    ],
    propertyContexts: ["ਜੁੜੇ ਗੈਰੇਜ ਵਾਲੇ ਘਰ", "ਵਿਸਤ੍ਰਿਤ ਨਿਰਲੇਪ ਘਰਾਂ", "ਬਹੁ-ਪੱਧਰੀ ਛੱਤ ਡਰੇਨੇਜ"],
    faqs: [
      {
        question: "ਲੀਕ ਆਪਣੇ ਸਰੋਤ ਤੋਂ ਦੂਰ ਕਿਉਂ ਦਿਖਾਈ ਦੇ ਸਕਦੀ ਹੈ?",
        answer:
          "ਪਾਣੀ ਸ਼ੀਥਿੰਗ, ਫ੍ਰੇਮਿੰਗ ਜਾਂ ਛੱਤ ਦੇ ਪਰਿਵਰਤਨ ਦੇ ਨਾਲ ਦਿਖਾਈ ਦੇਣ ਤੋਂ ਪਹਿਲਾਂ ਯਾਤਰਾ ਕਰ ਸਕਦਾ ਹੈ। ਨਿਦਾਨ ਸਰੋਤ ਵਜੋਂ ਅੰਦਰੂਨੀ ਧੱਬੇ ਦਾ ਇਲਾਜ ਕਰਨ ਦੀ ਬਜਾਏ ਸੰਭਾਵਿਤ ਮਾਰਗ ਦਾ ਅਨੁਸਰਣ ਕਰਦਾ ਹੈ।",
      },
      {
        question: "ਕੀ ਗੈਰੇਜ ਅਤੇ ਦਲਾਨ ਦੀਆਂ ਛੱਤਾਂ ਮੁਲਾਂਕਣ ਦਾ ਹਿੱਸਾ ਹਨ?",
        answer:
          "ਉਹ ਹੋ ਸਕਦੇ ਹਨ, ਖਾਸ ਤੌਰ 'ਤੇ ਜਿੱਥੇ ਉਹ ਮੁੱਖ ਛੱਤ ਤੋਂ ਡਰੇਨੇਜ ਨਾਲ ਜੁੜਦੇ ਹਨ ਜਾਂ ਪ੍ਰਾਪਤ ਕਰਦੇ ਹਨ। ਬੇਨਤੀ ਕੀਤੇ ਮੁਲਾਂਕਣ ਦਾਇਰੇ ਨੂੰ ਸਮੀਖਿਆ ਕੀਤੇ ਜਾਣ ਵਾਲੇ ਖੇਤਰਾਂ ਦੀ ਪਛਾਣ ਕਰਨੀ ਚਾਹੀਦੀ ਹੈ।",
      },
    ],
  },
  "port-moody": {
    intro:
      "ਪੋਰਟ ਮੂਡੀਜ਼ ਇਨਲੇਟ-ਫੇਸਿੰਗ ਅਤੇ ਜੰਗਲੀ ਰਿਹਾਇਸ਼ੀ ਸੈਟਿੰਗਾਂ ਇੱਕੋ ਛੱਤ ਦੇ ਵੱਖ-ਵੱਖ ਪਾਸਿਆਂ 'ਤੇ ਨਮੀ, ਮਲਬੇ ਅਤੇ ਬਦਲਦੇ ਐਕਸਪੋਜ਼ਰ ਨੂੰ ਰੱਖ ਸਕਦੀਆਂ ਹਨ। ਨਿਰੀਖਣ ਨੋਟਾਂ ਨੂੰ ਛੱਤ ਦੇ ਜਹਾਜ਼ ਦੁਆਰਾ ਉਹਨਾਂ ਸਥਿਤੀਆਂ ਨੂੰ ਵੱਖਰਾ ਕਰਨਾ ਚਾਹੀਦਾ ਹੈ।",
    localContext:
      "ਛੱਤ ਦੀ ਸਥਿਤੀ, ਨਜ਼ਦੀਕੀ ਬਨਸਪਤੀ ਅਤੇ ਇਮਾਰਤ ਦੀ ਉਚਾਈ ਸਮੱਗਰੀ ਦੇ ਨਾਮ ਜਿੰਨਾ ਮਾਇਨੇ ਰੱਖ ਸਕਦੀ ਹੈ। ਰੀਵੋਲਿਨ ਰੱਖ-ਰਖਾਅ, ਮੁਰੰਮਤ ਜਾਂ ਬਦਲਣ ਦੇ ਵਿਕਲਪਾਂ 'ਤੇ ਚਰਚਾ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਉਹਨਾਂ ਵੇਰੀਏਬਲਾਂ ਨੂੰ ਦਸਤਾਵੇਜ਼ ਦਿੰਦਾ ਹੈ।",
    assessmentFocus: [
      "ਕਿਨਾਰਿਆਂ, ਕੰਧਾਂ ਅਤੇ ਪ੍ਰਵੇਸ਼ 'ਤੇ ਹਵਾ ਨਾਲ ਚੱਲਣ ਵਾਲੀ ਬਾਰਿਸ਼",
      "ਘਾਟੀਆਂ ਅਤੇ ਡਰੇਨੇਜ ਪੁਆਇੰਟਾਂ ਵਿੱਚ ਮਲਬਾ ਇਕੱਠਾ ਕਰਨਾ",
      "ਛਾਂਦਾਰ ਅਤੇ ਖੁੱਲ੍ਹੇ ਛੱਤ ਦੀਆਂ ਸਤ੍ਹਾਂਾਂ ਵਿੱਚ ਵੱਖ ਵੱਖ ਮੌਸਮ ਦੇ ਪੈਟਰਨ",
    ],
    propertyContexts: ["ਇਨਲੇਟ-ਫੇਸਿੰਗ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ", "ਜੰਗਲੀ ਲਾਟ", "ਮਲਟੀ-ਪਲੇਨ ਅਲੱਗ ਘਰ"],
    faqs: [
      {
        question: "ਕੀ ਇੱਕ ਛੱਤ ਦੇ ਵੱਖੋ-ਵੱਖਰੇ ਪਾਸੇ ਵੱਖ-ਵੱਖ ਹੋ ਸਕਦੇ ਹਨ?",
        answer:
          "ਹਾਂ। ਸੂਰਜ, ਛਾਂ, ਹਵਾ ਅਤੇ ਮਲਬੇ ਦਾ ਐਕਸਪੋਜਰ ਸਥਿਤੀ ਅਨੁਸਾਰ ਵੱਖ-ਵੱਖ ਹੁੰਦਾ ਹੈ। ਸਥਿਤੀ ਦੀ ਰਿਪੋਰਟ ਵਿੱਚ ਸਾਰੀ ਛੱਤ ਨੂੰ ਇੱਕ ਸ਼ਰਤ ਨਿਰਧਾਰਤ ਕਰਨ ਦੀ ਬਜਾਏ ਛੱਤ ਦੇ ਹਰੇਕ ਖੇਤਰ ਦਾ ਵਰਣਨ ਕਰਨਾ ਚਾਹੀਦਾ ਹੈ।",
      },
      {
        question: "ਕੀ ਸਤ੍ਹਾ ਦਾ ਮਲਬਾ ਸਬੂਤ ਹੈ ਕਿ ਛੱਤ ਫੇਲ੍ਹ ਹੋ ਰਹੀ ਹੈ?",
        answer:
          "ਨਹੀਂ। ਇਹ ਇੱਕ ਰੱਖ-ਰਖਾਅ ਅਤੇ ਡਰੇਨੇਜ ਨਿਰੀਖਣ ਹੈ, ਆਪਣੇ ਆਪ ਵਿੱਚ ਇੱਕ ਬਦਲੀ ਨਿਦਾਨ ਨਹੀਂ ਹੈ। ਅੰਡਰਲਾਈੰਗ ਕਵਰ ਅਤੇ ਵੇਰਵਿਆਂ ਦਾ ਅਜੇ ਵੀ ਮੁਲਾਂਕਣ ਕਰਨ ਦੀ ਲੋੜ ਹੈ।",
      },
    ],
  },
  "maple-ridge": {
    intro:
      "ਮੈਪਲ ਰਿਜ ਵਿੱਚ ਵੱਡੀਆਂ ਰਿਹਾਇਸ਼ੀ ਸੰਪਤੀਆਂ, ਜੰਗਲੀ ਇਲਾਕੇ ਅਤੇ ਤਲਹੱਟੀ ਸਾਈਟਾਂ ਸ਼ਾਮਲ ਹਨ ਜਿੱਥੇ ਐਕਸਪੋਜਰ ਅਤੇ ਪਹੁੰਚ ਕਾਫ਼ੀ ਵੱਖਰੀ ਹੋ ਸਕਦੀ ਹੈ। ਛੱਤ ਅਤੇ ਇਸਦੇ ਆਲੇ ਦੁਆਲੇ ਦੀਆਂ ਸਥਿਤੀਆਂ ਦੀ ਇੱਕ ਪ੍ਰੋਜੈਕਟ ਯੋਜਨਾ ਦੇ ਹਿੱਸੇ ਵਜੋਂ ਸਮੀਖਿਆ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
    localContext:
      "ਉੱਚੀਆਂ ਜਾਂ ਵਧੇਰੇ ਐਕਸਪੋਜ਼ਡ ਸਾਈਟਾਂ ਅਜਿਹੀਆਂ ਸਥਿਤੀਆਂ ਦਾ ਅਨੁਭਵ ਕਰ ਸਕਦੀਆਂ ਹਨ ਜੋ ਹੇਠਲੇ ਆਂਢ-ਗੁਆਂਢ ਦੇ ਪ੍ਰਤੀਨਿਧ ਨਹੀਂ ਹਨ। ਸਿਸਟਮ ਦੀ ਚੋਣ ਅਤੇ ਵੇਰਵੇ ਇਸ ਲਈ ਖੇਤਰੀ ਧਾਰਨਾ ਦੀ ਬਜਾਏ ਜਾਇਦਾਦ ਨਾਲ ਜੁੜੇ ਹੋਏ ਹਨ।",
    assessmentFocus: [
      "ਵੱਡੀਆਂ ਜਾਂ ਢਲਾਣ ਵਾਲੀਆਂ ਸਾਈਟਾਂ 'ਤੇ ਪਹੁੰਚ, ਸਟੇਜਿੰਗ ਅਤੇ ਸੁਰੱਖਿਆ",
      "ਪਰਿਪੱਕ ਬਨਸਪਤੀ ਦੇ ਨੇੜੇ ਡਰੇਨੇਜ ਅਤੇ ਮਲਬੇ ਦਾ ਪ੍ਰਬੰਧਨ",
      "ਕਿਨਾਰਿਆਂ, ਛਾਲਿਆਂ ਅਤੇ ਛੱਤਾਂ ਦੇ ਕਿਨਾਰਿਆਂ 'ਤੇ ਐਕਸਪੋਜਰ",
    ],
    propertyContexts: ["ਵੱਡੇ ਰਿਹਾਇਸ਼ੀ ਲਾਟ", "ਪੈਦਲ ਇਲਾਕੇ", "ਜੰਗਲੀ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ"],
    faqs: [
      {
        question: "ਕੀ ਇੱਕ ਵੱਡੀ ਜਾਇਦਾਦ ਛੱਤ ਦੀ ਸਿਫ਼ਾਰਿਸ਼ ਨੂੰ ਬਦਲਦੀ ਹੈ?",
        answer:
          "ਆਪਣੇ ਆਪ ਨਹੀਂ। ਇਹ ਪਹੁੰਚ ਅਤੇ ਪ੍ਰੋਜੈਕਟ ਲੌਜਿਸਟਿਕਸ ਨੂੰ ਬਦਲ ਸਕਦਾ ਹੈ, ਜਦੋਂ ਕਿ ਛੱਤ ਪ੍ਰਣਾਲੀ ਦੀ ਸਿਫਾਰਸ਼ ਅਜੇ ਵੀ ਢਲਾਨ, ਅਸੈਂਬਲੀ, ਐਕਸਪੋਜਰ ਅਤੇ ਸਥਿਤੀ 'ਤੇ ਨਿਰਭਰ ਕਰਦੀ ਹੈ।",
      },
      {
        question: "ਛੱਤ ਦੇ ਹੋਰ ਕਿਨਾਰਿਆਂ ਦੀ ਸਮੀਖਿਆ ਕਿਵੇਂ ਕੀਤੀ ਜਾਂਦੀ ਹੈ?",
        answer:
          "ਮੁਲਾਂਕਣ ਦਸਤਾਵੇਜ਼ ਦਿਸਣ ਵਾਲੇ ਕਿਨਾਰੇ ਦੀ ਸਥਿਤੀ, ਫਾਸਟਨਿੰਗ-ਸਬੰਧਤ ਚਿੰਤਾਵਾਂ ਅਤੇ ਪਰਿਵਰਤਨ ਵੇਰਵਿਆਂ ਨੂੰ ਦਰਸਾਉਂਦੇ ਹਨ, ਫਿਰ ਚੁਣੇ ਗਏ ਸਿਸਟਮ ਅਤੇ ਲਾਗੂ ਲੋੜਾਂ ਨਾਲ ਕਿਸੇ ਵੀ ਸਿਫ਼ਾਰਸ਼ ਨਾਲ ਸਬੰਧਤ ਹਨ।",
      },
    ],
  },
  delta: {
    intro:
      "ਡੈਲਟਾ ਦੇ ਭਾਈਚਾਰਿਆਂ ਵਿੱਚ ਤੱਟਵਰਤੀ, ਖੇਤੀਬਾੜੀ-ਕਿਨਾਰੇ ਅਤੇ ਅੰਦਰੂਨੀ ਰਿਹਾਇਸ਼ੀ ਸੈਟਿੰਗਾਂ ਸ਼ਾਮਲ ਹਨ। ਉਹ ਵੱਖ-ਵੱਖ ਐਕਸਪੋਜ਼ਰ ਇੱਕ ਹੱਲ ਚੁਣਨ ਤੋਂ ਪਹਿਲਾਂ ਵਿਅਕਤੀਗਤ ਸਾਈਟ ਦੀ ਹਵਾ, ਡਰੇਨੇਜ ਅਤੇ ਛੱਤ ਦੀ ਜਿਓਮੈਟਰੀ ਦਾ ਮੁਲਾਂਕਣ ਕਰਨਾ ਮਹੱਤਵਪੂਰਨ ਬਣਾਉਂਦੇ ਹਨ।",
    localContext:
      "ਇੱਕ Tsawwassen, Ladner ਜਾਂ North Delta ਪ੍ਰਾਪਰਟੀ ਨੂੰ ਸਿਰਫ਼ ਨਗਰਪਾਲਿਕਾ ਦੇ ਨਾਮ ਦੇ ਆਧਾਰ 'ਤੇ ਸਿਫ਼ਾਰਿਸ਼ ਪ੍ਰਾਪਤ ਨਹੀਂ ਹੋਣੀ ਚਾਹੀਦੀ। ਰੈਵੋਲਿਨ ਪਤੇ 'ਤੇ ਦੇਖੀਆਂ ਗਈਆਂ ਇਮਾਰਤਾਂ ਅਤੇ ਸਥਿਤੀਆਂ 'ਤੇ ਦਾਇਰੇ ਨੂੰ ਆਧਾਰਿਤ ਕਰਦਾ ਹੈ।",
    assessmentFocus: [
      "ਈਵਜ਼, ਰਿਜਜ਼ ਅਤੇ ਘੇਰੇ ਦੇ ਵੇਰਵਿਆਂ 'ਤੇ ਹਵਾ ਦਾ ਐਕਸਪੋਜਰ",
      "ਵਿਆਪਕ ਛੱਤ ਦੀਆਂ ਸਤ੍ਹਾਂਾਂ ਤੋਂ ਡਰੇਨੇਜ ਸਮਰੱਥਾ ਅਤੇ ਡਿਸਚਾਰਜ",
      "ਵੱਖੋ-ਵੱਖਰੇ ਤੌਰ 'ਤੇ ਪ੍ਰਗਟ ਕੀਤੀਆਂ ਉਚਾਈਆਂ ਦੇ ਪਾਰ ਪਦਾਰਥਕ ਸਥਿਤੀ",
    ],
    propertyContexts: ["ਤੱਟਵਰਤੀ ਇਲਾਕੇ", "ਰਿਹਾਇਸ਼ੀ ਸਾਈਟਾਂ ਖੋਲ੍ਹੋ", "ਅੰਦਰੂਨੀ ਨਿਰਲੇਪ ਘਰ"],
    faqs: [
      {
        question: "ਕੀ ਸਾਰੇ ਡੈਲਟਾ ਵਿੱਚ ਇੱਕੋ ਛੱਤ ਪ੍ਰਣਾਲੀ ਢੁਕਵੀਂ ਹੈ?",
        answer:
          "ਇੱਥੇ ਕੋਈ ਆਟੋਮੈਟਿਕ ਸ਼ਹਿਰ-ਵਿਆਪੀ ਵਿਕਲਪ ਨਹੀਂ ਹੈ। ਢਲਾਨ, ਐਕਸਪੋਜਰ, ਆਰਕੀਟੈਕਚਰ, ਡਰੇਨੇਜ ਅਤੇ ਬਜਟ ਸਾਰੇ ਢੁਕਵੇਂ ਸਿਸਟਮ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਕਰਦੇ ਹਨ।",
      },
      {
        question: "ਤੇਜ਼ ਹਵਾ ਤੋਂ ਬਾਅਦ ਕੀ ਜਾਂਚਿਆ ਜਾਂਦਾ ਹੈ?",
        answer:
          "ਇੱਕ ਨਿਸ਼ਾਨਾ ਮੁਲਾਂਕਣ ਦ੍ਰਿਸ਼ਟੀਗਤ ਤਬਦੀਲੀ ਲਈ ਪਹੁੰਚਯੋਗ ਛੱਤ ਦੇ ਕਿਨਾਰਿਆਂ, ਢੱਕਣ, ਫਲੈਸ਼ਿੰਗਾਂ ਅਤੇ ਪ੍ਰਵੇਸ਼ ਦੀ ਸਮੀਖਿਆ ਕਰ ਸਕਦਾ ਹੈ। ਸੁਰੱਖਿਆ ਪਹਿਲਾਂ ਆਉਂਦੀ ਹੈ; ਘਰ ਦੇ ਮਾਲਕਾਂ ਨੂੰ ਗਿੱਲੀ ਜਾਂ ਖਰਾਬ ਹੋਈ ਛੱਤ 'ਤੇ ਨਹੀਂ ਚੜ੍ਹਨਾ ਚਾਹੀਦਾ।",
      },
    ],
  },
  langley: {
    intro:
      "ਲੈਂਗਲੇ ਸੰਪਤੀਆਂ ਵਿੱਚ ਵੱਡੇ ਅਲੱਗ ਘਰ, ਚੌੜੀਆਂ ਛੱਤਾਂ ਅਤੇ ਮਲਟੀਪਲ ਜੁੜੇ ਢਾਂਚੇ ਸ਼ਾਮਲ ਹੋ ਸਕਦੇ ਹਨ। ਇੱਕ ਸਪਸ਼ਟ ਸਕੋਪ ਹਰੇਕ ਛੱਤ ਦੇ ਖੇਤਰ ਨੂੰ ਵੱਖਰਾ ਕਰਦਾ ਹੈ ਜਦੋਂ ਇਹ ਹੱਲ ਕੀਤਾ ਜਾਂਦਾ ਹੈ ਕਿ ਉਹ ਕਿਵੇਂ ਨਿਕਾਸ ਅਤੇ ਕਨੈਕਟ ਕਰਦੇ ਹਨ।",
    localContext:
      "ਖੁੱਲ੍ਹੀਆਂ ਸਾਈਟਾਂ ਅਤੇ ਸਥਾਪਿਤ ਰੁੱਖਾਂ ਵਾਲੇ ਆਂਢ-ਗੁਆਂਢ ਵੱਖ-ਵੱਖ ਰੱਖ-ਰਖਾਅ ਅਤੇ ਐਕਸਪੋਜ਼ਰ ਦੇ ਵਿਚਾਰ ਪੇਸ਼ ਕਰਦੇ ਹਨ। ਰੇਵੋਲਿਨ ਸਮੱਗਰੀ ਜਾਂ ਮੁਰੰਮਤ ਸੀਮਾਵਾਂ ਦੀ ਸਿਫ਼ਾਰਸ਼ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਸਾਈਟ ਦੀਆਂ ਅਸਲ ਸਥਿਤੀਆਂ ਨੂੰ ਰਿਕਾਰਡ ਕਰਦਾ ਹੈ।",
    assessmentFocus: [
      "ਚੌੜੀ ਛੱਤ ਦੀਆਂ ਸਤ੍ਹਾਂ ਅਤੇ ਲੰਬੇ ਡਰੇਨੇਜ ਚੱਲਦੇ ਹਨ",
      "ਘਰ, ਗੈਰੇਜ ਅਤੇ ਕਵਰ ਕੀਤੇ ਬਾਹਰੀ ਖੇਤਰਾਂ ਦੇ ਵਿਚਕਾਰ ਕਨੈਕਸ਼ਨ",
      "ਖੁੱਲ੍ਹੇ ਐਕਸਪੋਜ਼ਰ ਅਤੇ ਰੁੱਖ-ਆਸਰਾ ਵਾਲੇ ਭਾਗਾਂ ਵਿੱਚ ਅੰਤਰ",
    ],
    propertyContexts: ["ਵੱਡੇ ਅਲੱਗ ਘਰ", "ਜੁੜੇ ਢਾਂਚੇ ਵਾਲੇ ਘਰ", "ਰਿਹਾਇਸ਼ੀ ਸਾਈਟਾਂ ਖੋਲ੍ਹੋ"],
    faqs: [
      {
        question: "ਕੀ ਇੱਕ ਪ੍ਰੋਜੈਕਟ ਨੂੰ ਛੱਤ ਦੇ ਖੇਤਰ ਦੁਆਰਾ ਪੜਾਅਵਾਰ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ?",
        answer:
          "ਕਈ ਵਾਰ, ਪਰ ਸਿਰਫ ਤਾਂ ਹੀ ਜੇਕਰ ਅਸੈਂਬਲੀਆਂ ਅਤੇ ਪਰਿਵਰਤਨ ਇੱਕ ਟਿਕਾਊ ਸਟਾਪਿੰਗ ਪੁਆਇੰਟ ਦੀ ਆਗਿਆ ਦਿੰਦੇ ਹਨ। ਦਾਇਰੇ ਨੂੰ ਇਹ ਦੱਸਣਾ ਚਾਹੀਦਾ ਹੈ ਕਿ ਪੜਾਅਵਾਰ ਕੰਮ ਜੁੜੇ ਖੇਤਰਾਂ ਨੂੰ ਕਿਵੇਂ ਪ੍ਰਭਾਵਿਤ ਕਰਦਾ ਹੈ।",
      },
      {
        question: "ਕੀ ਇੱਕ ਚੌੜੀ ਛੱਤ ਦੀਆਂ ਸਤ੍ਹਾਂ ਨੂੰ ਇੱਕ ਖਾਸ ਸਮੱਗਰੀ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ?",
        answer:
          "ਨੰ. ਜਿਓਮੈਟਰੀ ਇੱਕ ਇਨਪੁਟ ਹੈ। ਢਲਾਨ, ਅਸੈਂਬਲੀ ਡਿਜ਼ਾਈਨ, ਐਕਸਪੋਜ਼ਰ, ਦਿੱਖ, ਰੱਖ-ਰਖਾਅ ਦੀਆਂ ਤਰਜੀਹਾਂ ਅਤੇ ਬਜਟ ਨੂੰ ਇਕੱਠੇ ਵਿਚਾਰਿਆ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।",
      },
    ],
  },
  "white-rock": {
    intro:
      "ਵ੍ਹਾਈਟ ਰੌਕ ਹੋਮ ਸਮਕਾਲੀ ਛੱਤ ਦੇ ਰੂਪਾਂ, ਬਾਲਕੋਨੀਆਂ ਅਤੇ ਘੱਟ-ਢਲਾਨ ਵਾਲੇ ਭਾਗਾਂ ਦੇ ਨਾਲ ਸਮੁੰਦਰ ਦਾ ਸਾਹਮਣਾ ਕਰ ਰਹੇ ਐਕਸਪੋਜਰ ਨੂੰ ਜੋੜ ਸਕਦੇ ਹਨ। ਕਿਨਾਰਿਆਂ, ਕੰਧ ਦੇ ਪਰਿਵਰਤਨ ਅਤੇ ਡਰੇਨੇਜ ਵੇਰਵਿਆਂ ਦੀ ਉਸ ਆਰਕੀਟੈਕਚਰ ਦੇ ਸੰਦਰਭ ਵਿੱਚ ਸਮੀਖਿਆ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
    localContext:
      "ਤੱਟਵਰਤੀ ਸਥਿਤੀਆਂ ਇੱਕ ਛੱਤ ਦੇ ਉਤਪਾਦ ਨੂੰ ਸਰਵ ਵਿਆਪਕ ਤੌਰ 'ਤੇ ਸਹੀ ਨਹੀਂ ਬਣਾਉਂਦੀਆਂ ਹਨ। ਉਤਪਾਦ ਦੀ ਅਨੁਕੂਲਤਾ, ਸਿਸਟਮ ਡਿਜ਼ਾਈਨ ਅਤੇ ਦ੍ਰਿਸ਼ਮਾਨ ਵੇਰਵੇ ਨੂੰ ਢਲਾਨ ਅਤੇ ਘਰ ਦੇ ਮਾਲਕ ਦੀਆਂ ਤਰਜੀਹਾਂ ਦੇ ਨਾਲ-ਨਾਲ ਵਿਚਾਰਿਆ ਜਾਂਦਾ ਹੈ।",
    assessmentFocus: [
      "ਪੈਰਾਮੀਟਰ ਅਤੇ ਪਰਿਵਰਤਨ ਵੇਰਵੇ ਸੰਚਾਲਿਤ ਮੀਂਹ ਦੇ ਸੰਪਰਕ ਵਿੱਚ ਹਨ",
      "ਪੈਰਾਪੈਟਸ, ਕਰਬਜ਼ ਅਤੇ ਨਾਲ ਲੱਗਦੀਆਂ ਕੰਧਾਂ ਦੇ ਆਲੇ-ਦੁਆਲੇ ਘੱਟ ਢਲਾਨ ਵਾਲਾ ਡਰੇਨੇਜ",
      "ਚੁਣੀ ਗਈ ਅਸੈਂਬਲੀ ਦੇ ਨਾਲ ਦਿਖਾਈ ਦੇਣ ਵਾਲੀ ਧਾਤ ਦੇ ਵੇਰਵਿਆਂ ਦੀ ਅਨੁਕੂਲਤਾ",
    ],
    propertyContexts: [
      "ਸਮੁੰਦਰ ਦਾ ਸਾਹਮਣਾ ਕਰਨ ਵਾਲੇ ਘਰ",
      "ਸਮਕਾਲੀ ਨਿਵਾਸ",
      "ਮਿਸ਼ਰਤ-ਢਲਾਨ ਛੱਤ ਦੇ ਡਿਜ਼ਾਈਨ",
    ],
    faqs: [
      {
        question: "ਕੀ ਸਮੁੰਦਰੀ ਐਕਸਪੋਜਰ ਆਪਣੇ ਆਪ ਛੱਤ ਵਾਲੀ ਸਮੱਗਰੀ ਨੂੰ ਰੱਦ ਕਰਦਾ ਹੈ?",
        answer:
          "ਆਪਣੇ ਆਪ ਨਹੀਂ। ਸੰਪੱਤੀ ਲਈ ਸੰਪੂਰਨ ਪ੍ਰਣਾਲੀ, ਉਤਪਾਦ ਦੀਆਂ ਸੀਮਾਵਾਂ, ਕੋਟਿੰਗ ਜਾਂ ਫਿਨਿਸ਼, ਫਾਸਟਨਿੰਗ ਅਤੇ ਪਰਿਵਰਤਨ ਵੇਰਵਿਆਂ ਦੀ ਸਮੀਖਿਆ ਕਰਨ ਦੀ ਲੋੜ ਹੈ।",
      },
      {
        question: "ਬਾਲਕੋਨੀ ਅਤੇ ਪੈਰਾਪੇਟ ਕਨੈਕਸ਼ਨ ਮਹੱਤਵਪੂਰਨ ਕਿਉਂ ਹਨ?",
        answer:
          "ਉਹ ਸਧਾਰਨ ਪਾਣੀ ਦੇ ਵਹਾਅ ਨੂੰ ਰੋਕ ਸਕਦੇ ਹਨ ਅਤੇ ਕੰਧ, ਕਰਬ ਜਾਂ ਝਿੱਲੀ ਦੇ ਪਰਿਵਰਤਨ ਨੂੰ ਪੇਸ਼ ਕਰ ਸਕਦੇ ਹਨ। ਉਹਨਾਂ ਇੰਟਰਫੇਸਾਂ ਨੂੰ ਦਸਤਾਵੇਜ਼ੀ ਮੁਲਾਂਕਣ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤਾ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ।",
      },
    ],
  },
} as const satisfies Record<ServiceAreaSlug, ServiceAreaContentTranslation>;

export const ui = {
  common: {
    home: "ਘਰ",
    services: "ਸੇਵਾਵਾਂ",
    serviceAreas: "ਸੇਵਾ ਖੇਤਰ",
    contact: "ਸੰਪਰਕ ਕਰੋ",
    faq: "FAQ",
    learnMore: "ਜਿਆਦਾ ਜਾਣੋ",
    requestAssessment: "ਛੱਤ ਦੇ ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ",
    exploreServices: "ਛੱਤ ਸੇਵਾਵਾਂ ਦੀ ਪੜਚੋਲ ਕਰੋ",
    viewContactOptions: "ਸਾਰੇ ਸੰਪਰਕ ਵਿਕਲਪ ਵੇਖੋ",
  },
  serviceDetail: {
    breadcrumbLabel: "ਬਰੈੱਡਕ੍ਰੰਬ",
    call: "ਕਾਲ ਕਰੋ",
    whoForEyebrow: "ਇਹ ਕਿਸ ਲਈ ਹੈ",
    whoForTitle: "ਸਥਿਤੀ ਨਾਲ ਸ਼ੁਰੂ ਕਰੋ, ਉਤਪਾਦ ਨਹੀਂ",
    warningSignsTitle: "ਆਮ ਚੇਤਾਵਨੀ ਚਿੰਨ੍ਹ",
    assessmentEyebrow: "ਮੁਲਾਂਕਣ ਅਨੁਸ਼ਾਸਨ",
    evaluatesTitle: "ਰੇਵੋਲਿਨ ਕੀ ਮੁਲਾਂਕਣ ਕਰਦਾ ਹੈ",
    solutionsEyebrow: "ਹੱਲ ਸ਼੍ਰੇਣੀਆਂ",
    solutionsTitle: "ਵਿਕਲਪ ਛੱਤ ਦੀ ਪਾਲਣਾ ਕਰਦੇ ਹਨ, ਸਕ੍ਰਿਪਟ ਨਹੀਂ",
    repairEyebrow: "ਜਦੋਂ ਮੁਰੰਮਤ ਦਾ ਕੋਈ ਮਤਲਬ ਹੋ ਸਕਦਾ ਹੈ",
    replaceEyebrow: "ਜਦੋਂ ਬਦਲੀ ਦਾ ਮਤਲਬ ਹੋ ਸਕਦਾ ਹੈ",
    scopeEyebrow: "ਸਕੋਪ",
    scopeTitle: "ਕੀ ਕੰਮ ਨੂੰ ਪ੍ਰਭਾਵਿਤ ਕਰਦਾ ਹੈ",
    scopeBody:
      "ਅਸਲ ਦਾਇਰਾ ਮੁਲਾਂਕਣ ਤੋਂ ਬਾਅਦ ਸਥਾਪਿਤ ਕੀਤਾ ਜਾਂਦਾ ਹੈ। ਰੀਵੋਲਿਨ ਰੂਫਿੰਗ ਇੱਕ-ਅਕਾਰ-ਫਿੱਟ-ਸਾਰੀ ਕੀਮਤ, ਉਮਰ ਜਾਂ ਅਸੈਂਬਲੀ ਪ੍ਰਕਾਸ਼ਿਤ ਨਹੀਂ ਕਰਦੀ ਹੈ ਕਿਉਂਕਿ ਇਹ ਇਮਾਰਤ ਅਤੇ ਚੁਣੇ ਗਏ ਸਿਸਟਮ 'ਤੇ ਨਿਰਭਰ ਕਰਦੇ ਹਨ।",
    questionsEyebrow: "ਸਵਾਲ",
    questionsTitle: "ਇਸ ਤੋਂ ਪਹਿਲਾਂ ਕਿ ਤੁਸੀਂ ਫੈਸਲਾ ਕਰੋ",
    nextStepEyebrow: "ਅਗਲਾ ਕਦਮ",
    nextStepTitle: "ਆਪਣੀ ਛੱਤ ਦੇ ਸਪਸ਼ਟ ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ",
    nextStepBody:
      "ਸਾਨੂੰ ਦੱਸੋ ਕਿ ਤੁਸੀਂ ਕੀ ਦੇਖ ਰਹੇ ਹੋ ਅਤੇ ਜਾਇਦਾਦ ਕਿੱਥੇ ਹੈ। ਅਸੀਂ ਉਸ ਸੰਦਰਭ ਦੀ ਵਰਤੋਂ ਸਹੀ ਅਗਲੀ ਗੱਲਬਾਤ ਦੀ ਯੋਜਨਾ ਬਣਾਉਣ ਲਈ ਕਰਾਂਗੇ।",
  },
  servicesIndex: {
    eyebrow: "ਛੱਤ ਸੇਵਾਵਾਂ",
    title: "ਸਹੀ ਦਾਇਰਾ ਸਹੀ ਨਿਦਾਨ ਨਾਲ ਸ਼ੁਰੂ ਹੁੰਦਾ ਹੈ",
    body: "ਰੀਵੋਲਿਨ ਰੂਫਿੰਗ ਦੀਆਂ ਮੁੱਖ ਸੇਵਾ ਸ਼੍ਰੇਣੀਆਂ ਦੀ ਪੜਚੋਲ ਕਰੋ। ਹਰ ਇੱਕ ਦੀ ਸ਼ੁਰੂਆਤ ਇਮਾਰਤ, ਛੱਤ ਦੀ ਅਸੈਂਬਲੀ ਅਤੇ ਉਹਨਾਂ ਸਥਿਤੀਆਂ ਨਾਲ ਹੁੰਦੀ ਹੈ ਜੋ ਅਸੀਂ ਦੇਖ ਸਕਦੇ ਹਾਂ - ਇੱਕ ਪੂਰਵ-ਨਿਰਧਾਰਤ ਉਤਪਾਦ ਸਿਫ਼ਾਰਿਸ਼ ਨਹੀਂ।",
    exploreService: "ਸੇਵਾ ਦੀ ਪੜਚੋਲ ਕਰੋ",
    technicalEyebrow: "ਤਕਨੀਕੀ ਸੰਦਰਭ",
    technicalTitle: "ਮੌਜੂਦਾ ਬੀਸੀ ਸਰੋਤ ਮਾਇਨੇ ਰੱਖਦੇ ਹਨ",
    rcabcTitle: "RCABC ਰੂਫਿੰਗ ਪ੍ਰੈਕਟਿਸ ਮੈਨੂਅਲ",
    rcabcBody:
      "ਵਰਤਮਾਨ ਛੱਤ-ਅਭਿਆਸ ਸੰਦਰਭ; ਲਿੰਕ ਦਾ ਮਤਲਬ ਰੀਵੋਲਿਨ ਮੈਂਬਰਸ਼ਿਪ ਜਾਂ ਰੂਫਸਟਾਰ ਦੀ ਗਰੰਟੀ ਨਹੀਂ ਹੈ।",
    bcCodesTitle: "ਬੀ ਸੀ ਕੋਡ",
    bcCodesBody: "ਅਧਿਕਾਰ ਖੇਤਰ ਅਤੇ ਪ੍ਰੋਜੈਕਟ ਦਾਇਰੇ ਲਈ ਸੂਬਾਈ ਕੋਡ, ਸੰਸ਼ੋਧਨ ਅਤੇ ਬੁਲੇਟਿਨ।",
    vancouverBylawTitle: "ਵੈਨਕੂਵਰ ਬਿਲਡਿੰਗ ਉਪ-ਕਾਨੂੰਨ",
    vancouverBylawBody:
      "ਵੈਨਕੂਵਰ-ਵਿਸ਼ੇਸ਼ ਲੋੜਾਂ ਦੀ ਪ੍ਰੋਵਿੰਸ਼ੀਅਲ ਕੋਡ ਤੋਂ ਵੱਖਰੇ ਤੌਰ 'ਤੇ ਜਾਂਚ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
  },
  areaIndex: {
    breadcrumbLabel: "ਬਰੈੱਡਕ੍ਰੰਬ",
    eyebrow: "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਅਤੇ ਲੋਅਰ ਮੇਨਲੈਂਡ",
    title: "ਛੱਤ ਸੇਵਾ ਖੇਤਰ",
    body: "ਰੇਵੋਲਿਨ ਰੂਫਿੰਗ ਹੇਠਾਂ ਦਿੱਤੇ ਭਾਈਚਾਰਿਆਂ ਵਿੱਚ ਰਿਹਾਇਸ਼ੀ ਛੱਤਾਂ ਦਾ ਮੁਲਾਂਕਣ ਕਰਦੀ ਹੈ। ਹਰੇਕ ਪ੍ਰੋਜੈਕਟ ਦੀ ਯੋਜਨਾ ਜਾਇਦਾਦ ਦੀ ਛੱਤ ਦੇ ਰੂਪ, ਐਕਸਪੋਜਰ, ਪਹੁੰਚ ਅਤੇ ਲਾਗੂ ਸਥਾਨਕ ਲੋੜਾਂ ਲਈ ਕੀਤੀ ਗਈ ਹੈ।",
    coverageEyebrow: "ਕਵਰੇਜ, ਬ੍ਰਾਂਚ ਆਫਿਸ ਨਹੀਂ",
    coverageTitle: "ਜਾਅਲੀ ਟਿਕਾਣਿਆਂ ਤੋਂ ਬਿਨਾਂ ਸਥਾਨਕ ਸੰਦਰਭ",
    coverageBody:
      "ਇਹ ਪੰਨੇ ਦੱਸਦੇ ਹਨ ਕਿ ਛੱਤ ਦੇ ਮੁਲਾਂਕਣ ਕਿੱਥੇ ਉਪਲਬਧ ਹੋ ਸਕਦੇ ਹਨ। ਉਹ ਇਹ ਦਾਅਵਾ ਨਹੀਂ ਕਰਦੇ ਹਨ ਕਿ ਰੇਵੋਲਿਨ ਰੂਫਿੰਗ ਹਰ ਸੂਚੀਬੱਧ ਸ਼ਹਿਰ ਵਿੱਚ ਇੱਕ ਦਫਤਰ ਦਾ ਪ੍ਰਬੰਧਨ ਕਰਦੀ ਹੈ। ਸੰਪਤੀ ਦੇ ਪਤੇ ਨਾਲ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ ਤਾਂ ਜੋ ਪ੍ਰੋਜੈਕਟ ਲਈ ਕਵਰੇਜ ਦੀ ਪੁਸ਼ਟੀ ਕੀਤੀ ਜਾ ਸਕੇ।",
    nearbyEyebrow: "ਨੇੜਲੇ ਭਾਈਚਾਰੇ?",
    nearbyTitle: "ਸਾਨੂੰ ਪ੍ਰੋਜੈਕਟ ਕਵਰੇਜ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਲਈ ਕਹੋ।",
    contactCta: "ਰਿਵੋਲਿਨ ਰੂਫਿੰਗ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
  },
  serviceArea: {
    breadcrumbLabel: "ਬਰੈੱਡਕ੍ਰੰਬ",
    metroVancouver: "ਮੈਟਰੋ ਵੈਨਕੂਵਰ",
    lowerMainland: "ਲੋਅਰ ਮੇਨਲੈਂਡ",
    roofingServicesSuffix: "ਛੱਤ ਸੇਵਾਵਾਂ",
    titlePrefix: "ਵਿੱਚ ਛੱਤ ਸੇਵਾਵਾਂ",
    confirmedCommunity:
      "{area} ਇੱਕ ਪੁਸ਼ਟੀ ਕੀਤੀ ਸੇਵਾ ਭਾਈਚਾਰਾ ਹੈ। ਇਹ ਇੱਕ ਸੇਵਾ-ਖੇਤਰ ਪੰਨਾ ਹੈ, ਨਾ ਕਿ ਸਥਾਨਕ ਸ਼ਾਖਾ ਦਫ਼ਤਰ ਦਾ ਦਾਅਵਾ।",
    localContextEyebrow: "ਸਥਾਨਕ ਛੱਤ ਦਾ ਸੰਦਰਭ",
    localContextTitle: "ਸੰਪਤੀ ਸਿਫਾਰਸ਼ ਦਾ ਫੈਸਲਾ ਕਰਦੀ ਹੈ",
    propertyContextsLabel: "ਸੰਪੱਤੀ ਦੇ ਸੰਦਰਭ ਅਸੀਂ ਆਲੇ ਦੁਆਲੇ ਦੀ ਯੋਜਨਾ ਬਣਾਉਂਦੇ ਹਾਂ",
    prioritiesEyebrow: "ਮੁਲਾਂਕਣ ਦੀਆਂ ਤਰਜੀਹਾਂ",
    prioritiesTitle: "{area} ਵਿੱਚ ਕਿਹੜੀਆਂ ਗੱਲਾਂ ਵੱਲ ਖ਼ਾਸ ਧਿਆਨ ਦੇਣਾ ਚਾਹੀਦਾ ਹੈ",
    planningDisclaimer:
      "ਇਹ ਸਾਧਾਰਨ ਯੋਜਨਾਬੰਦੀ ਜਾਣਕਾਰੀ ਹੈ, ਰਿਮੋਟ ਨਿਦਾਨ ਜਾਂ ਇੰਜੀਨੀਅਰਿੰਗ ਰਾਏ ਨਹੀਂ। ਖਾਸ ਸੰਪਤੀ ਲਈ ਲੱਭਤਾਂ ਅਤੇ ਲਾਗੂ ਲੋੜਾਂ ਦੀ ਪੁਸ਼ਟੀ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
    relatedEyebrow: "ਸਬੰਧਤ ਸੇਵਾਵਾਂ",
    relatedTitle: "{area} ਦੇ ਘਰਾਂ ਲਈ ਛੱਤ ਸੰਬੰਧੀ ਫ਼ੈਸਲੇ",
    relatedBody:
      "ਸਮੱਸਿਆ ਨਾਲ ਸ਼ੁਰੂ ਕਰੋ ਅਤੇ ਛੱਤ ਦੀ ਸਥਿਤੀ ਨੂੰ ਦੇਖਿਆ. ਸਹੀ ਅਗਲਾ ਕਦਮ ਇੱਕ ਖਾਸ ਥਾਂ ਦੀ ਮੁਰੰਮਤ, ਰੋਕਥਾਮ ਮੁਲਾਂਕਣ ਜਾਂ ਇੱਕ ਯੋਜਨਾਬੱਧ ਤਬਦੀਲੀ ਹੋ ਸਕਦਾ ਹੈ।",
    fallbackServiceName: "ਛੱਤ ਦੀ ਸੇਵਾ",
    faqSuffix: "FAQ",
    faqTitle: "ਮੁਲਾਂਕਣ ਤੋਂ ਪਹਿਲਾਂ ਸਵਾਲ",
    requestEyebrow: "ਮੁਲਾਂਕਣ ਲਈ ਬੇਨਤੀ ਕਰੋ",
    requestTitle: "ਸਾਡੇ ਸਾਹਮਣੇ ਛੱਤ ਨਾਲ ਸ਼ੁਰੂ ਕਰੋ.",
    requestBody:
      "ਸਾਨੂੰ {area} ਵਿੱਚ ਜਾਇਦਾਦ, ਛੱਤ ਦੇ ਖੇਤਰ ਅਤੇ ਜੋ ਕੁਝ ਤੁਸੀਂ ਦੇਖਿਆ ਹੈ ਉਸ ਬਾਰੇ ਦੱਸੋ। ਇਹ ਜਾਣਕਾਰੀ ਮੁਲਾਂਕਣ ਦੀ ਤਿਆਰੀ ਵਿੱਚ ਮਦਦ ਕਰਦੀ ਹੈ; ਇਹ ਸਾਈਟ ਉੱਤੇ ਜਾਂਚ ਦੀ ਥਾਂ ਨਹੀਂ ਲੈਂਦੀ।",
  },
  about: {
    eyebrow: "ਇੱਕ Revolin ਗਰੁੱਪ ਕੰਪਨੀ",
    title: "ਇੱਕ ਉਸਾਰੀ ਕੰਪਨੀ ਦੇ ਦ੍ਰਿਸ਼ਟੀਕੋਣ ਨਾਲ ਛੱਤ ਦੀ ਮੁਹਾਰਤ",
    body: "ਰੀਵੋਲਿਨ ਰੂਫਿੰਗ, ਰੇਵੋਲਿਨ ਗਰੁੱਪ ਦਾ ਵਿਸ਼ੇਸ਼ ਛੱਤ ਵਾਲਾ ਡਿਵੀਜ਼ਨ ਹੈ, ਜੋ ਮੂਲ ਬ੍ਰਾਂਡ ਦੇ ਆਰਕੀਟੈਕਚਰਲ ਸੰਜਮ, ਪਾਰਦਰਸ਼ੀ ਪ੍ਰਕਿਰਿਆ ਅਤੇ ਅਨੁਸ਼ਾਸਿਤ ਪ੍ਰੋਜੈਕਟ ਸੋਚ ਨੂੰ ਛੱਤ ਅਸੈਂਬਲੀ ਵਿੱਚ ਲਿਆਉਂਦਾ ਹੈ।",
    relationshipEyebrow: "ਰਿਸ਼ਤਾ",
    relationshipTitle: "ਛੱਤ ਬਣਾਉਣ ਵਿੱਚ ਵਿਸ਼ੇਸ਼. ਪੂਰੀ ਇਮਾਰਤ ਨਾਲ ਜੁੜਿਆ ਹੋਇਆ ਹੈ।",
    relationshipBody1:
      "ਛੱਤ ਇੱਕ ਅਲੱਗ ਸਤ੍ਹਾ ਨਹੀਂ ਹੈ। ਇਹ ਕੰਧਾਂ, ਕਲੈਡਿੰਗ, ਸਕਾਈਲਾਈਟਸ, ਹਵਾਦਾਰੀ, ਡਰੇਨੇਜ ਅਤੇ ਅੰਦਰੂਨੀ ਅਸੈਂਬਲੀਆਂ ਨੂੰ ਪੂਰਾ ਕਰਦਾ ਹੈ। ਰੇਵੋਲਿਨ ਰੂਫਿੰਗ ਉਹਨਾਂ ਇੰਟਰਫੇਸਾਂ ਤੱਕ ਪਹੁੰਚਦੀ ਹੈ ਜਿਸਦੇ ਦ੍ਰਿਸ਼ਟੀਕੋਣ ਵਿੱਚ ਵਿਸ਼ਾਲ ਨਿਰਮਾਣ ਸੰਦਰਭ ਹੈ।",
    relationshipBody2:
      "ਇਹ ਦ੍ਰਿਸ਼ਟੀਕੋਣ ਸਪਸ਼ਟ ਨਿਦਾਨ ਅਤੇ ਸਕੋਪ ਦਾ ਸਮਰਥਨ ਕਰਦਾ ਹੈ। ਇਹ ਢੁਕਵੇਂ ਇੰਜੀਨੀਅਰ, ਡਿਜ਼ਾਈਨਰ ਜਾਂ ਮਾਹਰ ਦੀ ਲੋੜ ਨੂੰ ਨਹੀਂ ਬਦਲਦਾ ਹੈ ਜਦੋਂ ਕੋਈ ਸਥਿਤੀ ਛੱਤ ਦੇ ਕੰਮ ਤੋਂ ਬਾਹਰ ਆਉਂਦੀ ਹੈ; ਇਹ ਉਹਨਾਂ ਸੀਮਾਵਾਂ ਨੂੰ ਪਹਿਲਾਂ ਪਛਾਣਨ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਹੈ।",
    principlesEyebrow: "ਕੰਮ ਕਰਨ ਦੇ ਸਿਧਾਂਤ",
    principlesTitle: "ਹਰੇਕ ਫੈਸਲੇ ਦੇ ਬਿੰਦੂ 'ਤੇ ਸਪੱਸ਼ਟਤਾ",
    assessTitle: "ਸਿਫਾਰਸ਼ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਮੁਲਾਂਕਣ ਕਰੋ",
    assessBody:
      "ਇੱਕ ਦਾਇਰੇ ਦੇ ਪ੍ਰਸਤਾਵਿਤ ਹੋਣ ਤੋਂ ਪਹਿਲਾਂ ਦਿਖਾਈ ਦੇਣ ਵਾਲੇ ਲੱਛਣ, ਸੰਭਾਵਿਤ ਸਰੋਤ ਅਤੇ ਵਿਆਪਕ ਅਸੈਂਬਲੀ ਸਥਿਤੀ 'ਤੇ ਵਿਚਾਰ ਕੀਤਾ ਜਾਂਦਾ ਹੈ।",
    architectureTitle: "ਆਰਕੀਟੈਕਚਰ ਦਾ ਆਦਰ ਕਰੋ",
    architectureBody:
      "ਸਮੱਗਰੀ, ਰੰਗ, ਪ੍ਰੋਫਾਈਲ, ਕਿਨਾਰੇ ਅਤੇ ਪਰਿਵਰਤਨ ਇਸ ਵਿੱਚ ਯੋਗਦਾਨ ਪਾਉਂਦੇ ਹਨ ਕਿ ਇਮਾਰਤ ਕਿਵੇਂ ਪੜ੍ਹਦੀ ਹੈ-ਨਾ ਸਿਰਫ ਪਾਣੀ ਕਿਵੇਂ ਵਹਿੰਦਾ ਹੈ।",
    limitsTitle: "ਸੀਮਾਵਾਂ ਦੱਸੋ",
    limitsBody:
      "ਧਾਰਨਾਵਾਂ, ਬੇਦਖਲੀ ਅਤੇ ਸ਼ਰਤਾਂ ਜਿਨ੍ਹਾਂ ਲਈ ਹੋਰ ਜਾਂਚ ਦੀ ਲੋੜ ਹੁੰਦੀ ਹੈ ਉਹ ਗੱਲਬਾਤ ਅਤੇ ਦਾਇਰੇ ਵਿੱਚ ਹਨ।",
    parentEyebrow: "ਮੂਲ ਕੰਪਨੀ",
    parentTitle: "ਰੇਵੋਲਿਨ ਗਰੁੱਪ ਦੀ ਪੜਚੋਲ ਕਰੋ",
    parentBody: "ਮੁਰੰਮਤ, ਨਿਰਮਾਣ ਅਤੇ ਵਿਸ਼ਾਲ ਇਮਾਰਤ ਦੇ ਕੰਮ ਲਈ, ਮੂਲ ਕੰਪਨੀ ਦੀ ਸਾਈਟ 'ਤੇ ਜਾਓ।",
    parentCta: "RevolinGroup.com 'ਤੇ ਜਾਓ",
  },
  beforeAfter: {
    eyebrow: "ਪਹਿਲਾਂ ਤੇ ਬਾਅਦ",
    title: "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਵਿੱਚ ਛੱਤ ਦੀਆਂ ਪਹਿਲਾਂ-ਬਾਅਦ ਗੈਲਰੀਆਂ",
    body: "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਅਤੇ ਲੋਅਰ ਮੇਨਲੈਂਡ ਘਰ-ਮਾਲਕਾਂ ਲਈ Revolin Roofing ਦੀਆਂ ਪਹਿਲਾਂ-ਬਾਅਦ ਗੈਲਰੀਆਂ ਵੇਖੋ - ਐਮਰਜੈਂਸੀ ਲੀਕ ਮੁਰੰਮਤ ਤੋਂ ਲੈ ਕੇ ਐਸਫਾਲਟ, ਮੈਟਲ, ਸੀਡਰ ਅਤੇ ਫਲੈਟ-ਰੂਫ ਬਦਲੀ ਤੱਕ, ਹਰ ਗੈਲਰੀ ਵਿੱਚ ਸਮੱਸਿਆ, ਨਿਦਾਨ ਅਤੇ ਮੁਕੰਮਲ ਛੱਤ ਦਾ ਸੰਦਰਭ ਹੈ।",
    notice:
      "ਸੇਵਾ, ਛੱਤ ਦੀ ਕਿਸਮ ਜਾਂ ਸ਼ਹਿਰ ਨਾਲ ਫਿਲਟਰ ਕਰੋ, ਆਪਣੇ ਘਰ ਦੇ ਨਜ਼ਦੀਕੀ ਬਦਲਾਅ ਲੱਭੋ, ਫਿਰ ਆਪਣੀ ਜਾਇਦਾਦ ਲਈ ਛੱਤ ਮੁਲਾਂਕਣ ਦੀ ਬੇਨਤੀ ਕਰੋ।",
    projectHeroBody:
      "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਵਿੱਚ Revolin Roofing ਦੀਆਂ ਪਹਿਲਾਂ-ਬਾਅਦ ਤਬਦੀਲੀਆਂ ਵੇਖੋ - ਐਮਰਜੈਂਸੀ ਲੀਕ ਮੁਰੰਮਤ ਤੋਂ ਲੈ ਕੇ ਐਸਫਾਲਟ, ਮੈਟਲ, ਸੀਡਰ ਅਤੇ ਫਲੈਟ-ਰੂਫ ਦੀ ਪੂਰੀ ਬਦਲੀ ਤੱਕ। ਹਰ ਗੈਲਰੀ ਲੋਅਰ ਮੇਨਲੈਂਡ ਘਰ-ਮਾਲਕਾਂ ਲਈ ਸਮੱਸਿਆ, ਨਿਦਾਨ ਅਤੇ ਮੁਕੰਮਲ ਛੱਤ ਦਾ ਨਤੀਜਾ ਉਜਾਗਰ ਕਰਦੀ ਹੈ।",
  },
  faqPage: {
    eyebrow: "ਘਰ ਦੇ ਮਾਲਕ ਦੀ ਅਗਵਾਈ",
    title: "ਛੱਤ ਵਾਲੇ ਸਵਾਲ, ਵਿਕਰੀ ਸਕ੍ਰਿਪਟ ਤੋਂ ਬਿਨਾਂ ਜਵਾਬ ਦਿੱਤੇ ਗਏ",
    body: "ਮੁਲਾਂਕਣ, ਮੁਰੰਮਤ, ਬਦਲਣ ਅਤੇ ਛੱਤ ਪ੍ਰਣਾਲੀਆਂ ਬਾਰੇ ਵਿਹਾਰਕ ਜਾਣਕਾਰੀ। ਪ੍ਰੋਜੈਕਟ-ਵਿਸ਼ੇਸ਼ ਸਲਾਹ ਇੱਕ ਆਨ-ਸਾਈਟ ਸਮੀਖਿਆ ਦੀ ਪਾਲਣਾ ਕਰਦੀ ਹੈ।",
  },
  contactPage: {
    eyebrow: "ਰਿਵੋਲਿਨ ਰੂਫਿੰਗ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    title: "ਸਾਨੂੰ ਦੱਸੋ ਕਿ ਤੁਸੀਂ ਕੀ ਦੇਖ ਰਹੇ ਹੋ",
    body: "ਜਾਇਦਾਦ ਦੀ ਸਥਿਤੀ, ਛੱਤ ਦੀ ਕਿਸਮ ਜੇ ਪਤਾ ਹੋਵੇ ਅਤੇ ਚਿੰਤਾ ਜਾਂ ਪ੍ਰੋਜੈਕਟ ਨੂੰ ਸਾਂਝਾ ਕਰੋ ਜਿਸ ਬਾਰੇ ਤੁਸੀਂ ਵਿਚਾਰ ਕਰ ਰਹੇ ਹੋ। ਫਾਰਮ ਸਿਰਫ਼ ਡਿਲੀਵਰੀ ਦੀ ਪੁਸ਼ਟੀ ਕਰੇਗਾ ਜਦੋਂ ਇੱਕ ਕੌਂਫਿਗਰ ਕੀਤੀ ਲੀਡ ਸੇਵਾ ਇਸਨੂੰ ਸਵੀਕਾਰ ਕਰਦੀ ਹੈ।",
    directEyebrow: "ਸਿੱਧਾ ਸੰਪਰਕ",
    directTitle: "ਮੂਲ ਗੱਲਾਂ ਨਾਲ ਸ਼ੁਰੂ ਕਰੋ",
    phone: "ਫ਼ੋਨ",
    email: "ਈਮੇਲ",
    serviceRegion: "ਸੇਵਾ ਖੇਤਰ",
    regionValue: "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਅਤੇ ਲੋਅਰ ਮੇਨਲੈਂਡ",
  },
  legal: {
    legal: "ਕਾਨੂੰਨੀ",
    privacyPolicy: "ਗੋਪਨੀਯਤਾ ਨੀਤੀ",
    websiteTerms: "ਵੈੱਬਸਾਈਟ ਦੀਆਂ ਸ਼ਰਤਾਂ",
    privacyBody:
      "ਵੈੱਬਸਾਈਟ ਪੁੱਛਗਿੱਛ, ਵਿਸ਼ੇਸ਼ਤਾ ਡੇਟਾ ਅਤੇ ਜ਼ਰੂਰੀ ਬ੍ਰਾਊਜ਼ਰ ਸਟੋਰੇਜ ਨੂੰ ਕਿਵੇਂ ਸੰਭਾਲਿਆ ਜਾਂਦਾ ਹੈ।",
    termsBody:
      "ਉਹ ਨਿਯਮ ਜੋ ਰੇਵੋਲਿਨ ਰੂਫਿੰਗ ਦੀ ਵੈੱਬਸਾਈਟ ਅਤੇ ਆਮ ਵਿਦਿਅਕ ਸਮੱਗਰੀ ਦੀ ਵਰਤੋਂ ਕਰਦੇ ਸਮੇਂ ਲਾਗੂ ਹੁੰਦੇ ਹਨ।",
    lastUpdated: "ਆਖਰੀ ਵਾਰ ਅੱਪਡੇਟ ਕੀਤਾ: 10 ਅਗਸਤ, 2026।",
  },
} as const;

export type ContentUi = typeof ui;

// Semantic aliases used by the locale-content registry.
export const serviceContent = services;
export const serviceAreaContent = serviceAreas;

const content = { services, serviceAreas, ui } as const;
export default content;
